const ns = Function("return this")();
function rs() {
  const e = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis, t = typeof window == "object" && window && window.Object === Object && window, n = typeof global == "object" && global && global.Object === Object && global, r = typeof self == "object" && self && self.Object === Object && self;
  return e || t || n || r || ns;
}
const T = rs(), Bn = "@YZ/";
function qn(e, t = Bn) {
  return e.startsWith(t);
}
function Wn(e, t = Bn) {
  return qn(e, t) ? e : `${t}${e}`;
}
function Ue(e) {
  return typeof e == "string" && e.startsWith("Symbol(") && e.endsWith(")");
}
function ze(e) {
  return Ue(e) && (e = e.slice(7, -1)), e;
}
function Hn(e) {
  return e = ze(e), e = Wn(e), typeof Symbol == "function" ? Symbol(e) : `Symbol(${e})`;
}
const ht = Hn("META");
function Ma(e, t) {
  const n = t.toString();
  if (!Ue(n))
    return !1;
  if (e && typeof e == "object") {
    if (!qn(ze(n)))
      return t in e;
    for (const r of Reflect.ownKeys(e))
      if (r.toString() == n)
        return !0;
    return !1;
  }
  return !1;
}
function hn(e) {
  if (!Ue(e))
    return e;
  switch (e = ze(e), e) {
    case Wn("META"):
      return ht;
    default:
      return Hn(e);
  }
}
function ve(e) {
  if (Array.isArray(e))
    return e.map(ve);
  if (e && typeof e == "object") {
    const t = {};
    for (const n of Reflect.ownKeys(e)) {
      const r = e[n];
      t[typeof n == "symbol" ? n.toString() : n] = typeof r == "symbol" ? r.toString() : ve(r);
    }
    return t;
  }
  return typeof e == "symbol" ? e.toString() : e;
}
function Re(e) {
  if (Array.isArray(e))
    return e.map(Re);
  if (e && typeof e == "object") {
    const t = {};
    for (const n of Object.keys(e))
      t[hn(n)] = Re(e[n]);
    return t;
  }
  return hn(e);
}
function ss(e) {
  return JSON.stringify(ve(e));
}
const je = ss;
function is(e) {
  return Re(JSON.parse(e));
}
const La = is;
class os {
}
function le(e) {
  e || (e = T), Object.prototype.hasOwnProperty.call(e, ht) === !1 && Object.defineProperty(e, ht, {
    value: new os()
  });
  const t = {
    set: (n, r) => e[ht][n] = r,
    get: (n, r) => {
      const s = e[ht][n];
      return s === void 0 && r !== void 0 ? (t.set(n, r), r) : s;
    },
    delete: (n) => {
      delete e[ht][n];
    }
  };
  return t;
}
var J = /* @__PURE__ */ ((e) => (e.UNKNOWN = "", e.TEXT = "text/plain", e.MD = "text/plain", e.HTML = "text/html", e.XML_TEXT = "text/xml", e.CSS = "text/css", e.JPEG = "image/jpeg", e.PNG = "image/png", e.GIF = "image/gif", e.BMP = "image/bmp", e.WEBP = "image/webp", e.SVG = "image/svg+xml", e.ICON = "image/x-icon", e.MICROSOFT_ICON = "image/vnd.microsoft.icon", e.MPEG = "audio/mpeg", e.MP3 = "audio/mpeg", e.MP4 = "video/mp4", e.OGG = "audio/ogg", e.WAV = "audio/wav", e.MIDI = "audio/midi", e.WEBM = "video/webm", e.VIDEO_OGG = "video/ogg", e.OCTET_STREAM = "application/octet-stream", e.JAVASCRIPT = "application/javascript", e.ECMASCRIPT = "application/ecmascript", e.JSON = "application/json", e.XML = "application/xml", e.XHTML = "application/xhtml+xml", e.XWWW = "application/x-www-form-urlencoded", e.DOC = "application/msword", e.CSV = "application/x-csv", e.EXCEL = "application/vnb.ms-excel", e.PPT = "application/vnb.mspowerpoint", e.PDF = "application/pdf", e.ZIP = "application/zip", e.TGZ = "application/x-gtar", e.TAR_GZ = "application/x-gzip", e.EOT = "appliaction/vnd.ms-fontobject", e.TTF = "aplication/font-sfnt", e.PKCS12 = "aplication/pkcs12", e))(J || {}), Zt = /* @__PURE__ */ ((e) => (e.ascii = "ascii", e.utf8 = "utf8", e.utf16le = "utf16le", e.ucs2 = "ucs2", e.base64 = "base64", e.base64url = "base64url", e.latin1 = "latin1", e.binary = "binary", e.hex = "hex", e))(Zt || {}), as = /* @__PURE__ */ ((e) => (e.text = "text", e.dataURL = "dataURL", e.binaryString = "binaryString", e.arraybuffer = "arraybuffer", e))(as || {}), cs = /* @__PURE__ */ ((e) => (e.md5 = "md5", e.sha1 = "sha1", e.sha256 = "sha256", e.SHA256 = "SHA-256", e.sha512 = "sha512", e.SHA512 = "SHA-512", e.AESGCM = "AES-GCM", e.ECDSA = "ECDSA", e))(cs || {}), us = /* @__PURE__ */ ((e) => (e.aes_128_cbc = "aes-128-cbc", e.aes_128_ecb = "aes-128-ecb", e.aes_192_cbc = "aes-192-cbc", e.ae_192_ecb = "aes-192-ecb", e.aes_256_cbc = "aes-256-cbc", e.aes_256_ecb = "aes-256-ecb", e.base64 = "base64", e))(us || {});
const Ia = [
  "jelly",
  "bounce",
  "flash",
  "pulse",
  "rubberBand",
  "shakeX",
  "shakeY",
  "headShake",
  "swing",
  "tada",
  "wobble",
  "jello",
  "heartBeat",
  "backInLeft",
  "backInRight",
  "backInUp",
  "backInDown",
  "backOutLeft",
  "backOutRight",
  "backOutUp",
  "backOutDown",
  "bounceIn",
  "bounceInLeft",
  "bounceInRight",
  "bounceInUp",
  "bounceInDown",
  "bounceOut",
  "bounceOutLeft",
  "bounceOutRight",
  "bounceOutUp",
  "bounceOutDown",
  "fadeIn",
  "fadeInLeft",
  "fadeInLeftBig",
  "fadeInRight",
  "fadeInRightBig",
  "fadeInUp",
  "fadeInUpBig",
  "fadeInDown",
  "fadeInDownBig",
  "fadeInTopLeft",
  "fadeInTopRight",
  "fadeInBottomLeft",
  "fadeInBottomRight",
  "fadeOut",
  "fadeOutLeft",
  "fadeOutLeftBig",
  "fadeOutRight",
  "fadeOutRightBig",
  "fadeOutUp",
  "fadeOutUpBig",
  "fadeOutDown",
  "fadeOutDownBig",
  "fadeOutTopLeft",
  "fadeOutTopRight",
  "fadeOutBottomRight",
  "fadeOutBottomLeft",
  "flip",
  "flipInX",
  "flipInY",
  "flipOutX",
  "flipOutY",
  "flipOutRight",
  "flipInLeft",
  "flipOutLeft",
  "flipInRight",
  "flipOutTop",
  "flipInBottom",
  "flipOutBottom",
  "flipInTop",
  "lightSpeedInLeft",
  "lightSpeedInRight",
  "lightSpeedOutLeft",
  "lightSpeedOutRight",
  "rotateIn",
  "rotateInUpLeft",
  "rotateInUpRight",
  "rotateInDownLeft",
  "rotateInDownRight",
  "rotateOut",
  "rotateOutUpLeft",
  "rotateOutUpRight",
  "rotateOutDownLeft",
  "rotateOutDownRight",
  "hinge",
  "rotateFall",
  "rotateOutNewspaper",
  "rotateInNewspaper",
  "jackInTheBox",
  "rollIn",
  "rollOut",
  "zoomIn",
  "zoomInLeft",
  "zoomInRight",
  "zoomInUp",
  "zoomInDown",
  "zoomOut",
  "zoomOutLeft",
  "zoomOutRight",
  "zoomOutUp",
  "zoomOutDown",
  "fade",
  "moveFromLeft",
  "moveToLeft",
  "moveFromRight",
  "moveToRight",
  "moveFromTop",
  "moveToTop",
  "moveFromBottom",
  "moveToBottom",
  "moveFromLeftFade",
  "moveToLeftFade",
  "moveFromRightFade",
  "moveToRightFade",
  "moveFromTopFade",
  "moveToTopFade",
  "moveFromBottomFade",
  "moveToBottomFade",
  "scaleFromSmall",
  "scaleToSmall",
  "scaleFromLarge",
  "scaleToLarge",
  "scaleFromSmallCenter",
  "scaleToSmallCenter",
  "slideInLeft",
  "slideInRight",
  "slideInUp",
  "slideInDown",
  "slideOutLeft",
  "slideOutRight",
  "slideOutUp",
  "slideOutDown",
  "rotateRightSideFirst",
  "rotateLeftSideFirst",
  "rotateTopSideFirst",
  "rotateBottomSideFirst",
  "rotatePushLeft",
  "rotatePushRight",
  "rotatePushTop",
  "rotatePushBottom",
  "rotatePullRight",
  "rotatePullLeft",
  "rotatePullTop",
  "rotatePullBottom",
  "rotateFoldRight",
  "rotateFoldLeft",
  "rotateFoldTop",
  "rotateFoldBottom",
  "rotateUnfoldLeft",
  "rotateUnfoldRight",
  "rotateUnfoldTop",
  "rotateUnfoldBottom",
  "rotateRoomLeftOut",
  "rotateRoomLeftIn",
  "rotateRoomRightOut",
  "rotateRoomRightIn",
  "rotateRoomTopOut",
  "rotateRoomTopIn",
  "rotateRoomBottomOut",
  "rotateRoomBottomIn",
  "rotateCubeLeftOut",
  "rotateCubeLeftIn",
  "rotateCubeRightOut",
  "rotateCubeRightIn",
  "rotateCubeTopOut",
  "rotateCubeTopIn",
  "rotateCubeBottomOut",
  "rotateCubeBottomIn",
  "rotateCarouselLeftOut",
  "rotateCarouselLeftIn",
  "rotateCarouselRightOut",
  "rotateCarouselRightIn",
  "rotateCarouselTopOut",
  "rotateCarouselTopIn",
  "rotateCarouselBottomOut",
  "rotateCarouselBottomIn",
  "rotateSidesOut",
  "rotateSidesIn",
  "rotateSlideOut",
  "rotateSlideIn",
  "superRainbow",
  "statusProcessing"
], ct = (e) => {
  let t = null;
  switch (e) {
    case "any-character":
      t = /[^]/;
      break;
    case "bin":
      t = /^(0b)?[0-1]+$/i;
      break;
    case "oct":
      t = /^(0o)?[0-7]+$/i;
      break;
    case "hex":
      t = /^(0x)?[0-9a-fA-F]+$/i;
      break;
    case "ascii":
      t = /^[\x00-\xFF]+$/i;
      break;
    case "int":
      t = /^[-+]?[0-9]+$/;
      break;
    case "number":
      t = /[-+]?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
      break;
    case "number-single":
      t = /[-+]?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/i;
      break;
    case "split":
      t = /\s*,\s*/gi;
      break;
    case "trim":
      t = /^\s+|\s+$/g;
      break;
    case "regexp":
      t = /[\\^$.*+?()[\]{}|]/g;
      break;
    case "regexp-flags":
      t = /\w*$/;
      break;
    case "native-method":
      t = RegExp(
        "^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(ct("regexp"), "\\$&").replace(
          /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
          "$1.*?"
        ) + "$"
      );
      break;
    case "svg-segment":
      t = /([mlhvzaqtcs])([^mlhvzaqtcs]*)/gi;
      break;
    case "mobile-china":
      t = /^[1]{1}[0-9]{10}$/;
      break;
    case "email":
      t = /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+\@[A-Za-z0-9._-]+\.[A-Za-z0-9]+$/gm;
      break;
    case "ip":
      t = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      break;
    case "url":
      t = /^http[s]?:\/\/([\w-]+\.)+[\w-]+([\w-./?%&=]*)?$/;
      break;
    case "element-url":
      t = /^url\(['"]?(.+?)['"]?\)$/i;
      break;
    case "date":
      t = /^\d{4}(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2})$/;
      break;
    case "time":
      t = /^(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
      break;
    case "datetime":
      t = /^\d{4}(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2})\s+(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
      break;
    case "base64-data":
      t = /^\s*data:(?:[a-z]+\/[a-z0-9-+.]+(?:;[a-z-]+=[a-z0-9-]+)?)?(?:;base64)?,([a-z0-9!$&',()*+;=\-._~:@/?%\s]*?)\s*$/i;
      break;
    case "hex-color":
      t = /^#([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
      break;
    case "color":
      t = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i;
      break;
    case "whitespace":
      t = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]/g;
      break;
    case "commaSpaces":
      t = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/;
      break;
    case "var-name":
      t = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/;
      break;
    case "bezier":
      t = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/;
      break;
    case "chinese-name":
      t = /^(?:[\u4e00-\u9fa5·]{2,16})$/;
      break;
    case "chinese":
      t = new RegExp(
        String.raw`
          [\u{FA0E}\u{FA0F}\u{FA11}\u{FA13}\u{FA14}\u{FA1F}\u{FA21}\u{FA23}\u{FA24}\u{FA27}-\u{FA29}]
          |[\u{4E00}-\u{9FCC}]
          |[\u{3400}-\u{4DB5}]
          |[\u{20000}-\u{2A6D6}]
          |[\u{2A700}-\u{2B734}]
          |[\u{2B740}-\u{2B81D}]
          |[\u{2B820}-\u{2CEAF}]
          |[\u{2CEB0}-\u{2EBEF}]
        `.replace(/\s+/g, ""),
        "u"
      );
      break;
    case "mime-image":
      t = /^image\//;
      break;
    case "mime-video":
      t = /^video\//;
      break;
    case "mime-audio":
      t = /^audio\//;
      break;
    case "mime-document-word":
      t = /^application\/(?:vnd\.openxmlformats-officedocument\.wordprocessingml\.document|msword|vnd\.ms-word\.document\.macroenabled\.12|vnd\.openxmlformats-officedocument\.wordprocessingml\.template|vnd\.ms-word\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-excel":
      t = /^application\/(?:vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|vnd\.ms-excel|vnd\.ms-excel\.sheet\.macroenabled\.12|vnd\.openxmlformats-officedocument\.spreadsheetml\.template|vnd\.ms-excel\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-ppt":
      t = /^application\/(?:vnd\.ms-powerpoint|vnd\.openxmlformats-officedocument\.presentationml\.presentation|vnd\.ms-powerpoint\.presentation\.macroenabled\.12|vnd\.openxmlformats-officedocument\.presentationml\.template|vnd\.ms-powerpoint\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-json":
      t = /^application\/json$/;
      break;
    case "mime-document-xml":
      t = /^(?:application|text)\/(?:xml|xhtml\+xml)$/;
      break;
  }
  return t;
};
function ls(e) {
  if (e.flags)
    return e.flags;
  const t = [];
  return e.global && t.push("g"), e.ignoreCase && t.push("i"), e.multiline && t.push("m"), e.sticky && t.push("y"), e.unicode && t.push("u"), t.join("");
}
function hs(e) {
  const t = new RegExp(e.source, ls(e));
  return t.lastIndex = e.lastIndex, t;
}
const Rt = (e, t) => (typeof e == "string" && (e = ct(e) || new RegExp(e)), e.test(t)), $a = (e, t) => (typeof e == "string" && (e = ct(e) || new RegExp(e)), t.search(e)), Na = (e, t) => (typeof e == "string" && (e = ct(e) || new RegExp(e)), t.split(e)), Be = (e, t) => {
  typeof e == "string" && (e = ct(e) || new RegExp(e));
  const n = t.match(e);
  return n ? e.flags.toLowerCase().indexOf("g") >= 0 ? n.map(
    (r) => ({
      matchIndex: -1,
      fullMatch: r,
      groupMatchs: []
    })
  ) : {
    matchIndex: typeof n.index == "number" ? n.index : -1,
    fullMatch: n[0],
    groupMatchs: n.slice(1)
  } : null;
}, Ua = (e, t) => {
  typeof e == "string" && (e = ct(e) || new RegExp(e));
  const n = [], r = t.matchAll(e);
  for (const s of r)
    n.push({
      matchIndex: typeof s.index == "number" ? s.index : -1,
      fullMatch: s[0],
      groupMatchs: s.slice(1)
    });
  return n;
}, za = (e, t) => {
  if (typeof e == "string" && (e = ct(e) || new RegExp(e)), e.flags.toLowerCase().indexOf("g") < 0)
    return Be(e, t);
  const n = [];
  let r;
  for (; r = e.exec(t); )
    n.push({
      matchIndex: typeof r.index == "number" ? r.index : -1,
      fullMatch: r[0],
      groupMatchs: r.slice(1)
    });
  return n;
};
function rt(e) {
  const t = e.match(/[\s\S]/gu);
  return t ? t.length : 0;
}
function ja(e) {
  return [...e].length;
}
function Ba(e) {
  return Array.from(e).length;
}
function qa(e) {
  const t = e.length;
  let n = 0, r = 0;
  for (; n < t; ) {
    const s = e.charCodeAt(n);
    if (s >= 55296 && s <= 56319) {
      const i = e.charCodeAt(n + 1);
      i >= 56320 && i <= 57343 && n++;
    }
    r++, n++;
  }
  return r;
}
function Wa(e, t) {
  return Array.from(e).slice(0, t).join("");
}
function Ha(e, t) {
  const n = e.codePointAt(t);
  return n ? String.fromCodePoint(n) : void 0;
}
function Va(e) {
  if (!/^\s*[0-9A-Z]+\s*$/i.test(e))
    throw new Error("纳税人识别号只能由数字和大写字母组成");
  const t = e.trim().toUpperCase(), n = rt(t);
  if (n !== 15 && n !== 17 && n !== 18 && n !== 20)
    throw new Error("税号应为15/17/18/20位数字或大写字母组合，请检查。");
  return t;
}
function Ga(e) {
  if (!/^\s*[0-9A-Z（）\u{FA0E}\u{FA0F}\u{FA11}\u{FA13}\u{FA14}\u{FA1F}\u{FA21}\u{FA23}\u{FA24}\u{FA27}-\u{FA29}\u{4E00}-\u{9FCC}\u{3400}-\u{4DB5}\u{20000}-\u{2A6D6}\u{2A700}-\u{2B734}\u{2B740}-\u{2B81D}\u{2B820}-\u{2CEAF}\u{2CEB0}-\u{2EBEF}]+\s*$/iu.test(
    e
  ))
    throw new Error("名称只能包含：中文+英文+数字+全角括号");
  const t = e.trim(), n = rt(t);
  if (n == 0)
    throw new Error("请输入名称");
  if (n > 100)
    throw new Error("名称过长，请修改 (不超过100个字符)");
  return t;
}
function Xa(e) {
  if (!/^\s*([a-z0-9A-Z]+[-|_|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}\s*$/i.test(
    e
  ))
    throw new Error("请输入正确的邮箱");
  return e.trim();
}
function Za(e = 12, t = "all") {
  let n = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghijklmnopqrstuvwxyz0123456789";
  t == "number" && (n = "0123456789");
  const r = n.length;
  let s = "";
  for (let i = 0; i < e; i++)
    s += n[Math.floor(Math.random() * r)];
  return s;
}
const Vn = () => Math.random().toString(36).slice(2), Ja = () => String.fromCharCode(
  Math.random() * ("z".charCodeAt(0) - "a".charCodeAt(0)) + "a".charCodeAt(0)
);
function Ya(e, t) {
  const n = Object.keys(t);
  for (let r = 0, s = n.length; r < s; r++)
    e = e.replace(new RegExp("{" + n[r] + "}", "gi"), t[n[r]]);
  return e;
}
function Ka(e, ...t) {
  let n = "", r;
  for (r = 0; r < t.length; r++)
    n += e.raw[r] + t[r];
  return n += e.raw[r] || "", n;
}
function Qa(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function fs(e) {
  return e.replace(/(^\w)/g, (t) => t.toLowerCase());
}
const tc = (e, t = "-") => {
  let n = e.replace(new RegExp("[_-]?([A-Z])", "g"), t + "$1").toLowerCase();
  const r = new RegExp(`^${t}`);
  return r.test(e) || (n = n.replace(r, "")), n;
};
function ds(e) {
  return e.replace(/(^\w|[_-]\w)/g, (t) => t.slice(-1).toUpperCase());
}
function ec(e) {
  return fs(ds(e));
}
function nc(e) {
  return e ? e.replaceAll(/^\s+|\s+$/g, "").replaceAll(/\r?\n/g, "") : "";
}
function rc(e = "") {
  const t = /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
  return e.replaceAll(t, "");
}
function sc(e, t = "", n = /\[data-v-[0-9a-zA-Z]*\]/g) {
  return e = e.replaceAll(n, t), e;
}
function ic(e, t, n = "0", r = "left") {
  const s = rt(e);
  if (t > s) {
    const i = t - s;
    let o, a;
    switch (r) {
      case "left":
        e = Array(i + 1).join(n) + e;
        break;
      case "right":
        e = e + Array(i + 1).join(n);
        break;
      default:
        o = Math.ceil(i / 2), a = i - o, e = Array(a + 1).join(n) + e + Array(o + 1).join(n);
        break;
    }
  }
  return e;
}
const oc = (e, t) => e.repeat(t), ac = (e, t, n = "...") => rt(e) < t ? e : `${e.slice(0, t - 3)}${n}`, cc = (e, t, n, r = "...") => {
  const s = rt(e);
  return s < t || n - t >= s ? e : `${e.slice(0, t)}${r}${e.slice(s - n)}`;
}, uc = (e) => e.split("").reverse().join("");
function lc(e) {
  const t = e.codePointAt(0);
  return typeof t < "u" && t > 65535;
}
function hc(e) {
  let t = "";
  for (let n = 0, r = e.length; n < r; n++) {
    const s = e.charCodeAt(n);
    s >= 1 && s <= 127 ? t += e.charAt(n) : s > 2047 ? (t += String.fromCharCode(224 | s >> 12 & 15), t += String.fromCharCode(128 | s >> 6 & 63), t += String.fromCharCode(128 | s >> 0 & 63)) : (t += String.fromCharCode(192 | s >> 6 & 31), t += String.fromCharCode(128 | s >> 0 & 63));
  }
  return t;
}
function fc(e) {
  const t = e.length;
  let n = "", r = 0, s, i;
  for (; r < t; ) {
    const o = e.charCodeAt(r++);
    switch (o >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        n += e.charAt(r - 1);
        break;
      case 12:
      case 13:
        s = e.charCodeAt(r++), n += String.fromCharCode((o & 31) << 6 | s & 63);
        break;
      case 14:
        s = e.charCodeAt(r++), i = e.charCodeAt(r++), n += String.fromCharCode(
          (o & 15) << 12 | (s & 63) << 6 | (i & 63) << 0
        );
        break;
    }
  }
  return n;
}
function dc(e, t = "utf-8") {
  t = t.toLowerCase();
  let n = 0;
  if (t === "utf-16" || t === "utf16")
    for (let r = 0, s = e.length; r < s; r++)
      e.charCodeAt(r) <= 65535 ? n += 2 : n += 4;
  else
    for (let r = 0, s = e.length; r < s; r++) {
      const i = e.charCodeAt(r);
      i <= 127 ? n += 1 : i <= 2047 ? n += 2 : i <= 65535 ? n += 3 : n += 4;
    }
  return n;
}
function he(e) {
  const t = new ArrayBuffer(e.length), n = new Uint8Array(t);
  for (let r = 0, s = e.length; r < s; r++)
    n[r] = e[r];
  return t;
}
function ps(e) {
  return ArrayBuffer.isView(e);
}
function ms(e) {
  return ps(e) && !(e instanceof DataView);
}
function pc(e) {
  return ms(e) && e.constructor.name;
}
function mc(e) {
  return new DataView(e);
}
function gc(e, t) {
  return new e(t);
}
function yc(e, ...t) {
  let n = 0;
  for (const i of t)
    n += i.length;
  const r = new e(n);
  let s = 0;
  for (const i of t)
    r.set(i, s), s += i.length;
  return r;
}
function qe(e) {
  return e.slice(0);
}
function wc(e, t = !0) {
  const n = t ? qe(e.buffer) : e.buffer;
  return new DataView(n, e.byteOffset, e.byteLength);
}
function bc(e, t = !0) {
  const n = t ? qe(e.buffer) : e.buffer;
  return new e.constructor(
    n,
    e.byteOffset,
    e.length
  );
}
class xt {
  value;
  left;
  right;
  constructor(t, n) {
    this.value = t, this.left = n?.left, this.right = n?.right;
  }
  clone() {
    return new xt(this.value, {
      left: this.left,
      right: this.right
    });
  }
}
class Sc {
  root;
  constructor() {
  }
  add(t) {
    if (!this.root)
      this.root = new xt(t);
    else {
      let n = this.root;
      for (; n; )
        if (t === n.value) {
          console.log("Duplicates cannot be added");
          break;
        } else if (t < n.value)
          if (n.left)
            n = n.left;
          else {
            n.left = new xt(t);
            break;
          }
        else if (t > n.value)
          if (n.right)
            n = n.right;
          else {
            n.right = new xt(t);
            break;
          }
    }
  }
  remove(t) {
    let n = this.root, r, s;
    for (; n; )
      if (t < n.value)
        r = n, n = n.left;
      else if (t > n.value)
        r = n, n = n.right;
      else {
        s = n;
        break;
      }
    if (!s) {
      console.log("The node was not found");
      return;
    }
    if (r) {
      const i = r.left === s;
      if (!s.left && !s.right)
        i ? r.left = void 0 : r.right = void 0;
      else if (s.left && !s.right)
        i ? r.left = s.left : r.right = s.left;
      else if (s.right && !s.left)
        i ? r.left = s.right : r.right = s.right;
      else {
        const o = s.right, a = s.left;
        i ? r.left = o : r.right = o;
        let c = o, u;
        for (; c; )
          u = c, c = c.left;
        u && (u.left = a), console.log("The node was successfully deleted");
      }
    } else if (!s.left && !s.right)
      this.root = void 0;
    else if (s.left && !s.right)
      this.root = s.left;
    else if (s.right && !s.left)
      this.root = s.right;
    else {
      const i = s.right, o = s.left;
      this.root = i;
      let a = i, c;
      for (; a; )
        c = a, a = a.left;
      c && (c.left = o), console.log("The node was successfully deleted");
    }
    return s;
  }
  // 树的高度
  // 最大深度： root 到 叶子节点
  maxDepth(t = this.root) {
    let n = 0;
    const r = (s, i = 1) => {
      s && (!s.left && !s.right && (n = Math.max(n, i)), r(s.left, i + 1), r(s.right, i + 1));
    };
    return r(t), n;
  }
  // 最小深度： root 到 叶子节点
  minDepth(t = this.root) {
    if (!t)
      return 0;
    const n = [[t, 1]];
    for (; n.length; ) {
      const [r, s] = n.shift();
      if (!r.left && !r.right)
        return s;
      r.left && n.push([r.left, s + 1]), r.right && n.push([r.right, s + 1]);
    }
  }
  // 如果某二叉树中任意节点的左右子树的深度相差不超过 1，那么它就是一棵平衡二叉树
  // 该方法最坏的情况是每个父节点都只有一个子节点，这样树的高度时间复杂度为 O(n)，即“链表”的长度。而第 d 层调用 height 函数的时间复杂度是 O(d)，所以整体的时间复杂度为 高度时间复杂度 * 调用height函数的时间复杂度，即 O(n^2)。
  isBalance(t = this.root) {
    return t ? Math.abs(this.maxDepth(t.left) - this.maxDepth(t.right)) <= 1 && this.isBalance(t.left) && this.isBalance(t.right) : !0;
  }
  // 广度优先遍历
  bfs(t = this.root, n) {
    if (!t)
      return;
    const r = [t];
    for (; r.length; ) {
      const s = r.shift();
      if (!n?.(s))
        break;
      s.left && r.push(s.left), s.right && r.push(s.right);
    }
  }
  // 深度优先遍历
  dfs(t = this.root, n) {
    t && n?.(t) && (this.dfs(t.left, n), this.dfs(t.right, n));
  }
  // 递归遍历 - 先序遍历 current, left, right
  preOrderRecursive(t = this.root, n) {
    t && n?.(t) && (this.preOrderRecursive(t.left, n), this.preOrderRecursive(t.right, n));
  }
  // 递归遍历 - 中序遍历 left, current, right
  // 中序遍历：递增序列
  // 中序遍历倒序：递减序列
  inOrderRecursive(t = this.root, n) {
    t && (this.inOrderRecursive(t.left, n), n?.(t) && this.inOrderRecursive(t.right, n));
  }
  // 递归遍历 - 后序遍历 left, right, current
  postOrderRecursive(t = this.root, n) {
    t && (this.postOrderRecursive(t.left, n), this.postOrderRecursive(t.right, n), n?.(t));
  }
  // 非递归遍历 - 先序遍历 current, left, right
  preOrder(t = this.root, n) {
    const r = [];
    for (t && r.push(t); r.length && (t = r.pop(), !!n?.(t)); )
      t.right && r.push(t.right), t.left && r.push(t.left);
  }
  // 中序遍历：递增序列
  // 非递归遍历 - 中序遍历 left, current, right
  inOrder(t = this.root, n) {
    const r = [];
    for (; r.length || t; ) {
      for (; t; )
        r.push(t), t = t.left;
      if (t = r.pop(), !n?.(t))
        break;
      t = t.right;
    }
  }
  // 中序遍历倒序：递减序列 right, current, left
  inOrderReverse(t = this.root, n) {
    const r = [];
    for (; r.length || t; ) {
      for (; t; )
        r.push(t), t = t.right;
      if (t = r.pop(), !n?.(t))
        break;
      t = t.left;
    }
  }
  // 非递归遍历 - 后序遍历 left, right, current
  postOrder(t = this.root, n) {
    const r = [], s = [];
    for (t && r.push(t); r.length; )
      t = r.pop(), s.push(t), t.left && r.push(t.left), t.right && r.push(t.right);
    n && s.reverse().map(n);
  }
  // 获得第K大的节点, K从1开始
  kthLargest(t) {
    let n = 0, r;
    return this.inOrderReverse(this.root, (s) => (n++, n == t ? (r = s.value, !1) : !0)), r;
  }
  // 反转二叉树
  // 寻找递归公式
  // 解题要采用自上而下的思考方式，那我们取前面的 1， 2，3 结点来看，对于根节点 1 来说，假设 2, 3 结点下的节点都已经翻转，那么只要翻转 2， 3 节点即满足需求
  // 对于 2， 3 结点来说，也是翻转其左右节点即可,依此类推,对每一个根节点，依次翻转其左右节点，
  // 所以我们可知问题与子问题的关系是 翻转(根节点) = 翻转(根节点的左节点) + 翻转(根节点的右节点)
  // 即 invert(root) = invert(root->left) + invert(root->right),
  // 而显然递归的终止条件是当结点为叶子结点时终止（因为叶子节点没有左右结点）
  // 时间复杂度分析: 由于会对每一个节点都去做翻转，所以时间复杂度是 O(n)
  // 空间复杂度分析: 由于每次调用 invertTree 函数都相当于一次压栈操作，
  //   那最多压了几次栈呢，从根节点出发不断对左结果调用翻转函数, 直到叶子节点，每调用一次都会压栈，左节点调用完后，出栈，再对右节点压栈 ...,
  //   可知栈的大小为3， 即树的高度，如果是完全二叉树 ，则树的高度为logn, 即空间复杂度为O(logn)
  //   最坏情况，如果此二叉树是只有左节点，没有右节点，则树的高度即结点的个数 n，此时空间复杂度为 O(n)
  //   总的来看，空间复杂度为O(n)
  invertTree(t = this.root) {
    if (!t)
      return;
    const n = this.invertTree(t.left), r = this.invertTree(t.right);
    return t.right = n, t.left = r, t;
  }
}
class We {
  value;
  toEdges;
  constructor(t, n = []) {
    this.value = t, this.toEdges = n;
  }
  clone() {
    return new We(this.value, this.toEdges);
  }
}
class Jt {
  fromNode;
  toNode;
  // 权重
  weight;
  constructor(t, n, r = 1) {
    this.fromNode = t, this.toNode = n, this.weight = r;
  }
  clone() {
    return new Jt(this.fromNode, this.toNode, this.weight);
  }
}
class Ac {
  // 有无方向
  isdirected;
  nodes = [];
  visitFn;
  constructor(t = !1, n) {
    this.isdirected = t, this.visitFn = n || ((r) => console.log(r.value + ","));
  }
  addNode(t) {
    this.nodes.push(new We(t));
  }
  removeNode(t) {
    this.nodes = this.nodes.filter((n) => n.value !== t), this.nodes.forEach((n) => {
      n.toEdges = n.toEdges.filter((r) => r.toNode.value !== t);
    });
  }
  findNode(t) {
    return this.nodes.find((n) => n.value === t);
  }
  addEdge(t, n, r = 1) {
    const s = this.findNode(t), i = this.findNode(n);
    s && i && (s.toEdges.push(new Jt(s, i, r)), this.isdirected && i.toEdges.push(new Jt(i, s, r)));
  }
  // 邻接矩阵
  toMatrixArray() {
    const t = this.nodes.length, n = Array.from(
      { length: t },
      () => Array(t).fill(0)
    );
    return this.nodes.forEach((r, s) => {
      r.toEdges.forEach((i) => {
        const o = this.nodes.indexOf(i.toNode);
        n[s][o] = 1;
      });
    }), n;
  }
  // 邻接表
  toLinkedArrayObject() {
    const t = this.nodes.length, n = {};
    for (let r = 0; r < t; r++) {
      const s = [];
      this.nodes[r].toEdges.forEach((i) => {
        s.push(this.nodes.indexOf(i.toNode));
      }), n[String(this.nodes[r].value)] = s;
    }
    return n;
  }
  // 深度优先遍历
  dfs(t, n = /* @__PURE__ */ new Set()) {
    this.visitFn(t), n.add(t), t.toEdges.forEach((r) => {
      n.has(r.toNode) || this.dfs(r.toNode, n);
    });
  }
  // 广度优先遍历
  wfs(t) {
    const n = /* @__PURE__ */ new Set(), r = [t];
    for (; r.length; ) {
      const s = r.shift();
      this.visitFn(s), n.add(s), s.toEdges.forEach((i) => {
        n.has(i.toNode) || r.push(i.toNode);
      });
    }
  }
}
class fe {
  heap = [];
  compareFn;
  constructor(t, n) {
    if (this.compareFn = t, n) {
      this.heap = n;
      const r = this.size() - 1, s = this.getParentIndex(r);
      for (let i = s; i >= 0; i--)
        this.shiftDown(i);
    }
  }
  size() {
    return this.heap.length;
  }
  isEmpty() {
    return this.size() === 0;
  }
  // 获取父元素坐标
  getParentIndex(t) {
    return t - 1 >> 1;
  }
  // 获取左子节点元素坐标
  getLeftChildIndex(t) {
    const n = t * 2 + 1;
    return n < this.size() ? n : null;
  }
  // 获取右子节点元素坐标
  getRightChildIndex(t) {
    const n = t * 2 + 2;
    return n < this.size() ? n : null;
  }
  // 交换元素
  swap(t, n) {
    t >= 0 && t < this.size() && n >= 0 && n < this.size() && ([this.heap[t], this.heap[n]] = [this.heap[n], this.heap[t]]);
  }
  // 查看堆顶元素
  peek() {
    return this.heap[0];
  }
  // 尾部插入元素
  // 时间复杂度O(logN)
  push(t) {
    this.heap.push(t), this.shiftUp(this.size() - 1);
  }
  // 上移操作
  shiftUp(t) {
    if (t === 0)
      return;
    const n = this.getParentIndex(t);
    this.compareFn(this.heap[n], this.heap[t]) || (this.swap(n, t), this.shiftUp(n));
  }
  // 堆顶删除元素
  // 时间复杂度O(logN)
  pop() {
    if (this.isEmpty())
      return null;
    {
      const t = this.heap[0], n = this.heap.pop();
      return n !== void 0 && !this.isEmpty() && (this.heap[0] = n, this.shiftDown(0)), t;
    }
  }
  // 下移操作
  shiftDown(t) {
    if (t >= this.size() - 1)
      return;
    const n = this.getLeftChildIndex(t), r = this.getRightChildIndex(t);
    n && !this.compareFn(this.heap[t], this.heap[n]) && (this.swap(n, t), this.shiftDown(n)), r && !this.compareFn(this.heap[t], this.heap[r]) && (this.swap(r, t), this.shiftDown(r));
  }
}
const xc = fe;
class _c extends fe {
  constructor(t, n) {
    const r = (s, i) => s > i;
    super(t ?? r, n);
  }
}
class Oc extends fe {
  constructor(t, n) {
    const r = (s, i) => s < i;
    super(t ?? r, n);
  }
}
class He {
  value;
  next;
  constructor(t, n) {
    this.value = t, this.next = n;
  }
  clone() {
    return new He(this.value, this.next);
  }
}
class gs {
  head;
  tail;
  length = 0;
  constructor() {
  }
  size() {
    return this.length;
  }
  isEmpty() {
    return this.size() === 0;
  }
  insert(t, n) {
    const r = new He(n);
    if (t == 0)
      return r.next = this.head, this.head = r, this.isEmpty() && (this.tail = this.head), this.length++, !0;
    {
      let s = this.head, i = this.head?.next, o = 1;
      for (; o++ < t; )
        s = i, i = i?.next;
      return s ? (s.next = r, r.next = i, i || (this.tail = r), this.length++, !0) : !1;
    }
  }
  delete(t) {
    if (!this.isEmpty())
      if (t == 0) {
        const n = this.head;
        return this.size() == 1 ? this.head = this.tail = void 0 : this.head = this.head?.next, this.length--, n;
      } else {
        let n = this.head, r = this.head?.next, s = 1;
        for (; s++ < t && r; )
          n = r, r = r?.next;
        return n ? (n.next = r?.next, (!r || !r.next) && (this.tail = n), r && this.length--, r) : void 0;
      }
  }
  deleteNode(t) {
    t.next ? (t.value = t.next.value, t.next = t.next.next, t.next || (this.tail = t), this.length--) : this.pop();
  }
  // 尾部加入
  push(t) {
    return this.insert(this.size(), t);
  }
  // 尾部删除
  pop() {
    return this.delete(this.size() - 1);
  }
  // 头部加入
  unshift(t) {
    return this.insert(0, t);
  }
  // 头部删除
  shift() {
    return this.delete(0);
  }
  // 遍历
  // visitFn 返回 true 继续遍历， 返回 false 中断遍历
  traverse(t) {
    let n = this.head, r = 0;
    for (; n && t?.(n, r++); )
      n = n.next;
  }
  at(t) {
    if (t < 0 || t >= this.size() || this.isEmpty())
      return;
    if (t === 0)
      return this.head;
    if (t === this.size() - 1)
      return this.tail;
    let n = this.head;
    for (; --t >= 0 && n; )
      n = n.next;
    return n;
  }
  getIndex(t) {
    let n = -1;
    return this.traverse((r, s) => (r.value == t && (n = s), n == -1)), n;
  }
  toArray() {
    const t = [];
    return this.traverse((n) => (t.push(n.value), !0)), t;
  }
  // 列表反转
  // 时间复杂度 O(N)
  reverse() {
    this.tail = this.head;
    let t, n;
    for (; this.head && this.head.next; )
      t = n, n = this.head, this.head = this.head.next, n.next = t;
    return this.head && (this.head.next = n), this;
  }
  // 快慢指针: 判断链表中是否有环
  hasCycle(t = this.head) {
    if (!t || !t.next)
      return !1;
    let n = t, r = t.next;
    for (; n !== r; ) {
      if (!n || !r || !r.next)
        return !1;
      n = n.next, r = r.next.next;
    }
    return !0;
  }
}
const V = {
  THROW: 1,
  DROP: 2,
  SLIDE: 3,
  EXPAND: 4
};
class Et {
  queue;
  limit;
  overflow;
  constructor(t = 10, n = V.EXPAND) {
    this.queue = [], this.limit = t, this.overflow = n;
  }
  length() {
    return this.queue.length;
  }
  isEmpty() {
    return this.length() === 0;
  }
  findIndex(t) {
    return this.queue.findIndex(t);
  }
  deleteIndex(t) {
    return !!this.queue.splice(t, 1).length;
  }
  delete(t) {
    const n = this.findIndex(t);
    return n > -1 ? this.deleteIndex(n) : !1;
  }
  // 入队
  enqueue(t) {
    if (this.length() < this.limit) {
      this.queue.push(t);
      return;
    }
    switch (this.overflow) {
      case V.EXPAND:
        this.limit *= 2, this.queue.push(t);
        break;
      case V.SLIDE:
        this.deleteIndex(0), this.queue.push(t);
        break;
      case V.THROW:
        throw new Error(`Queue limit(${this.limit}) overflow!`);
      case V.DROP:
    }
  }
  push(t) {
    this.enqueue(t);
  }
  put(t) {
    this.enqueue(t);
  }
  // 出队
  dequeue() {
    return this.queue.shift();
  }
  pop() {
    return this.dequeue();
  }
  take() {
    return this.dequeue();
  }
  // 获取队顶对象
  peek() {
    return this.queue[0];
  }
  // 获取对象
  index(t) {
    return this.queue[t];
  }
  // 全部出队
  clear() {
    this.queue = [];
  }
  // 全部出队
  flush() {
    const t = [];
    let n;
    for (; n = this.dequeue(); )
      t.push(n);
    return t;
  }
}
const Tc = () => new Et(0, V.DROP), vc = (e) => new Et(e, V.THROW), Rc = (e) => new Et(e, V.DROP), Ec = (e) => new Et(e, V.SLIDE), ys = (e) => new Et(e, V.EXPAND), Cc = 9007199254740991, Fc = -9007199254740991, kc = Math.pow(2, -52), ws = 2147483647;
function Gn(e) {
  return Number.isNaN(e);
}
function Pc(e) {
  return typeof e == "number" && Gn(e);
}
const Dc = (e) => e % 2 === 0, bs = (e) => e && e === Math.floor(e) && e > 0 && isFinite(e);
function Ss(e) {
  if (e <= 1)
    return !1;
  for (let t = 2; t <= Math.sqrt(e); t++)
    if (e % t === 0)
      return !1;
  return !0;
}
function As(e) {
  for (; !Ss(e); )
    e++;
  return e;
}
const Mc = (...e) => e.reduce((t, n) => t + n) / e.length;
function Y(e, t) {
  const n = parseFloat(e);
  return Number.isNaN(n) ? typeof t == "number" ? t : NaN : n;
}
function Lc(e, t, n) {
  return typeof e == "string" ? (e = e.trim().toLowerCase(), e.indexOf("%") > 0 ? Y(e, t) / 100 * n : e.indexOf("vw") > 0 ? Y(e, t) / 100 * window.innerWidth : e.indexOf("vh") > 0 ? Y(e, t) / 100 * window.innerHeight : e.indexOf("vm") > 0 ? Y(e, t) / 100 * Math.min(window.innerWidth, window.innerHeight) : e == "top" || e == "left" ? 0 : e == "center" || e == "middle" ? n * 0.5 : e == "bottom" || e == "right" ? n : Y(e, t)) : Y(e, t);
}
function xs(e = 1e-6) {
  return function(t, n) {
    return Math.abs(t - n) < e;
  };
}
function Ic(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, s = Math.pow(10, Math.max(n, r));
  return (e * s + t * s) / s;
}
function dt(e, t, n) {
  const r = Math.min(t, n), s = Math.max(t, n);
  return e < r ? r : e > s ? s : e;
}
function $c(e, t = 0) {
  const n = Math.pow(10, t);
  return Math.round(n * e) / n;
}
function Nc(e, t) {
  return (e % t + t) % t;
}
function _s(e, t, n) {
  return typeof e == "number" && typeof t == "number" ? (1 - n) * e + n * t : typeof e == "number" ? e : typeof t == "number" ? t : 0;
}
function Uc(e, t, n) {
  const r = Math.max(e.length, t.length), s = new Array(r);
  for (let i = 0; i < r; i++)
    s[i] = _s(e[i], t[i], n);
  return s;
}
function zc(e, t, n, r) {
  return (s) => n + (r - n) * ((s - e) / (t - e));
}
function jc(e, t, n) {
  return (r) => {
    const s = dt(r, e, t);
    return n == 0 ? s : t - s < n ? t : Math.round(s / n) * n;
  };
}
function Bc(e, t = 12) {
  return Y(e, 0).toPrecision(t);
}
function Xn(e, t = 12) {
  return Y(e, 0).toFixed(t);
}
function et(e, t = 12) {
  return +Xn(e, t);
}
function qc(e) {
  return et(e, 0);
}
function Wc(e, t = 4, n = ",") {
  const r = new RegExp(`\\d{1,${t}}(?=(\\d{${t}})+$)`, "g");
  return String(e).replace(r, `$&${n}`);
}
function Hc(e, t) {
  const n = Be("number-single", String(e));
  return {
    hasNumber: !!n,
    number: n && !Array.isArray(n) && n.fullMatch ? parseFloat(n.fullMatch) : ai(t) ? t : NaN,
    prefix: n && !Array.isArray(n) && n.fullMatch ? e.substring(0, n.matchIndex) : "",
    suffix: n && !Array.isArray(n) && n.fullMatch ? e.substring(n.matchIndex + n.fullMatch.length) : ""
  };
}
function Os(e) {
  const t = Be("number", e);
  return t ? Array.isArray(t) ? t.map((n) => Number(n.fullMatch)) : [Number(t.fullMatch)] : [];
}
function Vc() {
  return Math.random() > 0.5 ? 1 : -1;
}
function Ts(e = 0, t = 100) {
  return Math.random() * (t - e) + e;
}
function Gc(e = 0, t = 100) {
  return Math.floor(Ts(e, t));
}
function Xc(e = 0) {
  return () => ++e;
}
function Zc(e, t) {
  switch (t.constructor) {
    case Float32Array:
      return e;
    case Uint32Array:
      return Math.round(e * 4294967295);
    case Uint16Array:
      return Math.round(e * 65535);
    case Uint8Array:
      return Math.round(e * 255);
    case Int32Array:
      return Math.round(e * 2147483647);
    case Int16Array:
      return Math.round(e * 32767);
    case Int8Array:
      return Math.round(e * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
function Jc(e, t) {
  switch (t.constructor) {
    case Float32Array:
      return e;
    case Uint32Array:
      return e / 4294967295;
    case Uint16Array:
      return e / 65535;
    case Uint8Array:
      return e / 255;
    case Int32Array:
      return Math.max(e / 2147483647, -1);
    case Int16Array:
      return Math.max(e / 32767, -1);
    case Int8Array:
      return Math.max(e / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
const fn = {
  SLIDE: 1,
  EXPAND: 2
};
class Yc {
  size;
  table;
  objectSignature;
  overflow;
  ttl;
  constructor(t) {
    this.table = new Array(t?.size || 137), this.size = this.table.length, this.objectSignature = t?.objectSignature || ((n) => String(n)), this.overflow = t?.overflow || fn.EXPAND, this.ttl = t?.ttl || 6e4;
  }
  // 散列函数，纯函数
  hash(t) {
    if (t == null || t == null)
      throw new Error("HashTable can't put undefined or null");
    const n = this.objectSignature(t), r = 31;
    let s = 0;
    for (let i = 0, o = n.length; i < o; i++)
      s += r * s + n.charCodeAt(i);
    return s % this.size;
  }
  // 扩展散列表大小至一个更大的质数
  resize() {
    const t = this.size, n = As(this.size * 2), r = new Array(n), s = this.table;
    this.table = r, this.size = n;
    for (let i = 0, o = t; i < o; i++)
      if (s[i] !== void 0 && !this.isOutdated(s[i])) {
        let a = this.hash(s[i].value);
        for (; r[a] !== void 0; )
          a = (a + 1) % n;
        r[a] = s[i];
      }
    s.length = 0;
  }
  put(t) {
    this.size > 200 && Math.random() < 0.1 && this.clean();
    let n = this.hash(t);
    const r = n;
    for (; this.table[n] !== void 0 && !this.isOutdated(this.table[n]); )
      if (n = (n + 1) % this.size, r == n) {
        if (this.overflow == fn.EXPAND)
          return this.resize(), this.put(t);
        break;
      }
    return this.table[n] = { value: t, timestamp: Date.now() }, n;
  }
  // 性能瓶颈
  // visitFn : return false to break loop
  traverse(t) {
    for (let n = 0, r = this.size; n < r; n++)
      if (this.table[n] !== void 0 && !t(this.table[n].value, n))
        return n;
    return -1;
  }
  // filter : return false 删除
  update(t) {
    this.traverse((n, r) => (t(n) === !1 && this.deleteIndex(r), !0));
  }
  getIndex(t) {
    let n = this.hash(t);
    const r = n;
    for (; this.table[n]?.value !== t; )
      if (this.table[n] === void 0 || (this.isOutdated(this.table[n]) && (this.table[n] = void 0), n = (n + 1) % this.size, r == n))
        return -1;
    return this.isOutdated(this.table[n]) ? (this.table[n] = void 0, -1) : n;
  }
  has(t) {
    return this.getIndex(t) >= 0;
  }
  // 性能瓶颈
  find(t) {
    const n = this.traverse((r) => !t(r));
    return n >= 0 ? this.table[n]?.value : void 0;
  }
  deleteIndex(t) {
    return t >= 0 && t < this.size && this.table[t] !== void 0 ? (this.table[t] = void 0, !0) : !1;
  }
  delete(t) {
    return this.deleteIndex(this.getIndex(t));
  }
  clear() {
    this.table = [];
  }
  // 数据是否过期
  isOutdated(t) {
    return Date.now() - t.timestamp > this.ttl;
  }
  // 性能瓶颈
  // 供外部使用：主动清理过期数据
  clean() {
    for (let t = 0, n = this.size; t < n; t++)
      this.table[t] !== void 0 && this.isOutdated(this.table[t]) && (this.table[t] = void 0);
  }
}
class Kc {
  obj = {};
  constructor() {
  }
  put(t, n) {
    this.obj[t] = this.obj[t] || [], this.obj[t].push(n);
  }
  get(t) {
    return this.obj[t] || [];
  }
  has(t) {
    let n = !1;
    return this.traverse((r) => r == t ? (n = !0, !1) : !0), n;
  }
  keys() {
    const t = [];
    for (const n in this.obj)
      t.push(n);
    return t;
  }
  // visitFn : return false to break loop
  traverse(t) {
    for (const n in this.obj)
      for (let r = 0, s = this.obj[n].length; r < s && t(this.obj[n][r]); r++)
        ;
  }
}
class Ve {
  maps = /* @__PURE__ */ new Map();
  constructor() {
  }
  // Object.entries(...);
  // Object.fromEntries(...);
  entries() {
    return [...this.maps.entries()];
  }
  // Object.keys(...);
  keys() {
    return [...this.maps.keys()];
  }
  // Object.values(...);
  values() {
    return [...this.maps.values()];
  }
  json() {
    const t = {};
    for (const n of this.maps)
      t[n[0]] = n[1];
    return t;
  }
  get length() {
    return this.maps.size;
  }
  set(t, n) {
    this.maps.set(t, n);
  }
  get(t) {
    return this.maps.get(t);
  }
  has(t) {
    return this.maps.has(t);
  }
  // Map 对象是按插入的顺序返回键值
  getEntryFromIndex(t) {
    let n = -1;
    for (const r of this.maps)
      if (++n == t)
        return r;
  }
  // 性能瓶颈
  getEntry(t) {
    for (const n of this.maps)
      if (t(n[0], n[1]))
        return n;
  }
  firstEntry() {
    return this.getEntryFromIndex(0);
  }
  // 从头部删除
  shift() {
    const t = this.firstEntry();
    if (t) {
      const [n] = t;
      this.delete(n);
    }
    return t;
  }
  delete(t) {
    return this.maps.delete(t);
  }
  clear() {
    this.maps.clear();
  }
  // filter : return false 删除
  update(t) {
    const n = this.entries();
    for (let r = 0, s = n.length; r < s; r++) {
      const [i, o] = n[r];
      t(i, o) === !1 && this.delete(i);
    }
  }
}
const vs = "__yz_hash_undefined__";
class Dt {
  __data__ = {};
  size = 0;
  constructor(t) {
    t = t || [];
    const n = t.length;
    let r = -1;
    for (; ++r < n; ) {
      const s = t[r];
      this.set(s[0], s[1]);
    }
  }
  clear() {
    this.__data__ = {}, this.size = 0;
  }
  has(t) {
    const n = this.__data__;
    return Object.prototype.hasOwnProperty.call(n, t);
  }
  set(t, n) {
    const r = this.__data__;
    return this.size += this.has(t) ? 0 : 1, r[t] = n, this;
  }
  get(t) {
    const n = this.__data__;
    return this.has(t) ? n[t] : void 0;
  }
  delete(t) {
    const n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
}
const Qc = (e) => new Array(e).fill(void 0), t1 = (e) => Array.isArray(e) && e.length > 0;
function e1(e) {
  const t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Object.prototype.hasOwnProperty.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
function n1(e, t) {
  const n = new Array(e);
  let r = -1;
  for (; ++r < e; )
    n[r] = t(r);
  return n;
}
function r1(e, t) {
  return Array.from({ length: e }, (n, r) => t);
}
function Rs(e, t, n) {
  return Array.from(
    { length: e },
    () => new Array(t).fill(n)
  );
}
function s1(e, t) {
  return e[0].length ? Rs(
    e.map((n) => n.filter((r, s) => s === 0)[0]).length,
    e[0].length,
    t
  ) : new Error("Illegal, Array must be any[][]!");
}
function Es(e, t) {
  return [...e[t]];
}
function Cs(e, t) {
  return e.map((n) => n.filter((r, s) => s === t)[0]);
}
function i1(e, t, n) {
  return {
    row: Es(e, t),
    column: Cs(e, n)
  };
}
function o1(e, t) {
  const n = e.length || 0;
  let r = -1;
  for (; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
function a1(e, t) {
  const n = e.length || 0;
  let r = -1;
  for (; ++r < n; )
    if (t(e[r], r, e) === !1)
      return !1;
  return !0;
}
function c1(e, t) {
  let n = 0;
  for (const r of e)
    n += +!!t(r);
  return n;
}
function u1(e, t) {
  return e.flatMap((n, r) => r ? [t(r), n] : [n]);
}
function Fs(e, t, n) {
  [e[t], e[n]] = [e[n], e[t]];
}
function l1(e, t) {
  return Fs(e, 0, t);
}
function h1(e) {
  e.sort((n, r) => n - r);
  const t = Math.floor(e.length / 2);
  return e[t];
}
function f1(e) {
  if (e.length)
    return e[0];
}
function d1(e) {
  if (e.length)
    return e[e.length - 1];
}
function ks(e, t) {
  for (let n = 0, r = e.length; n < r; n++)
    if (e[n] == t)
      return !0;
  return !1;
}
function Ps(e = [], t = []) {
  const n = e.length, r = t.length;
  for (let i = 0; i < r; i++)
    e[i] = t[i];
  let s = Math.max(0, n - r);
  for (; s > 0; )
    e.pop(), s--;
  return e;
}
function p1(e) {
  for (; e.length; )
    e.pop();
}
function m1(e, t, n) {
  return e.splice(dt(t, 0, e.length - 1), 0, n), e;
}
function g1(e, t) {
  const n = e.findIndex((r) => r === t);
  return n >= 0 && e.splice(n, 1), e;
}
const y1 = (e) => j(e) && Object.keys(e).length > 0, w1 = (e, t) => e.length === t.length && e.every((n, r) => n === t[r]);
function* Zn(e) {
  for (const t of e)
    j(t) ? yield* Zn(t) : yield t;
}
function b1(e) {
  if (j(e))
    return [...Zn(e)];
}
function Ds(e) {
  let t = [];
  return e.forEach((n) => {
    j(n) ? t = t.concat(Ds(n)) : t.push(n);
  }), t;
}
function Ms(e) {
  return e.reduce((t, n) => t.concat(j(n) ? Ms(n) : n), []);
}
function S1(e) {
  return e.flat(1 / 0);
}
function A1(e) {
  let t = JSON.stringify(e);
  return t = t.replace(/(\[|\])/g, ""), t = "[" + t + "]", JSON.parse(t);
}
const x1 = (e) => e.sort(() => 0.5 - Math.random());
function _1(e) {
  return [...new Set(e)];
}
function O1(e, ...t) {
  return t.forEach((n) => {
    ks(e, n) || e.push(n);
  }), e;
}
function T1(e, t) {
  return [.../* @__PURE__ */ new Set([...e, ...t])];
}
function v1(e, t) {
  return /* @__PURE__ */ new Set([...e, ...t]);
}
function R1(e, t) {
  return [...new Set(e.filter((n) => t.includes(n)))];
}
function E1(e, t) {
  return new Set([...e].filter((n) => t.has(n)));
}
function C1(e, t) {
  const n = /* @__PURE__ */ new Map();
  e.forEach((s) => {
    n.set(s, !0);
  });
  const r = [];
  return t.forEach((s) => {
    n.has(s) && (r.push(s), n.delete(s));
  }), r;
}
function F1(e, t) {
  return [...new Set(e.filter((n) => !t.includes(n)))];
}
function k1(e, t) {
  return new Set([...e].filter((n) => !t.has(n)));
}
function P1(e) {
  for (let t = e.length - 1; t >= 0; --t)
    if (e[t] >= 65535)
      return !0;
  return !1;
}
let Ls = class extends Array {
  constructor(t) {
    super(t), this.fill(0);
  }
};
const M1 = (e) => bs(e) ? e <= Math.pow(2, 8) ? Uint8Array : e <= Math.pow(2, 16) ? Uint16Array : e <= Math.pow(2, 32) ? Uint32Array : e <= Number.MAX_SAFE_INTEGER ? Ls : null : null;
function Mt(e, t) {
  let n = e.length;
  for (; n--; )
    if (mi(e[n][0], t))
      return n;
  return -1;
}
function dn(e) {
  const t = Array(e.size);
  return e.forEach(function(n, r) {
    t.push([r, n]);
  }), t;
}
function Is(e, t) {
  return e.set(t[0], t[1]), e;
}
function L1(e, t) {
  return (t ? t(dn(e), !0) : dn(e)).reduce(Is, /* @__PURE__ */ new Map());
}
function pn(e) {
  const t = Array(e.size);
  return e.forEach((n, r) => {
    t[r] = n;
  }), t;
}
function $s(e, t) {
  return e.add(t), e;
}
function I1(e, t) {
  return (t ? t(pn(e), !0) : pn(e)).reduce($s, /* @__PURE__ */ new Set());
}
class _t {
  __data__ = [];
  size = 0;
  constructor(t) {
    t = t || [];
    const n = t.length;
    let r = -1;
    for (; ++r < n; ) {
      const s = t[r];
      this.set(s[0], s[1]);
    }
  }
  clear() {
    this.__data__ = [], this.size = 0;
  }
  delete(t) {
    const n = this.__data__, r = Mt(n, t);
    if (r < 0)
      return !1;
    const s = n.length - 1;
    return r == s ? n.pop() : Array.prototype.splice.call(n, r, 1), --this.size, !0;
  }
  get(t) {
    const n = this.__data__, r = Mt(n, t);
    return r < 0 ? void 0 : n[r][1];
  }
  has(t) {
    return Mt(this.__data__, t) > -1;
  }
  set(t, n) {
    const r = this.__data__, s = Mt(r, t);
    return s < 0 ? (++this.size, r.push([t, n])) : r[s][1] = n, this;
  }
}
function Lt(e, t) {
  const n = e.__data__;
  return hi(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
class Ct {
  __data__ = {
    string: new Dt(),
    // key = string
    hash: new Dt(),
    // key = number | boolean | symbol | null
    map: new _t()
    // key = undefined | array | object | function
  };
  size = 0;
  constructor(t) {
    t = t || [];
    const n = t.length;
    let r = -1;
    for (; ++r < n; ) {
      const s = t[r];
      this.set(s[0], s[1]);
    }
  }
  clear() {
    this.size = 0, this.__data__ = {
      string: new Dt(),
      hash: new Dt(),
      map: new _t()
    };
  }
  delete(t) {
    const n = Lt(this, t).delete(t);
    return this.size -= n ? 1 : 0, n;
  }
  get(t) {
    return Lt(this, t).get(t);
  }
  has(t) {
    return Lt(this, t).has(t);
  }
  set(t, n) {
    const r = Lt(this, t), s = r.size;
    return r.set(t, n), this.size += r.size == s ? 0 : 1, this;
  }
}
class $1 {
  __cache__;
  constructor(t) {
    const n = [];
    for (const r in t)
      this[r] = t[r].serverValue, n.push([t[r].serverValue, t[r]]);
    this.__cache__ = new Ct(n);
  }
  // types(): readonly string[] {
  //   const types = [...super.keys()] as const;
  //   type Types = (typeof types)[number];
  //   return types;
  // }
  isExist(t) {
    return this.__cache__.has(t);
  }
  getName(t) {
    const n = this.__cache__.get(t);
    return n ? n.name || n.serverDescription : "";
  }
  setName(t, n) {
    const r = this.__cache__.get(t);
    r && (r.name = n);
  }
}
const Ns = 200;
let N1 = class {
  __data__;
  size;
  constructor(t) {
    const n = this.__data__ = new _t(t);
    this.size = n.size;
  }
  clear() {
    this.__data__ = new _t(), this.size = 0;
  }
  delete(t) {
    const n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  get(t) {
    return this.__data__.get(t);
  }
  has(t) {
    return this.__data__.has(t);
  }
  set(t, n) {
    let r = this.__data__;
    if (r instanceof _t) {
      const s = r.__data__;
      if (!jt || s.length < Ns - 1)
        return s.push([t, n]), this.size = ++r.size, this;
      r = this.__data__ = new Ct(s);
    }
    return r.set(t, n), this.size = r.size, this;
  }
};
class z1 {
  __data__ = new Ct();
  constructor(t) {
    t = t || [];
    const n = t.length;
    let r = -1;
    for (; ++r < n; )
      this.add(t[r]);
  }
  add(t) {
    return this.__data__.set(t, vs), this;
  }
  has(t) {
    return this.__data__.has(t);
  }
}
function j1(e, t = "Asia/Shanghai") {
  const n = (/* @__PURE__ */ new Date()).getTimezoneOffset() * 60 * 1e3;
  return new Date(e.getTime() - n);
}
function Yt() {
  return (performance || Date).now();
}
function K(e = /* @__PURE__ */ new Date()) {
  return e.getTime();
}
function B1(e = /* @__PURE__ */ new Date(), t = "yyyy-mm-dd hh:ii:ss.SSS") {
  return Ft(e, t);
}
function N(e) {
  return !Gn(e.valueOf());
}
const Ge = 864e5;
function Jn(e) {
  return e > 1e12;
}
function q1(e) {
  return e > 1e9 && !Jn(e);
}
function de(e) {
  if (e == null)
    return /* @__PURE__ */ new Date(NaN);
  if (e instanceof Date)
    return new Date(e);
  if (typeof e == "string") {
    const n = e.match(
      /^(\d{4})[-/.]?(\d{1,2})?[-/.]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?[zZ]?$/
    );
    if (n && n[1] && n[2]) {
      const r = parseInt(n[1]), s = n[2] ? Math.max(parseInt(n[2]) - 1, 0) : 0, i = n[3] ? parseInt(n[3]) : 1, o = n[4] ? parseInt(n[4]) : 0, a = n[5] ? parseInt(n[5]) : 0, c = n[6] ? parseInt(n[6]) : 0, u = n[7] ? parseInt(n[7].substring(0, 3)) : 0;
      return /Z$/i.test(e) ? new Date(Date.UTC(r, s, i, o, a, c, u)) : new Date(r, s, i, o, a, c, u);
    } else
      return /* @__PURE__ */ new Date(NaN);
  }
  if (Array.isArray(e))
    return new Date(
      e[0],
      Math.max(e[1] - 1, 0),
      e[2] || 1,
      e[3] || 0,
      e[4] || 0,
      e[5] || 0,
      e[6] || 0
    );
  const t = Jn(e);
  return new Date(t ? e : e * 1e3);
}
function W1(e, t = 3) {
  const n = Math.max(e.length, 6);
  let r = "";
  for (let i = 0; i < n - 4; i++)
    r += e[i] || "0";
  const s = [
    r,
    "" + (e[n - 4] || "0") + (e[n - 3] || "0"),
    "" + (e[n - 2] || "0") + (e[n - 1] || "0")
  ];
  switch (t) {
    case 1:
      return s[0];
    case 2:
      return s[0] + ":" + s[1];
    case 3:
      return s[0] + ":" + s[1] + ":" + s[2];
  }
}
function H1(e, t = 3) {
  const n = Math.max(e.length, 6);
  let r = 0;
  for (let o = 0; o < n - 4; o++)
    r = r * 10 + (e[o] || 0);
  const s = [
    Math.floor(r),
    Math.floor((e[n - 4] || 0) * 10 + (e[n - 3] || 0)),
    Math.floor((e[n - 2] || 0) * 10 + (e[n - 1] || 0))
  ];
  let i = "";
  switch (t) {
    case 1:
      s[0] ? i += s[0] + "小时" : (s[1] || s[2]) && (i += "1小时");
      break;
    case 2:
      s[0] && (i += s[0] + "小时"), s[1] ? i += s[1] + "分钟" : s[2] && (i += "1分钟");
      break;
    case 3:
    default:
      s[0] && (i += s[0] + "小时"), (s[1] || s[2]) && (i += s[1] + "分钟"), s[2] && (i += s[2] + "秒");
      break;
  }
  return i || "0秒";
}
function Ut(e) {
  const t = Math.max(e.length, 6);
  let n = 0;
  n += (e[t - 2] || 0) * 10 + (e[t - 1] || 0), n += ((e[t - 4] || 0) * 10 + (e[t - 3] || 0)) * 60;
  let r = 0;
  for (let s = 0; s < t - 4; s++)
    r = r * 10 + (e[s] || 0);
  return n += r * 60 * 60, Math.floor(Math.max(0, n));
}
function mt(e, t = !1) {
  let n = 0;
  typeof e == "number" ? n = e : n = Ut(e);
  const r = [], s = n % 60;
  r.unshift(s % 10), r.unshift(Math.floor(s / 10)), n = Math.floor(n / 60);
  const i = n % 60;
  if (r.unshift(i % 10), r.unshift(Math.floor(i / 10)), n = Math.floor(n / 60), t) {
    const o = n % 100;
    for (r.unshift(o % 10), r.unshift(Math.floor(o / 10)), n = Math.floor(n / 100); n; )
      r.unshift(n % 10), n = Math.floor(n / 10);
  } else {
    const o = n % 24;
    r.unshift(o % 10), r.unshift(Math.floor(o / 10));
  }
  return r;
}
function V1(e, t = !1) {
  const n = Os(e);
  let r = 0, s = 0, i = 0;
  for (let o = 0, a = Math.max(n.length, 3); o < a; o++) {
    const c = Math.floor(Math.abs(n[o] || 0));
    o == 0 ? t ? r = c : r = c % 24 : o == 1 ? s = c : o == 2 && (i = c);
  }
  return mt(r * 60 * 60 + s * 60 + i, t);
}
function G1(e) {
  const t = e.getHours(), n = e.getMinutes(), r = e.getSeconds();
  return mt(t * 60 * 60 + n * 60 + r);
}
function X1(e, t = !1) {
  const n = e[0] || 0, r = e[1] || 0, s = e[2] || 0;
  return mt(n * 60 * 60 + r * 60 + s, t);
}
function Z1(e, t, n = !1) {
  const r = (N(e) && N(t) ? Math.abs(t.getTime() - e.getTime()) : 0) / 1e3;
  return mt(r, n);
}
function J1(e, t = 1, n = !1) {
  return e[e.length - 1] += t, mt(e, n);
}
function Y1(e, t = 1, n = !1) {
  return e[e.length - 1] -= t, mt(e, n);
}
function K1(e, t) {
  Ps(t, e);
}
function Q1(e, t, n) {
  const r = Ut(e), s = Ut(t), i = Ut(n);
  return s >= r ? i >= r && i <= s : i >= r || i <= s;
}
function mn(e, t) {
  if (!N(e))
    throw new Error(`Date(${e}) is Invalid !`);
  if (!N(t))
    throw new Error(`Date(${t}) is Invalid !`);
  return Math.ceil((t.getTime() - e.getTime()) / Ge);
}
function tu(e, t, n) {
  return !(!N(e) || !N(t) || !N(n) || mn(e, n) < 0 || mn(n, t) < 0);
}
function Ft(e, t = "yyyy-mm-dd hh:ii:ss") {
  if (!N(e))
    return "";
  const n = /(y+)/.exec(t);
  if (n && n[1]) {
    const s = n[1];
    t = t.replace(
      s,
      // (date.getFullYear() + "").substring(Math.max(4 - year.length, 0))
      (e.getFullYear() + "").substring(4 - s.length)
    );
  }
  const r = {
    "m+": e.getMonth() + 1,
    //月份
    "d+": e.getDate(),
    //日
    "h+": e.getHours(),
    //小时
    "i+": e.getMinutes(),
    //分
    "s+": e.getSeconds(),
    //秒
    "q+": Math.floor((e.getMonth() + 3) / 3),
    // 季度
    "S+": e.getMilliseconds()
    //毫秒
  };
  for (const s in r) {
    const i = new RegExp("(" + s + ")").exec(t);
    if (i && i[1]) {
      const o = i[1];
      t = t.replace(
        o,
        // d.length == 1 ? "" + o[k] : ("00" + o[k]).substring(("" + o[k]).length)
        // d.length == 1
        //   ? "" + o[k]
        //   : ("00" + o[k]).substring(("" + o[k]).length - d.length + 2)
        o.length === 1 ? "" + r[s] : ("00" + r[s]).slice(-o.length)
      );
    }
  }
  return t;
}
function eu(e = "yyyy-mm-dd hh:ii:ss") {
  return (t) => Ft(t, e);
}
function nu(e, t = "-") {
  return Ft(e, `yyyy${t}mm${t}dd`);
}
function ru(e, t = ":") {
  return Ft(e, `hh${t}ii${t}ss`);
}
function su(e) {
  return N(e) ? e.toTimeString().slice(0, 8) : "";
}
function iu(e, t = "-", n = ":") {
  return Ft(
    e,
    `yyyy${t}mm${t}dd hh${n}ii${n}ss`
  );
}
function ou(e) {
  return N(e) ? [0, 6].indexOf(e.getDay()) !== -1 : !1;
}
function au(e) {
  return N(e) ? Math.floor(
    (e.getTime() - new Date(e.getFullYear(), 0, 0).getTime()) / Ge
  ) : -1;
}
function Us(e, t) {
  return new Date(e, t, 0).getDate();
}
function zs(e, t) {
  const n = new Date(e, t, 1);
  return n.setHours(0, 0, 0, 0), n.getTime() - 1;
}
function cu(e, t) {
  return zs(e, t) + 1;
}
function js(e, t) {
  const n = new Date(e, t - 1, 1);
  return n.setHours(0, 0, 0, 0), n.getTime();
}
function uu(e, t) {
  return js(e, t) - 1;
}
function lu(e, t = 1) {
  const n = typeof e == "string" ? de(e) : new Date(e);
  n.setHours(0, 0, 0, 0);
  const r = new Date(n);
  return n.setMonth(n.getMonth() + t), n.getDate() < r.getDate() && n.setDate(0), new Date(n.getTime() - 1);
}
function hu(e, t = 1, n = !1) {
  const r = typeof e == "string" ? de(e) : new Date(e);
  r.setHours(0, 0, 0, 0);
  const s = new Date(r);
  return r.setMonth(r.getMonth() + t), r.getDate() < s.getDate() ? (r.setDate(0), r) : n ? r : new Date(r.getTime() - 1);
}
function It(e, t = 1) {
  const n = typeof e == "string" ? de(e) : e;
  return new Date(n.getTime() + t * Ge);
}
function St(e) {
  const t = e.getFullYear(), n = e.getMonth() + 1, r = e.getDate();
  let s = e.getDay();
  return s == 0 && (s = 7), {
    year: t,
    month: n,
    day: r,
    weekday: s,
    monthDays: Us(t, n),
    date: new Date(e)
  };
}
function fu(e = "") {
  const t = [], n = St(
    typeof e == "string" ? e != "" ? de(e) : /* @__PURE__ */ new Date() : e
  );
  function r(s, i) {
    if (s.month !== n.month)
      return;
    const o = [];
    i == "forward" ? t.unshift(o) : t.push(o), o.push(s);
    let a = s;
    for (let c = s.weekday - 1; c >= 1; c--)
      a = St(It(a.date, -1)), o.unshift(a);
    a = s;
    for (let c = s.weekday + 1; c <= 7; c++)
      a = St(It(a.date, 1)), o.push(a);
    o[0].day > 1 && (i == "both" || i == "forward") && r(St(It(o[0].date, -1)), "forward"), o[6].day < n.monthDays && (i == "both" || i == "backward") && r(St(It(o[6].date, 1)), "backward");
  }
  return r(n, "both"), t;
}
function du() {
  T.OPEN_LOG = !0;
}
function pu() {
  T.OPEN_LOG = !1;
}
function mu(e) {
  T.LOG_UPLOAD_FN = e;
}
function gt() {
  return !!T.OPEN_LOG;
}
function Xe(e) {
  T.LOG_UPLOAD_FN && T.LOG_UPLOAD_FN(e);
}
function E(e) {
  Xe({ level: "info", msg: e }), gt() && (!console || typeof console != "object" || typeof console.log != "function" || console.log(e));
}
function Bs(e) {
  Xe({ level: "warn", msg: e }), gt() && (!console || typeof console != "object" || typeof console.warn != "function" || console.warn(e));
}
function gu(e) {
  Xe({ level: "error", msg: e }), gt() && (!console || typeof console != "object" || typeof console.error != "function" || console.error(e));
}
const $t = {}, gn = {
  start: (e) => {
    gt() && (!console || typeof console != "object" || // typeof console.group !== "function"
    typeof console.groupCollapsed != "function" || console.groupCollapsed(e));
  },
  end: () => {
    !console || typeof console != "object" || typeof console.groupEnd != "function" || console.groupEnd();
  }
}, Kt = {
  start: (e) => {
    gt() && ($t[e] = Yt());
  },
  end: (e) => {
    $t[e] && (E(`${e}: ${Yt() - $t[e]} ms`), delete $t[e]);
  }
}, yn = {
  start: (e) => {
    gt() && (!console || typeof console != "object" || typeof console.profile != "function" || console.profile(e));
  },
  end: (e) => {
    !console || typeof console != "object" || typeof console.profileEnd != "function" || console.profileEnd(e);
  }
}, qs = () => {
}, yu = (e) => e, Yn = (e) => () => e, wu = Yn(!0), bu = Yn(!1), Su = (e) => ({ value: e, done: !0 });
function Ws(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function Au(e, t, n) {
  return Object.assign({}, n, { [e]: t });
}
const Kn = 300;
function Hs(e, t = Kn, n) {
  const r = typeof n?.leading == "boolean" ? n.leading : !0, s = typeof n?.trailing == "boolean" ? n.trailing : !1;
  let i = !0, o;
  return function(...c) {
    if (!i) {
      o = c;
      return;
    }
    i = !1, r && e.apply(n?.thisArg || this, c), s && (o = c), setTimeout(() => {
      s && e.apply(n?.thisArg || this, o), o = void 0, i = !0;
    }, t);
  };
}
function Vs(e, t = Kn, n) {
  let r, s = 0;
  return function(...o) {
    let a = !!n?.immediate && !r;
    !a && n?.throttle && (a = !!s && Yt() - s >= t), r && clearTimeout(r);
    const c = () => {
      e.apply(n?.thisArg || this, o), n?.throttle && (s = Yt());
    };
    r = setTimeout(() => {
      a || c(), r = void 0;
    }, t), a && c();
  };
}
function Gs(e, ...t) {
  const n = e.length;
  return t = t || [], function(...r) {
    const s = t.concat(Array.prototype.slice.call(r));
    return s.length < n ? Gs.call(this, e, ...s) : e.apply(this, s);
  };
}
function Xs(...e) {
  return e.length === 0 ? (...t) => t : e.length === 1 ? e[0] : e.reduce(
    (t, n) => (...r) => t(n(...r))
  );
}
const xu = (...e) => e.length === 0 ? (...t) => t : e.length === 1 ? e[0] : e.reduceRight(
  (t, n) => (...r) => t(n(...r))
), _u = (...e) => e.length === 0 ? (...t) => t : e.length === 1 ? e[0] : e.reduceRight(
  (t, n) => (...r) => n(...r, t),
  qs
);
function Ou(e) {
  for (; e && e instanceof Function; )
    e = e();
  return e;
}
function Tu(e) {
  let t, n = !1;
  const r = [];
  return function(...i) {
    if (r.push(i), !n) {
      for (n = !0; r.length; )
        t = e.apply(this, r.shift());
      return n = !1, t;
    }
  };
}
function vu(e, t) {
  return function(...n) {
    return e.apply(t || this, n.reverse());
  };
}
function Ru(e, t) {
  let n = !1, r;
  return async function(...s) {
    return n || (n = !0, r = await e.apply(t || this, s)), r;
  };
}
function Zs(e = 0, t) {
  const n = t?.min || 300, r = t?.max || 6e4, s = t?.exponent || 2, i = t?.factor || 0.5;
  let o = n * Math.pow(s, e);
  if (i) {
    const a = Math.random(), c = Math.floor(a * i * o);
    o = Math.floor(a * 10) & 1 ? o + c : o - c;
  }
  return Math.min(o, r) | 0;
}
function Qn(e, t = 3, n, r) {
  return async function(...s) {
    const i = `retry(${e.name})(${s.map((a) => I(a))})`;
    let o;
    for (let a = 0; a < t; a++)
      try {
        return await e.call(r || this, ...s);
      } catch (c) {
        E(`(${i}) 第 ${a + 1} 次尝试失败, retrying...`), o = c, await new Promise(
          (u) => setTimeout(
            u,
            typeof n == "number" ? n : Zs(a)
            // : 300 * Math.pow(2, attempt)
          )
        );
      }
    throw E(
      `(${i}) 已 ${t} 次失败，不再重试。 Last error: ${I(
        o
      )}`
    ), o;
  };
}
function tr(e, t = 60, n = new Ve(), r) {
  return async function(...s) {
    const i = `cache(${e.name})(${s.map((u) => I(u))})`, o = Date.now();
    t && n.update((u, l) => o - l.timestamp < t * 1e3);
    const a = je(s), c = n.get(a);
    if (c) {
      if (!t || o - c.timestamp < t * 1e3)
        return E(`${i} 击中缓存`), c.value;
      n.delete(a);
    }
    try {
      E(`${i} 没有缓存, 尝试立即执行...`);
      const l = await e.call(r || this, ...s);
      return E(`${i} 缓存设置成功`), n.set(a, {
        value: l,
        timestamp: Date.now()
      }), l;
    } catch (u) {
      throw E(`${i} 执行失败 : ${I(u)}`), u;
    }
  };
}
function Js(e, t = new Ve(), n) {
  return async function(...r) {
    const s = je(r), i = `memorize(${e.name})(${r.map((a) => I(a))})`, o = await t.get(s);
    if (o)
      return E(`${i} memorize hit: ${I(o)}`), o;
    try {
      E(`${i} memorize miss, await fetching fresh data...`);
      const a = await e.call(n || this, ...r);
      return E(`${i} memorize settled`), await t.set(s, a), a;
    } catch (a) {
      throw E(`${i} returns error: ${I(a)}`), a;
    }
  };
}
function Ze(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError("Expected a function");
  const n = function(...r) {
    const s = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(s))
      return i.get(s);
    const o = e.apply(this, r);
    return n.cache = i.set(s, o) || i, o;
  };
  return n.cache = new (Ze.Cache || Ct)(), n;
}
Ze.Cache = Ct;
const Ys = 500;
function Eu(e) {
  const t = Ze(e, function(r) {
    return n.size === Ys && n.clear(), r;
  }), n = t.cache;
  return t;
}
function Cu(e, t) {
  const { ignoreResult: n = () => !1 } = t || {};
  return async (...r) => {
    for (let s = 0, i = e.length; s < i; s++)
      try {
        const o = await e[s](...r);
        if (!n(o))
          return o;
      } catch (o) {
        t?.onError?.(o);
      }
    throw new Error("tryEach failed. No function returned a value");
  };
}
function Fu(e, t, n) {
  return function(...r) {
    return e.apply(this, r) ? t.apply(this, r) : n.apply(this, r);
  };
}
function ku(e, t) {
  return function(...n) {
    try {
      return e.apply(this, n);
    } catch (r) {
      return t.apply(this, r);
    }
  };
}
function Pu(e) {
  return (t) => (E(e + ": " + t), t);
}
function Du(e, t) {
  return function(n) {
    return e.call(this, t(n));
  };
}
const Mu = (e) => (t) => t.map(e), Lu = (e) => (t, n) => t.reduce(e, n);
function Ks(e, t) {
  return function(n) {
    return e(t(n));
  };
}
function Iu(e, t, n) {
  return n = Math.max(n === void 0 ? e.length - 1 : n, 0), function(...r) {
    const s = Math.max(r.length - n, 0), i = Array(s);
    let o = -1;
    for (; ++o < s; )
      i[o] = r[n + o];
    o = -1;
    const a = Array(n + 1);
    for (; ++o < n; )
      a[o] = r[o];
    return a[n] = t(i), Ws(e, this, a);
  };
}
const er = "[object Undefined]", nr = "[object Null]", rr = "[object Boolean]", Qs = "[object Number]", ti = "[object BigInt]", sr = "[object String]", ir = "[object Symbol]", ei = "[object Function]", ni = "[object GeneratorFunction]", ri = "[object Array]", si = "[object Map]", ii = "[object Set]", oi = "[object Date]";
function $(e) {
  return Object.prototype.toString.call(e);
}
function $u(e, t) {
  return t != null && e instanceof t;
}
function Nu(e) {
  const t = typeof e;
  return t !== "object" ? t : $(e).replace(/^\[object (\S+)\]$/, "$1").toLowerCase();
}
function Uu(e) {
  return $(e) === er;
}
function zu(e) {
  return $(e) === nr;
}
function ai(e) {
  return e != null;
}
function ju(e) {
  return $(e) === rr;
}
function ci(e) {
  return $(e) === sr;
}
function Bu(e) {
  return e === e + 0;
}
function qu(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function ui(e) {
  return $(e) === ir;
}
function Wu(e) {
  const t = e ? Symbol.prototype : void 0, n = t ? t.valueOf : void 0;
  return n ? Object(n.call(e)) : {};
}
function Je(e) {
  const t = $(e);
  return t === er || t === nr || t === rr || t === Qs || t === sr || t === ir || t === ti;
}
function Q(e) {
  const t = $(e);
  return t == ei || t == ni;
}
function Hu(e) {
  return Q(e) && Object.prototype.hasOwnProperty.call(e, "toString");
}
function Vu(e) {
  return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(
    ar(e)
  ) != null;
}
function zt(e) {
  if (!yt(e))
    return !1;
  const t = /[\\^$.*+?()[\]{}|]/g, n = /^\[object .+?Constructor\]$/, r = RegExp(
    "^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(t, "\\$&").replace(
      /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
      "$1.*?"
    ) + "$"
  );
  return (Q(e) ? r : n).test(ar(e));
}
function li(e, t) {
  return e?.[t];
}
function Ye(e, t) {
  const n = li(e, t);
  return zt(n) ? n : void 0;
}
function Gu() {
  return Ye(Object, "create");
}
const jt = Ye(T, "Map"), or = Ye(T, "WeakMap");
function j(e) {
  return $(e) === ri;
}
function Xu(e) {
  return e != null && typeof e.length == "number" && e.length > -1 && e.length % 1 == 0 && e.length <= Number.MAX_SAFE_INTEGER && !Q(e);
}
function yt(e) {
  const t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function U(e) {
  return !!e && typeof e == "object";
}
function M(e) {
  return U(e) && !j(e);
}
function Zu(e) {
  return U(e) ? Object == e.constructor : !1;
}
function hi(e) {
  const t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Ju(e) {
  const t = e && e.constructor, n = typeof t == "function" && t.prototype || Object.prototype;
  return e === n;
}
const Yu = Ks(Object.getPrototypeOf, Object);
function Ku(e) {
  if (!e || !e.hasOwnProperty)
    return !1;
  const t = ["value", "initializer", "get", "set"];
  for (let n = 0, r = t.length; n < r; n++)
    if (Object.hasOwnProperty.call(e, t[n]))
      return !0;
  return !1;
}
const Qu = (e) => {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t))
      return !1;
  return !0;
};
function t2(e) {
  return typeof Promise < "u" && e instanceof Promise || yt(e) && typeof e.then == "function" && typeof e.catch == "function";
}
function fi(e) {
  return yt(e) && typeof e.next == "function";
}
function e2(e) {
  const t = e.constructor;
  return t ? (t.name || t.displayName) === "GeneratorFunction" : !1;
}
function n2(e) {
  return e && Q(Symbol) ? Q(e[Symbol.iterator]) : j(e);
}
function r2(e) {
  return U(e) && $(e) == si;
}
function s2(e) {
  return U(e) && $(e) == ii;
}
function i2(e) {
  return U(e) && $(e) == oi;
}
function o2(e) {
  return e === e && !yt(e);
}
function kt(e) {
  const t = [];
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
  return t;
}
function a2(e) {
  const t = [];
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.push(e[n]);
  return t;
}
function c2(e) {
  const t = [];
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.push([n, e[n]]);
  return t;
}
function u2(e) {
  const t = {};
  return kt(e).forEach(
    (n) => t[n] = Object.getOwnPropertyDescriptor(e, n)
  ), t;
}
function l2(e, t) {
  if (ui(e)) {
    do {
      if (t === Object.prototype)
        return typeof t[e] < "u";
      if (Object.prototype.hasOwnProperty.call(t, e))
        return !0;
    } while (t = Object.getPrototypeOf(t));
    return !1;
  } else
    return e in t;
}
function Bt(e, t, n = !0) {
  if (M(e) && M(t))
    for (const r of kt(t))
      (n || typeof e[r] > "u") && (e[r] = t[r]);
  return e;
}
function di(e, t, n = !0) {
  if (M(e) && M(t))
    for (const r of kt(t))
      (n || typeof e[r] > "u") && (M(e[r]) && M(t[r]) ? di(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function pi(e) {
  Object.freeze(e), Object.keys(e).forEach((t) => {
    yt(e[t]) && pi(e[t]);
  });
}
function h2(e) {
  const t = Object.entries(e).slice(0), n = t.length;
  let r = -1;
  const s = n - 1;
  for (; ++r < n; ) {
    const i = r + Math.floor(Math.random() * (s - r + 1)), o = t[i];
    t[i] = t[r], t[r] = o;
  }
  return Object.fromEntries(t);
}
function f2(e, t = {}) {
  const n = Symbol("isa");
  function r(s) {
    for (const i of Reflect.ownKeys(e))
      Object.defineProperty(s.prototype, i, {
        value: e[i],
        writable: !0
      });
    return Object.defineProperty(s.prototype, n, { value: !0 }), s;
  }
  for (const s of Reflect.ownKeys(t))
    Object.defineProperty(r, s, {
      value: t[s],
      enumerable: Object.propertyIsEnumerable.call(t, s)
    });
  return Object.defineProperty(r, Symbol.hasInstance, {
    value: (s) => !!s[n]
  }), r;
}
function d2(...e) {
  class t {
    constructor() {
      for (const r of e)
        Bt(this, new r(), !0);
    }
  }
  for (const n of e)
    Bt(t, n, !0), Bt(t.prototype, n.prototype, !0);
  return t;
}
function p2(e) {
  try {
    postMessage(e, "*");
  } catch (t) {
    if (t?.code === 25)
      return !1;
  }
  return !0;
}
function m2(e, t) {
  return Je(e) || Q(e) ? t = e : j(e) ? t = [...e] : t ? (Object.setPrototypeOf(t, e), Bt(t, e, !0)) : t = Object.create(
    Object.getPrototypeOf(e),
    Object.getOwnPropertyDescriptors(e)
  ), t;
}
function g2(e, ...t) {
  return new e.constructor(...t);
}
function it(e, t = new or()) {
  if (!yt(e))
    return e;
  if (t.has(e))
    return t.get(e);
  let n;
  const r = e.constructor;
  if (Q(e) ? n = e : r === Array ? n = [] : r === jt ? n = new jt() : r === Set ? n = /* @__PURE__ */ new Set() : r === RegExp ? n = hs(e) : r === Date ? n = new Date(e.getTime()) : typeof ArrayBuffer < "u" && r === ArrayBuffer ? n = qe(e) : r === Promise ? n = new Promise((s, i) => {
    e.then(
      (o) => {
        s(it(o, t));
      },
      (o) => {
        i(it(o, t));
      }
    );
  }) : r === Error ? n = Object.create(e) : n = Object.create(
    Object.getPrototypeOf(e)
    // Object.getOwnPropertyDescriptors(from)
  ), e instanceof jt)
    e.forEach((s, i) => {
      n.set(it(i, t), it(s, t));
    });
  else if (e instanceof Set)
    e.forEach((s) => {
      n.add(it(s, t));
    });
  else
    for (const s in e)
      try {
        Object.getOwnPropertyDescriptor(e, s) && (n[s] = it(e[s], t));
      } catch (i) {
        if (i instanceof TypeError)
          continue;
        if (i instanceof ReferenceError)
          continue;
      }
  if (Object.getOwnPropertySymbols) {
    const s = Object.getOwnPropertySymbols(e);
    for (let i = 0, o = s.length; i < o; i++) {
      const a = s[i], c = Object.getOwnPropertyDescriptor(e, a);
      c && (n[a] = it(e[a], t), Object.defineProperty(n, a, c));
    }
  }
  return t.set(e, n), n;
}
function y2(e) {
  if (e === null)
    return null;
  class t {
  }
  return t.prototype = e, new t();
}
function w2(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e;
}
function b2(e, t) {
  return e.__proto__ = t, e;
}
function mi(e, t) {
  return e === t || e !== e && t !== t;
}
function gi(e, t) {
  if (e === t)
    return !0;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const s of n) {
    const i = e[s], o = t[s], a = M(i) && M(o);
    if (a && !gi(i, o) || !a && i !== o)
      return !1;
  }
  return !0;
}
function S2(e, t) {
  return e.bind ? e.bind(t) : function(...r) {
    return e.apply(t, r);
  };
}
function A2(e) {
  const t = new or();
  return new Proxy(e, {
    get(n, r) {
      const s = Reflect.get(n, r);
      return typeof s != "function" ? s : (t.has(s) || t.set(s, s.bind(n)), t.get(s));
    }
  });
}
function x2(e, t) {
  if (!M(e))
    return e;
  for (const n in t)
    Object.prototype.hasOwnProperty.call(t, n) && delete e[n];
  return e;
}
function _2(e, t) {
  if (!M(e))
    return e;
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && !t(n, e[n]) && delete e[n];
  return e;
}
function O2(e, t) {
  const n = {};
  return M(e) && t.forEach((r) => {
    Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  }), n;
}
function T2(e) {
  return M(e) && kt(e).forEach((t) => {
    delete e[t];
  }), e;
}
function I(e, t = `\r
`, n = 6, r = 1) {
  if (ci(e))
    return `"${e}"`;
  if (Je(e))
    return "" + e;
  if (Q(e))
    return "[Fn]";
  if (r > n)
    return j(e) ? "[...]" : "{...}";
  let s = "", i = "";
  for (let o = 0; o < r; o++)
    s += "  ", o > 0 && (i += "  ");
  return j(e) ? `[${e.map(
    (o) => t + s + I(o, t, n, r + 1)
  ).join(", ")}${t}${i}]` : `{${kt(e).map(
    (o) => `${t}${s}${o}: ${I(
      e[o],
      t,
      n,
      r + 1
    )}`
  ).join(", ")}${t}${i}}`;
}
function ar(e) {
  if (e != null) {
    try {
      return Function.prototype.toString.call(e);
    } catch {
    }
    try {
      return "" + e;
    } catch {
    }
  }
  return "";
}
function v2(e, t = "", n = ["", "sign", "key"]) {
  return M(e) ? Object.keys(e).filter((r) => {
    for (let s = 0, i = n.length; s < i; s++)
      if (e[r] == n[s])
        return !1;
    return !0;
  }).sort().map((r) => `${r}=${e[r]}`).join("&") + t : String(e);
}
function cr(e, t, n = "") {
  let r = [];
  return e === t ? r : typeof e != "object" || typeof t != "object" || !e || !t ? (r.push({
    path: n,
    newValue: t,
    oldValue: e
  }), r) : ((/* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)])).forEach((i) => {
    const o = n ? `${n}.${i}` : i;
    r = r.concat(cr(e[i], t[i], o));
  }), r);
}
function R2(e, t) {
  try {
    return t.split(".").reduce((n, r) => n?.[r], e);
  } catch {
    return;
  }
}
function E2(e, t, n) {
  if (!e || !t)
    return e;
  const r = t.split(".");
  let s = e;
  for (let i = 0, o = r.length - 1; i < o; i++) {
    const a = r[i];
    (!(a in s) || typeof s[a] != "object" || s[a] === null) && (s[a] = {}), s = s[a];
  }
  return s[r[r.length - 1]] = n, e;
}
function C2(e, t) {
  const n = typeof t?.aliveInSeconds == "number" ? Math.max(t.aliveInSeconds, 0) : -1, r = typeof t?.aliveUntilTimestamp == "number" ? Math.max(t.aliveUntilTimestamp, 0) : -1;
  function s(c, u = !1) {
    return Je(c) || j(c) || Q(c) ? { value: c, timestamp: K() } : u && Object.prototype.hasOwnProperty.call(c, "timestamp") ? c : {
      ...c,
      timestamp: K()
    };
  }
  let i = s(e, !0);
  return {
    get: () => {
      let c = !1;
      return (n >= 0 && K() > i.timestamp + n * 1e3 || // 时间戳
      r >= 0 && K() > r) && (c = !0), c && (i.value = void 0), i;
    },
    set: (c) => i = s(c, !1)
  };
}
const yi = () => typeof window == "object" && typeof document == "object", F2 = () => !yi(), k2 = () => typeof process < "u" && process.versions != null && process.versions.node != null, P2 = typeof BigInt < "u", D2 = typeof Symbol < "u", M2 = typeof document < "u", L2 = typeof window < "u", I2 = typeof history < "u";
function $2(e, t) {
  const n = e.split("."), r = t.split(".");
  for (let s = 0, i = n.length; s < i; s++) {
    if (r.length == s)
      return 1;
    if (n[s] != r[s])
      return n[s] > r[s] ? 1 : -1;
  }
  return n.length != r.length ? -1 : 0;
}
const wi = (() => !!(T.Worker && T.Blob && T.Promise && T.OffscreenCanvas && T.OffscreenCanvasRenderingContext2D && T.HTMLCanvasElement && T.HTMLCanvasElement.prototype.transferControlToOffscreen && T.URL && T.URL.createObjectURL))(), N2 = (() => {
  if (!T.OffscreenCanvas)
    return !1;
  const e = new OffscreenCanvas(1, 1), t = e.getContext("2d");
  if (!t)
    return !1;
  t.fillRect(0, 0, 1, 1);
  const n = e.transferToImageBitmap();
  try {
    t.createPattern(n, "no-repeat");
  } catch {
    return !1;
  }
  return !0;
})(), bi = (e, t = 16) => e.toString(t), Si = (e, t = 16) => {
  let n = e.toLowerCase();
  const r = n.indexOf("0b") == 0, s = n.indexOf("0o") == 0, i = n.indexOf("0x") == 0;
  (r || s || i) && (n = n.slice(2)), r && (t = 2), s && (t = 8), i && (t = 16);
  const o = parseInt(n, t);
  if (isNaN(o))
    throw new Error(`radixStringToNumber(${e}, ${t}) 无法解析！`);
  return o;
};
function Ai(e) {
  return Array.from(new Uint8Array(e));
}
function xi(e) {
  const t = [];
  for (; e > 0; ) {
    const n = e & 255;
    t.unshift(n), e = (e - n) / 256;
  }
  return t;
}
function _i(e) {
  e.toLowerCase().indexOf("0x") == 0 && (e = e.slice(2));
  const t = [];
  for (let n = 0, r = e.length; n < r; n += 2)
    t.push(Si(e.slice(n, n + 2), 16));
  return t;
}
function Oi(e) {
  const t = [];
  for (let n = 0, r = e.length; n < r; n++) {
    const s = e.charCodeAt(n);
    s && t.push(s);
  }
  return t;
}
function U2(e) {
  return new TextEncoder().encode(e);
}
function z2(e) {
  const t = [];
  for (const n of e) {
    const r = n.codePointAt(0);
    r && t.push(r);
  }
  return t;
}
function j2(e) {
  return he(e);
}
function B2(e) {
  return he(xi(e));
}
function q2(e) {
  return he(_i(e));
}
function Ti(e) {
  return he(Oi(e));
}
function vi(e) {
  return Ci(encodeURIComponent(e)).replaceAll("+", "*").replaceAll("/", "-").replaceAll("=", "");
}
function Ri(e) {
  let t = e.replaceAll("*", "+").replaceAll("-", "/");
  const n = t.length % 4;
  return n && (t = t.padEnd(t.length + (4 - n), "=")), decodeURIComponent(hr(t));
}
function W2(e) {
  return vi(Ei(Ai(e)));
}
function H2(e) {
  return Ti(Ri(e));
}
function V2(e) {
  let t = 0;
  for (let n = 0, r = e.length; n < r; n++)
    t = t * 256 + e[n];
  return t;
}
function G2(e) {
  let t = "";
  for (let n = 0, r = e.length; n < r; n++)
    t += bi(e[n], 16).padStart(2, "0");
  return t;
}
function Ei(e) {
  return String.fromCodePoint.apply(null, e);
}
function X2(e) {
  return String.fromCharCode.apply(
    null,
    new Uint16Array(e)
  );
}
function Z2(e, t = Zt.utf8) {
  return new TextDecoder(t).decode(e);
}
function J2(e) {
  return hr(e);
}
function Y2(e, t) {
  const n = t?.mime, r = t?.encode, s = t?.type;
  return s ? new Blob([e], {
    type: s
  }) : n ? r === Zt.base64 ? new Blob([e], { type: `${n};${r}` }) : r === Zt.utf8 ? new Blob([e], {
    type: `${n};charset=${r}`
  }) : new Blob([e], {
    type: `${n}`
  }) : new Blob([e]);
}
const K2 = (e) => {
  let t = J.UNKNOWN;
  switch (new DataView(e).getUint32(0, Ke()).toString(16).toUpperCase()) {
    case "FFD8FFDB":
      t = J.JPEG;
      break;
    case "FFD8FFE0":
    case "FFD8FFE1":
    case "FFD8FFE2":
    case "FFD8FFE3":
      t = J.JPEG;
      break;
    case "89504E47":
      t = J.PNG;
      break;
    case "47494638":
      t = J.GIF;
      break;
    case "52494646":
      t = J.WEBP;
      break;
    case "25504446":
      t = J.PDF;
      break;
    case "504B0304":
      t = J.ZIP;
      break;
  }
  return t;
};
class ur extends Error {
  constructor(t) {
    super(t);
  }
}
const lr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function Ci(e) {
  const t = String(e);
  let n = "";
  for (
    let r = 0, s, i = 0, o = lr;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    t.charAt(i | 0) || (o = "=", i % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    n += o.charAt(63 & r >> 8 - i % 1 * 8)
  ) {
    if (s = t.charCodeAt(i += 3 / 4), s > 255)
      throw new ur(
        "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range."
      );
    r = r << 8 | s;
  }
  return n;
}
function hr(e) {
  const t = String(e).replace(/[=]+$/, "");
  if (t.length % 4 === 1)
    throw new ur(
      "'atob' failed: The string to be decoded is not correctly encoded."
    );
  let n = "";
  for (
    let r = 0, s = 0, i, o = 0;
    // get next character
    i = t.charAt(o++);
    // eslint-disable-line no-cond-assign
    // character found in table? initialize bit storage and add its ascii value;
    ~i && (s = r % 4 ? s * 64 + i : i, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    r++ % 4) ? n += String.fromCharCode(255 & s >> (-2 * r & 6)) : 0
  )
    i = lr.indexOf(i);
  return n;
}
function Ke() {
  const e = Uint32Array.of(305419896), t = new Uint8Array(e.buffer);
  switch (t[0] * 16777216 + t[1] * 65536 + t[2] * 256 + t[3]) {
    case 305419896:
      return !1;
    case 2018915346:
      return !0;
  }
}
function Q2(e, t, n = Ke()) {
  const r = e.getUint32(t, n), s = e.getUint32(t + 4, n), i = n ? r + 2 ** 32 * s : 2 ** 32 * r + s;
  return Number.isSafeInteger(i) || console.warn(i, "exceeds MAX_SAFE_INTEGER. Precision may be lost"), i;
}
function tl(e, t, n = Ke()) {
  const r = BigInt(32);
  BigInt(0);
  const s = BigInt(e.getUint32(t | 0, !!n) >>> 0), i = BigInt(
    e.getUint32((t | 0) + 4 | 0, !!n) >>> 0
  );
  return n ? i << r | s : s << r | i;
}
function ut(e) {
  let t = "";
  return {
    match: (n) => (t = `"${String(n)}"不能为空`, n != null && n !== ""),
    error: e || t
  };
}
function Fi(e, t) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"不能小于"${e}"`, r >= e),
    error: t || n
  };
}
function ki(e, t) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"不能大于"${e}"`, r <= e),
    error: t || n
  };
}
function el(e, t) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"的长度不能小于"${e}"`, rt(r) >= e),
    error: t || n
  };
}
function nl(e, t) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"的长度不能大于"${e}"`, rt(r) <= e),
    error: t || n
  };
}
function Pi(e, t) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"的长度必须为"${e}"`, rt(r) == e),
    error: t || n
  };
}
function Di(e) {
  return {
    match: (t) => Rt("email", t),
    error: e || "邮箱格式不正确"
  };
}
function Mi(e) {
  return {
    match: (t) => Rt("mobile-china", t),
    error: e || "手机格式不正确"
  };
}
function Li(e) {
  return {
    match: (t) => Rt("date", t),
    error: e || "日期格式不正确"
  };
}
function Ii(e) {
  return {
    match: (t) => Rt("time", t),
    error: e || "时间格式不正确"
  };
}
function $i(e) {
  return {
    match: (t) => Rt("datetime", t),
    error: e || "时间格式不正确"
  };
}
function Ni(e, t) {
  let n = "";
  return {
    match: (r) => (n = `"${r}" 不在 "${e}" 范围内`, e.some((s) => s === r)),
    error: t || n
  };
}
function tt(e, t) {
  const n = t.reduce((r, s) => {
    const { match: i, error: o } = s;
    return i(e) || r.push(o), r;
  }, []);
  return {
    valid: n.length === 0,
    errors: n
  };
}
class rl {
  criterias = [];
  constructor(t = []) {
    t.forEach((n) => this.add(n));
  }
  add(...t) {
    this.criterias.push(...t);
  }
  clear() {
    this.criterias = [];
  }
  get() {
    return (t) => tt(t, this.criterias);
  }
  run(t) {
    return this.get()(t);
  }
}
function sl(e) {
  return (t) => {
    const n = tt(t, [
      ut(e?.emptyError || "邮箱不能为空"),
      Di(e?.error || "邮箱格式不正确")
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function il(e) {
  return (t) => {
    const n = tt(t, [
      ut(e?.emptyError || "手机号不能为空"),
      Mi(e?.error || "手机格式不正确")
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function ol(e) {
  return (t) => {
    const n = tt(t, [
      ut(e?.emptyError || "日期不能为空"),
      Li(e?.error || "日期格式不正确")
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function al(e) {
  return (t) => {
    const n = tt(t, [
      ut(e?.emptyError || "时间不能为空"),
      Ii(e?.error || "时间格式不正确")
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function cl(e) {
  return (t) => {
    const n = tt(t, [
      ut(e?.emptyError || "时间不能为空"),
      $i(e?.error || "时间格式不正确")
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function ul(e) {
  return (t) => {
    const n = [ut(e?.emptyError)];
    typeof e?.min == "number" && n.push(Fi(e.min, e?.minError)), typeof e?.max == "number" && n.push(ki(e.max, e?.maxError));
    const r = tt(t, n);
    if (!r.valid && e?.throw)
      throw new Error(r.errors[0]);
    return r;
  };
}
function ll(e, t) {
  return (n) => {
    const r = [
      ut(t?.emptyError || t?.error),
      Pi(e, t?.error)
    ], s = tt(n, r);
    if (!s.valid && t?.throw)
      throw new Error(s.errors[0]);
    return s;
  };
}
function hl(e, t) {
  return (n) => {
    const r = tt(n, [Ni(e, t?.error)]);
    if (!r.valid && t?.throw)
      throw new Error(r.errors[0]);
    return r;
  };
}
function fl(e) {
  const t = String(e).toLowerCase();
  if (t.indexOf("km") >= 0 || t.indexOf("m") >= 0)
    return t;
  const n = parseFloat(t);
  return n < 0 ? "" : n >= 1e3 ? Math.ceil(n / 1e3 * 10) / 10 + "km" : Math.ceil(n) + "m";
}
function dl(e, t = 2) {
  return Xn(e / 100, t);
}
function pl(e, t) {
  const n = e.getReader();
  n.read().then(function r({ done: s, value: i }) {
    return t(i), s ? Promise.resolve(s) : n.read().then(r);
  });
}
var Ee = function(e, t) {
  return Ee = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var s in r)
      Object.prototype.hasOwnProperty.call(r, s) && (n[s] = r[s]);
  }, Ee(e, t);
};
function Qe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Ee(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function Ui(e, t, n, r) {
  function s(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function a(l) {
      try {
        u(r.next(l));
      } catch (h) {
        o(h);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (h) {
        o(h);
      }
    }
    function u(l) {
      l.done ? i(l.value) : s(l.value).then(a, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function fr(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, s, i, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (n = 0)), n; )
      try {
        if (r = 1, s && (i = u[0] & 2 ? s.return : u[0] ? s.throw || ((i = s.return) && i.call(s), 0) : s.next) && !(i = i.call(s, u[1])).done)
          return i;
        switch (s = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, s = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = t.call(e, n);
      } catch (l) {
        u = [6, l], s = 0;
      } finally {
        r = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function Tt(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Qt(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), s, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(s = r.next()).done; )
      i.push(s.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      s && !s.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}
function te(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, s = t.length, i; r < s; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function pt(e) {
  return this instanceof pt ? (this.v = e, this) : new pt(e);
}
function zi(e, t, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), s, i = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", o), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function o(d) {
    return function(g) {
      return Promise.resolve(g).then(d, h);
    };
  }
  function a(d, g) {
    r[d] && (s[d] = function(m) {
      return new Promise(function(y, w) {
        i.push([d, m, y, w]) > 1 || c(d, m);
      });
    }, g && (s[d] = g(s[d])));
  }
  function c(d, g) {
    try {
      u(r[d](g));
    } catch (m) {
      p(i[0][3], m);
    }
  }
  function u(d) {
    d.value instanceof pt ? Promise.resolve(d.value.v).then(l, h) : p(i[0][2], d);
  }
  function l(d) {
    c("next", d);
  }
  function h(d) {
    c("throw", d);
  }
  function p(d, g) {
    d(g), i.shift(), i.length && c(i[0][0], i[0][1]);
  }
}
function ji(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof Tt == "function" ? Tt(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(i) {
    n[i] = e[i] && function(o) {
      return new Promise(function(a, c) {
        o = e[i](o), s(a, c, o.done, o.value);
      });
    };
  }
  function s(i, o, a, c) {
    Promise.resolve(c).then(function(u) {
      i({ value: u, done: a });
    }, o);
  }
}
function P(e) {
  return typeof e == "function";
}
function Bi(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var Ae = Bi(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, s) {
      return s + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function wn(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var tn = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, s, i;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var a = Tt(o), c = a.next(); !c.done; c = a.next()) {
              var u = c.value;
              u.remove(this);
            }
          } catch (m) {
            t = { error: m };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          o.remove(this);
      var l = this.initialTeardown;
      if (P(l))
        try {
          l();
        } catch (m) {
          i = m instanceof Ae ? m.errors : [m];
        }
      var h = this._finalizers;
      if (h) {
        this._finalizers = null;
        try {
          for (var p = Tt(h), d = p.next(); !d.done; d = p.next()) {
            var g = d.value;
            try {
              bn(g);
            } catch (m) {
              i = i ?? [], m instanceof Ae ? i = te(te([], Qt(i)), Qt(m.errors)) : i.push(m);
            }
          }
        } catch (m) {
          r = { error: m };
        } finally {
          try {
            d && !d.done && (s = p.return) && s.call(p);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (i)
        throw new Ae(i);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        bn(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && wn(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && wn(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}();
tn.EMPTY;
function dr(e) {
  return e instanceof tn || e && "closed" in e && P(e.remove) && P(e.add) && P(e.unsubscribe);
}
function bn(e) {
  P(e) ? e() : e.unsubscribe();
}
var pr = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, Ce = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    var s = Ce.delegate;
    return s?.setTimeout ? s.setTimeout.apply(s, te([e, t], Qt(n))) : setTimeout.apply(void 0, te([e, t], Qt(n)));
  },
  clearTimeout: function(e) {
    var t = Ce.delegate;
    return (t?.clearTimeout || clearTimeout)(e);
  },
  delegate: void 0
};
function mr(e) {
  Ce.setTimeout(function() {
    throw e;
  });
}
function Fe() {
}
function qi(e) {
  e();
}
var en = function(e) {
  Qe(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, dr(n) && n.add(r)) : r.destination = Gi, r;
  }
  return t.create = function(n, r, s) {
    return new ke(n, r, s);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(tn), Wi = Function.prototype.bind;
function xe(e, t) {
  return Wi.call(e, t);
}
var Hi = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        Nt(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        Nt(r);
      }
    else
      Nt(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        Nt(n);
      }
  }, e;
}(), ke = function(e) {
  Qe(t, e);
  function t(n, r, s) {
    var i = e.call(this) || this, o;
    if (P(n) || !n)
      o = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: s ?? void 0
      };
    else {
      var a;
      i && pr.useDeprecatedNextContext ? (a = Object.create(n), a.unsubscribe = function() {
        return i.unsubscribe();
      }, o = {
        next: n.next && xe(n.next, a),
        error: n.error && xe(n.error, a),
        complete: n.complete && xe(n.complete, a)
      }) : o = n;
    }
    return i.destination = new Hi(o), i;
  }
  return t;
}(en);
function Nt(e) {
  mr(e);
}
function Vi(e) {
  throw e;
}
var Gi = {
  closed: !0,
  next: Fe,
  error: Vi,
  complete: Fe
}, nn = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Xi(e) {
  return e;
}
function Zi() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return gr(e);
}
function gr(e) {
  return e.length === 0 ? Xi : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, s) {
      return s(r);
    }, n);
  };
}
var st = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var s = this, i = Yi(t) ? t : new ke(t, n, r);
    return qi(function() {
      var o = s, a = o.operator, c = o.source;
      i.add(a ? a.call(i, c) : c ? s._subscribe(i) : s._trySubscribe(i));
    }), i;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = Sn(n), new n(function(s, i) {
      var o = new ke({
        next: function(a) {
          try {
            t(a);
          } catch (c) {
            i(c), o.unsubscribe();
          }
        },
        error: i,
        complete: s
      });
      r.subscribe(o);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[nn] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return gr(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = Sn(t), new t(function(r, s) {
      var i;
      n.subscribe(function(o) {
        return i = o;
      }, function(o) {
        return s(o);
      }, function() {
        return r(i);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Sn(e) {
  var t;
  return (t = e ?? pr.Promise) !== null && t !== void 0 ? t : Promise;
}
function Ji(e) {
  return e && P(e.next) && P(e.error) && P(e.complete);
}
function Yi(e) {
  return e && e instanceof en || Ji(e) && dr(e);
}
function Ki(e) {
  return P(e?.lift);
}
function rn(e) {
  return function(t) {
    if (Ki(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function ee(e, t, n, r, s) {
  return new Qi(e, t, n, r, s);
}
var Qi = function(e) {
  Qe(t, e);
  function t(n, r, s, i, o, a) {
    var c = e.call(this, n) || this;
    return c.onFinalize = o, c.shouldUnsubscribe = a, c._next = r ? function(u) {
      try {
        r(u);
      } catch (l) {
        n.error(l);
      }
    } : e.prototype._next, c._error = i ? function(u) {
      try {
        i(u);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, c._complete = s ? function() {
      try {
        s();
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, c;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(en), to = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function eo(e) {
  return P(e?.then);
}
function no(e) {
  return P(e[nn]);
}
function ro(e) {
  return Symbol.asyncIterator && P(e?.[Symbol.asyncIterator]);
}
function so(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function io() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var oo = io();
function ao(e) {
  return P(e?.[oo]);
}
function co(e) {
  return zi(this, arguments, function() {
    var n, r, s, i;
    return fr(this, function(o) {
      switch (o.label) {
        case 0:
          n = e.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, pt(n.read())];
        case 3:
          return r = o.sent(), s = r.value, i = r.done, i ? [4, pt(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, pt(s)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function uo(e) {
  return P(e?.getReader);
}
function lo(e) {
  if (e instanceof st)
    return e;
  if (e != null) {
    if (no(e))
      return ho(e);
    if (to(e))
      return fo(e);
    if (eo(e))
      return po(e);
    if (ro(e))
      return yr(e);
    if (ao(e))
      return mo(e);
    if (uo(e))
      return go(e);
  }
  throw so(e);
}
function ho(e) {
  return new st(function(t) {
    var n = e[nn]();
    if (P(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function fo(e) {
  return new st(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function po(e) {
  return new st(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, mr);
  });
}
function mo(e) {
  return new st(function(t) {
    var n, r;
    try {
      for (var s = Tt(e), i = s.next(); !i.done; i = s.next()) {
        var o = i.value;
        if (t.next(o), t.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        i && !i.done && (r = s.return) && r.call(s);
      } finally {
        if (n)
          throw n.error;
      }
    }
    t.complete();
  });
}
function yr(e) {
  return new st(function(t) {
    yo(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function go(e) {
  return yr(co(e));
}
function yo(e, t) {
  var n, r, s, i;
  return Ui(this, void 0, void 0, function() {
    var o, a;
    return fr(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), n = ji(e), c.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = c.sent(), !!r.done)
            return [3, 4];
          if (o = r.value, t.next(o), t.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = c.sent(), s = { error: a }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), r && !r.done && (i = n.return) ? [4, i.call(n)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (s)
            throw s.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function wr(e, t) {
  return rn(function(n, r) {
    var s = 0;
    n.subscribe(ee(r, function(i) {
      r.next(e.call(t, i, s++));
    }));
  });
}
var wo = new st(Fe);
function bo(e, t) {
  return rn(function(n, r) {
    var s = 0;
    n.subscribe(ee(r, function(i) {
      return e.call(t, i, s++) && r.next(i);
    }));
  });
}
function So(e, t) {
  return rn(function(n, r) {
    var s = null, i = 0, o = !1, a = function() {
      return o && !s && r.complete();
    };
    n.subscribe(ee(r, function(c) {
      s?.unsubscribe();
      var u = 0, l = i++;
      lo(e(c, l)).subscribe(s = ee(r, function(h) {
        return r.next(t ? t(c, h, l, u++) : h);
      }, function() {
        s = null, a();
      }));
    }, function() {
      o = !0, a();
    }));
  });
}
function ml() {
  return Zi(
    bo((e) => !(e % 2)),
    wr((e) => e + e)
  );
}
function gl(e) {
  return (t) => new st((n) => {
    const r = /* @__PURE__ */ new Set();
    let s = !1;
    const i = t.subscribe({
      next(o) {
        const a = setTimeout(() => {
          n.next(o), r.delete(a), s && r.size === 0 && n.complete();
        }, e);
        r.add(a);
      },
      error(o) {
        n.error(o);
      },
      complete() {
        s = !0, r.size === 0 && n.complete();
      }
    });
    return () => {
      i.unsubscribe();
      for (const o of r)
        clearTimeout(o);
    };
  });
}
function yl(e, t) {
  return e.pipe(So((n) => n ? t : wo));
}
function wl(e, t) {
  return e.pipe(wr((n) => n[t]));
}
function bl(e, t) {
  return e.name == t.name || e.constructor.name == t.name || e instanceof t;
}
class Sl extends Error {
  name;
  response;
  statusCode;
  constructor(t, n) {
    super(t), this.name = "HttpError", this.response = n, this.statusCode = n.status;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      response: this.response,
      statusCode: this.statusCode
    };
  }
}
let Ot;
function Al(e) {
  Ot = e, e(), Ot = null;
}
class Ao {
  subscribers = /* @__PURE__ */ new Set();
  add() {
    Ot && !this.subscribers.has(Ot) && this.subscribers.add(Ot);
  }
  notify(t) {
    this.subscribers.forEach((n) => n(t));
  }
}
const An = /* @__PURE__ */ new WeakMap();
function qt(e, t) {
  let n = An.get(e);
  n || (n = /* @__PURE__ */ new Map(), An.set(e, n));
  let r = n.get(t);
  return r || (r = new Ao(), n.set(t, r)), r;
}
function xo(e, t = ne, n) {
  if (!Array.isArray(e))
    return;
  const r = n?.path || "", s = n?.callback, i = Array.prototype, o = Object.create(i);
  ["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(
    (a) => {
      o[a] = function(...c) {
        const u = this.slice();
        ["push", "unshift", "splice"].includes(a) && (a === "splice" ? c.slice(2) : c).forEach(
          (p, d) => {
            U(p) && (c[d] = t(p, {
              deep: !0,
              path: r,
              callback: s
            }));
          }
        ), i[a].apply(this, c);
        const l = this.slice();
        return s && s({ path: r, newValue: l, oldValue: u }), l;
      };
    }
  ), Object.setPrototypeOf(e, o), e.forEach((a, c) => {
    U(a) && (e[c] = t(a, { deep: !0, path: r, callback: s }));
  });
}
function ne(e, t) {
  const n = typeof t?.deep == "boolean" ? t?.deep : !0, r = t?.path || "", s = t?.callback;
  return Object.keys(e).forEach((i) => {
    const o = qt(e, i);
    let a = e[i];
    const c = r ? `${r}.${String(i)}` : String(i);
    Object.defineProperty(e, i, {
      configurable: !0,
      // 是否可删除、可配置
      enumerable: !0,
      // 是否可枚举
      // 数据描述符
      // value : 默认为 undefined
      // writable : 是否可读写
      // 存取描述符
      get() {
        return n && U(a) && (Array.isArray(a) ? xo(a, ne, {
          callback: (u) => {
            o.notify(u), s && s(u);
          },
          path: c
        }) : ne(a, { deep: !0, path: c })), o.add(), a;
      },
      set(u) {
        if (a !== u) {
          const l = a;
          a = u;
          const h = { path: c, newValue: u, oldValue: l };
          o.notify(h), s && s(h);
        }
      }
    });
  }), e;
}
function xl(e) {
  return e.value ? e.value : typeof e == "function" ? e() : e;
}
function _l(e, t) {
  return ne({ value: e }, t);
}
const _o = br;
function br(e, t) {
  if (!U(e))
    return e;
  const n = typeof t?.deep == "boolean" ? t?.deep : !0, r = t?.path || "", s = t?.callback, i = {
    // 拦截对象属性的读取
    // target 目标对象、key 键值、receiver 当前proxy实例
    get(a, c, u) {
      const l = r ? `${r}.${String(c)}` : String(c);
      let h = Reflect.get(a, c, u);
      const p = qt(a, c);
      if (n && U(h) && !("isYZProxy" in h)) {
        const d = br(h, {
          deep: !0,
          path: l,
          callback: s
        });
        Array.isArray(h) && (d.YZProxyArrayDep = p), h = d;
      }
      return p.add(), h;
    },
    // 拦截对象属性的设置
    // target 目标对象、key 键值、value 值、receiver 当前proxy实例
    set(a, c, u, l) {
      const h = Reflect.get(a, c, l), p = Reflect.set(a, c, u, l);
      if (c == "YZProxyArrayDep")
        return p;
      if (h !== u) {
        let d;
        Array.isArray(a) ? d = a.YZProxyArrayDep : d = qt(a, c);
        const m = { path: r ? `${r}.${String(c)}` : String(c), newValue: u, oldValue: h };
        d.notify(m), s && s(m);
      }
      return p;
    },
    // 拦截 `delete proxy[key]` 的操作，返回一个布尔值
    deleteProperty(a, c) {
      if (!(c in a))
        return !1;
      let l = typeof c == "symbol" ? void 0 : a[c];
      U(l) && (l = Array.isArray(l) ? [...l] : { ...l });
      const h = Reflect.deleteProperty(a, c);
      if (h) {
        let p;
        Array.isArray(a) ? p = a.YZProxyArrayDep : p = qt(a, c);
        const g = { path: r ? `${r}.${String(c)}` : String(c), newValue: void 0, oldValue: l };
        p.notify(g), s && s(g);
      }
      return h;
    },
    // 拦截 `key in proxy` 的操作，返回一个布尔值
    has(a, c) {
      return c === "isYZProxy" || c in a;
    }
    // 拦截 `Object.keys(proxy)`、`for...in` 等循环，返回一个数组
    // ownKeys(target) {
    //   return [];
    // },
    // 拦截 `Object.getOwnPropertyDescriptor(proxy, key)`，返回属性的描述对象
    // getOwnPropertyDescriptor(target, key) {
    //   return {};
    // },
    // 拦截 `Object.defineProperty(proxy, key, desc`，返回一个布尔值
    // defineProperty(target, key, desc) {
    //   return true;
    // },
    // 拦截 `Object.preventExtensions(proxy)`，返回一个布尔值
    // preventExtensions(target) {
    //   return true;
    // },
    // 拦截 `Object.getPrototypeOf(proxy)`，返回一个对象
    // getPrototypeOf(target) {
    //   return {};
    // },
    // 拦截 `Object.isExtensible(proxy)`，返回一个布尔值
    // isExtensible(target) {
    //   return true;
    // },
    // 拦截 `Object.setPrototypeOf(proxy, proto)`，返回一个布尔值
    // setPrototypeOf(target, proto) {
    //   return true;
    // },
    // 拦截 Proxy 实例作为函数调用的操作
    // apply(target, thisArg, args) {
    //   return target.apply(thisArg, args);
    // },
    // 拦截 Proxy 实例作为构造函数调用的操作
    // construct(target, args) {
    //   return {};
    // }
  };
  return new Proxy(e, i);
}
class Ol {
  events;
  constructor() {
    this.events = {};
  }
  isEmpty(t) {
    return this.events[t] == null || this.events[t].length == 0;
  }
  has(t, n) {
    return this.events[t] !== void 0 && this.events[t].indexOf(n) !== -1;
  }
  prependListener(t, n, r) {
    return this.events[t] || (this.events[t] = []), this.events[t].unshift(
      r ? n.bind(r) : n
    ), this;
  }
  addListener(t, n, r) {
    return this.events[t] || (this.events[t] = []), this.events[t].push(
      r ? n.bind(r) : n
    ), this;
  }
  on(t, n, r) {
    return this.addListener(t, n, r), this;
  }
  removeListener(t, n) {
    return this.events[t] && (this.events[t] = this.events[t].filter((r) => r !== n)), this;
  }
  off(t, n) {
    return this.removeListener(t, n), this;
  }
  removeAllListeners(t) {
    return t ? this.events[t] = [] : this.events = {}, this;
  }
  // 注意：handler 自己绑定 this
  emit(t, ...n) {
    return this.events[t] && this.events[t].slice(0).forEach((s) => {
      s(...n);
    }), this;
  }
  once(t, n, r) {
    const s = (...i) => {
      r ? n.apply(r, i) : n(...i), this.off(t, s);
    };
    return this.on(t, s), this;
  }
}
function Tl() {
  const e = /* @__PURE__ */ new Set();
  return {
    subscribe(t) {
      return e.add(t), () => {
        e.delete(t);
      };
    },
    emit(...t) {
      for (const n of e)
        n(...t);
    },
    clear() {
      e.clear();
    }
  };
}
const re = 3.141592653589793 * 3e3 / 180, F = 3.141592653589793, se = 6378245, ie = 0.006693421622965943;
function Sr(e, t) {
  return e < 72.004 || e > 137.8347 || t < 0.8293 || t > 55.8271 || !1;
}
function Ar(e, t) {
  let n = -100 + 2 * e + 3 * t + 0.2 * t * t + 0.1 * e * t + 0.2 * Math.sqrt(Math.abs(e));
  return n += (20 * Math.sin(6 * e * F) + 20 * Math.sin(2 * e * F)) * 2 / 3, n += (20 * Math.sin(t * F) + 40 * Math.sin(t / 3 * F)) * 2 / 3, n += (160 * Math.sin(t / 12 * F) + 320 * Math.sin(t * F / 30)) * 2 / 3, n;
}
function xr(e, t) {
  let n = 300 + e + 2 * t + 0.1 * e * e + 0.1 * e * t + 0.1 * Math.sqrt(Math.abs(e));
  return n += (20 * Math.sin(6 * e * F) + 20 * Math.sin(2 * e * F)) * 2 / 3, n += (20 * Math.sin(e * F) + 40 * Math.sin(e / 3 * F)) * 2 / 3, n += (150 * Math.sin(e / 12 * F) + 300 * Math.sin(e / 30 * F)) * 2 / 3, n;
}
function Oo(e, t) {
  if (Sr(e, t))
    return [e, t];
  {
    let n = xr(e - 105, t - 35), r = Ar(e - 105, t - 35);
    const s = t / 180 * F;
    let i = Math.sin(s);
    i = 1 - ie * i * i;
    const o = Math.sqrt(i);
    n = n * 180 / (se / o * Math.cos(s) * F), r = r * 180 / (se * (1 - ie) / (i * o) * F);
    const a = t + r;
    return [e + n, a];
  }
}
function To(e, t) {
  if (Sr(e, t))
    return [e, t];
  {
    let n = Ar(e - 105, t - 35), r = xr(e - 105, t - 35);
    const s = t / 180 * F;
    let i = Math.sin(s);
    i = 1 - ie * i * i;
    const o = Math.sqrt(i);
    n = n * 180 / (se * (1 - ie) / (i * o) * F), r = r * 180 / (se / o * Math.cos(s) * F);
    const a = t + n, c = e + r;
    return [e * 2 - c, t * 2 - a];
  }
}
function vo(e, t) {
  const n = Math.sqrt(e * e + t * t) + 2e-5 * Math.sin(t * re), r = Math.atan2(t, e) + 3e-7 * Math.cos(e * re), s = n * Math.cos(r) + 65e-4, i = n * Math.sin(r) + 6e-3;
  return [s, i];
}
function Ro(e, t) {
  const n = e - 65e-4, r = t - 6e-3, s = Math.sqrt(n * n + r * r) - 2e-5 * Math.sin(r * re), i = Math.atan2(r, n) - 3e-6 * Math.cos(r * re), o = s * Math.cos(i), a = s * Math.sin(i);
  return [o, a];
}
function vl(e, t) {
  const n = Oo(e, t);
  return vo(n[0], n[1]);
}
function Rl(e, t) {
  const n = Ro(e, t);
  return To(n[0], n[1]);
}
function El(e) {
  const t = /* @__PURE__ */ new WeakMap();
  return new Proxy(e, {
    construct(n, r) {
      return t.has(n) || t.set(n, new n(...r)), t.get(n);
    }
  });
}
function Cl(e) {
  return class extends e {
    constructor(...t) {
      super(...t), this.currentUser = null;
    }
    login(t) {
      E(`User ${t.name} logged in with role ${t.role}`), this.currentUser = t;
    }
    logout() {
      E(`User ${this.currentUser.name} logged out`), this.currentUser = null;
    }
  };
}
function Fl(e) {
  return function(t, n, r) {
    const s = r.value;
    return r.value = function(...i) {
      if (!this.currentUser)
        throw new Error("Authentication required");
      if (this.currentUser.role !== e)
        throw new Error(`Requires ${e} role`);
      return s.apply(this, i);
    }, r;
  };
}
function kl(e) {
  return function(t, n) {
    let r;
    Object.defineProperty(t, n, {
      get() {
        return r;
      },
      set(s) {
        if (s.length < e)
          throw new Error(`${String(n)} must be at least ${e} long`);
        r = s;
      }
    });
  };
}
function Pl(e) {
  return function(t, n) {
    let r;
    Object.defineProperty(t, n, {
      get() {
        return r;
      },
      set(s) {
        if (s.length < e)
          throw new Error(`${String(n)} must be at most ${e} long`);
        r = s;
      }
    });
  };
}
function Dl(e) {
  return function(t, n, r) {
    const s = e || `${t.constructor.name}.${String(n)}`, i = r.value;
    if (typeof i != "function")
      throw new SyntaxError(
        `@LogExecuteResultDecorator() can only be used on functions, not: ${s}`
      );
    return {
      ...r,
      value(...o) {
        const a = i.apply(this, o);
        return E(`${s} ( ${o} ) = ${a}`), a;
      }
    };
  };
}
function Ml(e, t, n) {
  const r = `${e.constructor.name}.${String(t)}`, s = n.value;
  if (typeof s != "function")
    throw new SyntaxError(
      `@LogExecuteTimeDecorator can only be used on functions, not: ${r}`
    );
  let i = 0;
  return {
    ...n,
    value(...o) {
      const a = `${r}-${i++}`;
      Kt.start(a);
      try {
        return s.apply(this, o);
      } finally {
        Kt.end(a);
      }
    }
  };
}
function Ll(e, t, n) {
  const r = `${e.constructor.name}.${String(t)}`, s = n.value;
  if (typeof s != "function")
    throw new SyntaxError(
      `@ProfileDecorator can only be used on functions, not: ${r}`
    );
  return {
    ...n,
    value(...i) {
      yn.start(r);
      try {
        return s.apply(this, i);
      } finally {
        yn.end(r);
      }
    }
  };
}
function Il(e = 300, t) {
  return function(n, r, s) {
    const i = `${n.constructor.name}.${String(r)}`, o = s.value;
    if (typeof o != "function")
      throw new SyntaxError(
        `@ThrottleDecorator() can only be used on functions, not: ${i}`
      );
    return {
      ...s,
      value(...a) {
        le(this).get(`__@ThrottleDecorator_${i}__`, Hs(o, e, t)).apply(this, a);
      }
    };
  };
}
function $l(e = 300, t = !1) {
  return function(n, r, s) {
    const i = `${n.constructor.name}.${String(r)}`, o = s.value;
    if (typeof o != "function")
      throw new SyntaxError(
        `@DebounceDecorator() can only be used on functions, not: ${i}`
      );
    return {
      ...s,
      value(...a) {
        le(this).get(
          `__@DebounceDecorator_${i}__`,
          Vs(o, e, { immediate: t })
        ).apply(this, a);
      }
    };
  };
}
function Nl(e = 3, t) {
  return function(n, r, s) {
    const i = `${n.constructor.name}.${String(r)}`, o = s.value;
    if (typeof o != "function")
      throw new SyntaxError(
        `@RetryDecoratorDecorator() can only be used on functions, not: ${i}`
      );
    const a = Qn(o, e, t);
    return {
      ...s,
      async value(...c) {
        return await a.apply(this, c);
      }
    };
  };
}
function Ul(e = 60) {
  return function(t, n, r) {
    const s = `${t.constructor.name}.${String(n)}`, i = r.value;
    if (typeof i != "function")
      throw new SyntaxError(
        `@CacheDecorator() can only be used on functions, not: ${s}`
      );
    return {
      ...r,
      async value(...o) {
        return await le(this).get(
          `__@CacheDecorator_${s}__`,
          tr(i, e)
        ).apply(this, o);
      }
    };
  };
}
function zl() {
  return function(e, t, n) {
    const r = `${e.constructor.name}.${String(t)}`, s = n.value;
    if (typeof s != "function")
      throw new SyntaxError(
        `@MemorizeDecorator() can only be used on functions, not: ${r}`
      );
    return {
      ...n,
      async value(...i) {
        return await le(this).get(
          `__@MemorizeDecorator_${r}__`,
          Js(s)
        ).apply(this, i);
      }
    };
  };
}
function jl(e, t, n) {
  if (n)
    return n.writable = !1, n;
  let r;
  Object.defineProperty(e, t, {
    get() {
      return r;
    },
    set(s) {
      if (r === void 0)
        r = s;
      else
        throw new Error(`${e}.${String(t)} is Readonly!`);
    }
  });
}
function Bl(e = !0) {
  return (t, n, r) => {
    if (r)
      return r.configurable = e, r;
    Object.defineProperty(t, n, {
      configurable: e
    });
  };
}
function ql(e = !0) {
  return (t, n, r) => {
    if (r)
      return r.enumerable = e, r;
    Object.defineProperty(t, n, {
      enumerable: e
    });
  };
}
const Eo = {
  11e4: "北京市",
  110100: "市辖区",
  110101: "东城区",
  110102: "西城区",
  110105: "朝阳区",
  110106: "丰台区",
  110107: "石景山区",
  110108: "海淀区",
  110109: "门头沟区",
  110111: "房山区",
  110112: "通州区",
  110113: "顺义区",
  110114: "昌平区",
  110115: "大兴区",
  110116: "怀柔区",
  110117: "平谷区",
  110118: "密云区",
  110119: "延庆区",
  12e4: "天津市",
  120100: "市辖区",
  120101: "和平区",
  120102: "河东区",
  120103: "河西区",
  120104: "南开区",
  120105: "河北区",
  120106: "红桥区",
  120110: "东丽区",
  120111: "西青区",
  120112: "津南区",
  120113: "北辰区",
  120114: "武清区",
  120115: "宝坻区",
  120116: "滨海新区",
  120117: "宁河区",
  120118: "静海区",
  120119: "蓟州区",
  13e4: "河北省",
  130100: "石家庄市",
  130101: "市辖区",
  130102: "长安区",
  130104: "桥西区",
  130105: "新华区",
  130107: "井陉矿区",
  130108: "裕华区",
  130109: "藁城区",
  130110: "鹿泉区",
  130111: "栾城区",
  130121: "井陉县",
  130123: "正定县",
  130125: "行唐县",
  130126: "灵寿县",
  130127: "高邑县",
  130128: "深泽县",
  130129: "赞皇县",
  130130: "无极县",
  130131: "平山县",
  130132: "元氏县",
  130133: "赵县",
  130183: "晋州市",
  130184: "新乐市",
  130200: "唐山市",
  130201: "市辖区",
  130202: "路南区",
  130203: "路北区",
  130204: "古冶区",
  130205: "开平区",
  130207: "丰南区",
  130208: "丰润区",
  130209: "曹妃甸区",
  130223: "滦县",
  130224: "滦南县",
  130225: "乐亭县",
  130227: "迁西县",
  130229: "玉田县",
  130281: "遵化市",
  130283: "迁安市",
  130300: "秦皇岛市",
  130301: "市辖区",
  130302: "海港区",
  130303: "山海关区",
  130304: "北戴河区",
  130306: "抚宁区",
  130321: "青龙满族自治县",
  130322: "昌黎县",
  130324: "卢龙县",
  130400: "邯郸市",
  130401: "市辖区",
  130402: "邯山区",
  130403: "丛台区",
  130404: "复兴区",
  130406: "峰峰矿区",
  130421: "邯郸县",
  130423: "临漳县",
  130424: "成安县",
  130425: "大名县",
  130426: "涉县",
  130427: "磁县",
  130428: "肥乡县",
  130429: "永年县",
  130430: "邱县",
  130431: "鸡泽县",
  130432: "广平县",
  130433: "馆陶县",
  130434: "魏县",
  130435: "曲周县",
  130481: "武安市",
  130500: "邢台市",
  130501: "市辖区",
  130502: "桥东区",
  130503: "桥西区",
  130521: "邢台县",
  130522: "临城县",
  130523: "内丘县",
  130524: "柏乡县",
  130525: "隆尧县",
  130526: "任县",
  130527: "南和县",
  130528: "宁晋县",
  130529: "巨鹿县",
  130530: "新河县",
  130531: "广宗县",
  130532: "平乡县",
  130533: "威县",
  130534: "清河县",
  130535: "临西县",
  130581: "南宫市",
  130582: "沙河市",
  130600: "保定市",
  130601: "市辖区",
  130602: "竞秀区",
  130606: "莲池区",
  130607: "满城区",
  130608: "清苑区",
  130609: "徐水区",
  130623: "涞水县",
  130624: "阜平县",
  130626: "定兴县",
  130627: "唐县",
  130628: "高阳县",
  130629: "容城县",
  130630: "涞源县",
  130631: "望都县",
  130632: "安新县",
  130633: "易县",
  130634: "曲阳县",
  130635: "蠡县",
  130636: "顺平县",
  130637: "博野县",
  130638: "雄县",
  130681: "涿州市",
  130683: "安国市",
  130684: "高碑店市",
  130700: "张家口市",
  130701: "市辖区",
  130702: "桥东区",
  130703: "桥西区",
  130705: "宣化区",
  130706: "下花园区",
  130708: "万全区",
  130709: "崇礼区",
  130722: "张北县",
  130723: "康保县",
  130724: "沽源县",
  130725: "尚义县",
  130726: "蔚县",
  130727: "阳原县",
  130728: "怀安县",
  130730: "怀来县",
  130731: "涿鹿县",
  130732: "赤城县",
  130800: "承德市",
  130801: "市辖区",
  130802: "双桥区",
  130803: "双滦区",
  130804: "鹰手营子矿区",
  130821: "承德县",
  130822: "兴隆县",
  130823: "平泉县",
  130824: "滦平县",
  130825: "隆化县",
  130826: "丰宁满族自治县",
  130827: "宽城满族自治县",
  130828: "围场满族蒙古族自治县",
  130900: "沧州市",
  130901: "市辖区",
  130902: "新华区",
  130903: "运河区",
  130921: "沧县",
  130922: "青县",
  130923: "东光县",
  130924: "海兴县",
  130925: "盐山县",
  130926: "肃宁县",
  130927: "南皮县",
  130928: "吴桥县",
  130929: "献县",
  130930: "孟村回族自治县",
  130981: "泊头市",
  130982: "任丘市",
  130983: "黄骅市",
  130984: "河间市",
  131e3: "廊坊市",
  131001: "市辖区",
  131002: "安次区",
  131003: "广阳区",
  131022: "固安县",
  131023: "永清县",
  131024: "香河县",
  131025: "大城县",
  131026: "文安县",
  131028: "大厂回族自治县",
  131081: "霸州市",
  131082: "三河市",
  131100: "衡水市",
  131101: "市辖区",
  131102: "桃城区",
  131103: "冀州区",
  131121: "枣强县",
  131122: "武邑县",
  131123: "武强县",
  131124: "饶阳县",
  131125: "安平县",
  131126: "故城县",
  131127: "景县",
  131128: "阜城县",
  131182: "深州市",
  139e3: "省直辖县级行政区划",
  139001: "定州市",
  139002: "辛集市",
  14e4: "山西省",
  140100: "太原市",
  140101: "市辖区",
  140105: "小店区",
  140106: "迎泽区",
  140107: "杏花岭区",
  140108: "尖草坪区",
  140109: "万柏林区",
  140110: "晋源区",
  140121: "清徐县",
  140122: "阳曲县",
  140123: "娄烦县",
  140181: "古交市",
  140200: "大同市",
  140201: "市辖区",
  140202: "城区",
  140203: "矿区",
  140211: "南郊区",
  140212: "新荣区",
  140221: "阳高县",
  140222: "天镇县",
  140223: "广灵县",
  140224: "灵丘县",
  140225: "浑源县",
  140226: "左云县",
  140227: "大同县",
  140300: "阳泉市",
  140301: "市辖区",
  140302: "城区",
  140303: "矿区",
  140311: "郊区",
  140321: "平定县",
  140322: "盂县",
  140400: "长治市",
  140401: "市辖区",
  140402: "城区",
  140411: "郊区",
  140421: "长治县",
  140423: "襄垣县",
  140424: "屯留县",
  140425: "平顺县",
  140426: "黎城县",
  140427: "壶关县",
  140428: "长子县",
  140429: "武乡县",
  140430: "沁县",
  140431: "沁源县",
  140481: "潞城市",
  140500: "晋城市",
  140501: "市辖区",
  140502: "城区",
  140521: "沁水县",
  140522: "阳城县",
  140524: "陵川县",
  140525: "泽州县",
  140581: "高平市",
  140600: "朔州市",
  140601: "市辖区",
  140602: "朔城区",
  140603: "平鲁区",
  140621: "山阴县",
  140622: "应县",
  140623: "右玉县",
  140624: "怀仁县",
  140700: "晋中市",
  140701: "市辖区",
  140702: "榆次区",
  140721: "榆社县",
  140722: "左权县",
  140723: "和顺县",
  140724: "昔阳县",
  140725: "寿阳县",
  140726: "太谷县",
  140727: "祁县",
  140728: "平遥县",
  140729: "灵石县",
  140781: "介休市",
  140800: "运城市",
  140801: "市辖区",
  140802: "盐湖区",
  140821: "临猗县",
  140822: "万荣县",
  140823: "闻喜县",
  140824: "稷山县",
  140825: "新绛县",
  140826: "绛县",
  140827: "垣曲县",
  140828: "夏县",
  140829: "平陆县",
  140830: "芮城县",
  140881: "永济市",
  140882: "河津市",
  140900: "忻州市",
  140901: "市辖区",
  140902: "忻府区",
  140921: "定襄县",
  140922: "五台县",
  140923: "代县",
  140924: "繁峙县",
  140925: "宁武县",
  140926: "静乐县",
  140927: "神池县",
  140928: "五寨县",
  140929: "岢岚县",
  140930: "河曲县",
  140931: "保德县",
  140932: "偏关县",
  140981: "原平市",
  141e3: "临汾市",
  141001: "市辖区",
  141002: "尧都区",
  141021: "曲沃县",
  141022: "翼城县",
  141023: "襄汾县",
  141024: "洪洞县",
  141025: "古县",
  141026: "安泽县",
  141027: "浮山县",
  141028: "吉县",
  141029: "乡宁县",
  141030: "大宁县",
  141031: "隰县",
  141032: "永和县",
  141033: "蒲县",
  141034: "汾西县",
  141081: "侯马市",
  141082: "霍州市",
  141100: "吕梁市",
  141101: "市辖区",
  141102: "离石区",
  141121: "文水县",
  141122: "交城县",
  141123: "兴县",
  141124: "临县",
  141125: "柳林县",
  141126: "石楼县",
  141127: "岚县",
  141128: "方山县",
  141129: "中阳县",
  141130: "交口县",
  141181: "孝义市",
  141182: "汾阳市",
  15e4: "内蒙古自治区",
  150100: "呼和浩特市",
  150101: "市辖区",
  150102: "新城区",
  150103: "回民区",
  150104: "玉泉区",
  150105: "赛罕区",
  150121: "土默特左旗",
  150122: "托克托县",
  150123: "和林格尔县",
  150124: "清水河县",
  150125: "武川县",
  150200: "包头市",
  150201: "市辖区",
  150202: "东河区",
  150203: "昆都仑区",
  150204: "青山区",
  150205: "石拐区",
  150206: "白云鄂博矿区",
  150207: "九原区",
  150221: "土默特右旗",
  150222: "固阳县",
  150223: "达尔罕茂明安联合旗",
  150300: "乌海市",
  150301: "市辖区",
  150302: "海勃湾区",
  150303: "海南区",
  150304: "乌达区",
  150400: "赤峰市",
  150401: "市辖区",
  150402: "红山区",
  150403: "元宝山区",
  150404: "松山区",
  150421: "阿鲁科尔沁旗",
  150422: "巴林左旗",
  150423: "巴林右旗",
  150424: "林西县",
  150425: "克什克腾旗",
  150426: "翁牛特旗",
  150428: "喀喇沁旗",
  150429: "宁城县",
  150430: "敖汉旗",
  150500: "通辽市",
  150501: "市辖区",
  150502: "科尔沁区",
  150521: "科尔沁左翼中旗",
  150522: "科尔沁左翼后旗",
  150523: "开鲁县",
  150524: "库伦旗",
  150525: "奈曼旗",
  150526: "扎鲁特旗",
  150581: "霍林郭勒市",
  150600: "鄂尔多斯市",
  150601: "市辖区",
  150602: "东胜区",
  150603: "康巴什区",
  150621: "达拉特旗",
  150622: "准格尔旗",
  150623: "鄂托克前旗",
  150624: "鄂托克旗",
  150625: "杭锦旗",
  150626: "乌审旗",
  150627: "伊金霍洛旗",
  150700: "呼伦贝尔市",
  150701: "市辖区",
  150702: "海拉尔区",
  150703: "扎赉诺尔区",
  150721: "阿荣旗",
  150722: "莫力达瓦达斡尔族自治旗",
  150723: "鄂伦春自治旗",
  150724: "鄂温克族自治旗",
  150725: "陈巴尔虎旗",
  150726: "新巴尔虎左旗",
  150727: "新巴尔虎右旗",
  150781: "满洲里市",
  150782: "牙克石市",
  150783: "扎兰屯市",
  150784: "额尔古纳市",
  150785: "根河市",
  150800: "巴彦淖尔市",
  150801: "市辖区",
  150802: "临河区",
  150821: "五原县",
  150822: "磴口县",
  150823: "乌拉特前旗",
  150824: "乌拉特中旗",
  150825: "乌拉特后旗",
  150826: "杭锦后旗",
  150900: "乌兰察布市",
  150901: "市辖区",
  150902: "集宁区",
  150921: "卓资县",
  150922: "化德县",
  150923: "商都县",
  150924: "兴和县",
  150925: "凉城县",
  150926: "察哈尔右翼前旗",
  150927: "察哈尔右翼中旗",
  150928: "察哈尔右翼后旗",
  150929: "四子王旗",
  150981: "丰镇市",
  152200: "兴安盟",
  152201: "乌兰浩特市",
  152202: "阿尔山市",
  152221: "科尔沁右翼前旗",
  152222: "科尔沁右翼中旗",
  152223: "扎赉特旗",
  152224: "突泉县",
  152500: "锡林郭勒盟",
  152501: "二连浩特市",
  152502: "锡林浩特市",
  152522: "阿巴嘎旗",
  152523: "苏尼特左旗",
  152524: "苏尼特右旗",
  152525: "东乌珠穆沁旗",
  152526: "西乌珠穆沁旗",
  152527: "太仆寺旗",
  152528: "镶黄旗",
  152529: "正镶白旗",
  152530: "正蓝旗",
  152531: "多伦县",
  152900: "阿拉善盟",
  152921: "阿拉善左旗",
  152922: "阿拉善右旗",
  152923: "额济纳旗",
  21e4: "辽宁省",
  210100: "沈阳市",
  210101: "市辖区",
  210102: "和平区",
  210103: "沈河区",
  210104: "大东区",
  210105: "皇姑区",
  210106: "铁西区",
  210111: "苏家屯区",
  210112: "浑南区",
  210113: "沈北新区",
  210114: "于洪区",
  210115: "辽中区",
  210123: "康平县",
  210124: "法库县",
  210181: "新民市",
  210200: "大连市",
  210201: "市辖区",
  210202: "中山区",
  210203: "西岗区",
  210204: "沙河口区",
  210211: "甘井子区",
  210212: "旅顺口区",
  210213: "金州区",
  210214: "普兰店区",
  210224: "长海县",
  210281: "瓦房店市",
  210283: "庄河市",
  210300: "鞍山市",
  210301: "市辖区",
  210302: "铁东区",
  210303: "铁西区",
  210304: "立山区",
  210311: "千山区",
  210321: "台安县",
  210323: "岫岩满族自治县",
  210381: "海城市",
  210400: "抚顺市",
  210401: "市辖区",
  210402: "新抚区",
  210403: "东洲区",
  210404: "望花区",
  210411: "顺城区",
  210421: "抚顺县",
  210422: "新宾满族自治县",
  210423: "清原满族自治县",
  210500: "本溪市",
  210501: "市辖区",
  210502: "平山区",
  210503: "溪湖区",
  210504: "明山区",
  210505: "南芬区",
  210521: "本溪满族自治县",
  210522: "桓仁满族自治县",
  210600: "丹东市",
  210601: "市辖区",
  210602: "元宝区",
  210603: "振兴区",
  210604: "振安区",
  210624: "宽甸满族自治县",
  210681: "东港市",
  210682: "凤城市",
  210700: "锦州市",
  210701: "市辖区",
  210702: "古塔区",
  210703: "凌河区",
  210711: "太和区",
  210726: "黑山县",
  210727: "义县",
  210781: "凌海市",
  210782: "北镇市",
  210800: "营口市",
  210801: "市辖区",
  210802: "站前区",
  210803: "西市区",
  210804: "鲅鱼圈区",
  210811: "老边区",
  210881: "盖州市",
  210882: "大石桥市",
  210900: "阜新市",
  210901: "市辖区",
  210902: "海州区",
  210903: "新邱区",
  210904: "太平区",
  210905: "清河门区",
  210911: "细河区",
  210921: "阜新蒙古族自治县",
  210922: "彰武县",
  211e3: "辽阳市",
  211001: "市辖区",
  211002: "白塔区",
  211003: "文圣区",
  211004: "宏伟区",
  211005: "弓长岭区",
  211011: "太子河区",
  211021: "辽阳县",
  211081: "灯塔市",
  211100: "盘锦市",
  211101: "市辖区",
  211102: "双台子区",
  211103: "兴隆台区",
  211104: "大洼区",
  211122: "盘山县",
  211200: "铁岭市",
  211201: "市辖区",
  211202: "银州区",
  211204: "清河区",
  211221: "铁岭县",
  211223: "西丰县",
  211224: "昌图县",
  211281: "调兵山市",
  211282: "开原市",
  211300: "朝阳市",
  211301: "市辖区",
  211302: "双塔区",
  211303: "龙城区",
  211321: "朝阳县",
  211322: "建平县",
  211324: "喀喇沁左翼蒙古族自治县",
  211381: "北票市",
  211382: "凌源市",
  211400: "葫芦岛市",
  211401: "市辖区",
  211402: "连山区",
  211403: "龙港区",
  211404: "南票区",
  211421: "绥中县",
  211422: "建昌县",
  211481: "兴城市",
  22e4: "吉林省",
  220100: "长春市",
  220101: "市辖区",
  220102: "南关区",
  220103: "宽城区",
  220104: "朝阳区",
  220105: "二道区",
  220106: "绿园区",
  220112: "双阳区",
  220113: "九台区",
  220122: "农安县",
  220182: "榆树市",
  220183: "德惠市",
  220200: "吉林市",
  220201: "市辖区",
  220202: "昌邑区",
  220203: "龙潭区",
  220204: "船营区",
  220211: "丰满区",
  220221: "永吉县",
  220281: "蛟河市",
  220282: "桦甸市",
  220283: "舒兰市",
  220284: "磐石市",
  220300: "四平市",
  220301: "市辖区",
  220302: "铁西区",
  220303: "铁东区",
  220322: "梨树县",
  220323: "伊通满族自治县",
  220381: "公主岭市",
  220382: "双辽市",
  220400: "辽源市",
  220401: "市辖区",
  220402: "龙山区",
  220403: "西安区",
  220421: "东丰县",
  220422: "东辽县",
  220500: "通化市",
  220501: "市辖区",
  220502: "东昌区",
  220503: "二道江区",
  220521: "通化县",
  220523: "辉南县",
  220524: "柳河县",
  220581: "梅河口市",
  220582: "集安市",
  220600: "白山市",
  220601: "市辖区",
  220602: "浑江区",
  220605: "江源区",
  220621: "抚松县",
  220622: "靖宇县",
  220623: "长白朝鲜族自治县",
  220681: "临江市",
  220700: "松原市",
  220701: "市辖区",
  220702: "宁江区",
  220721: "前郭尔罗斯蒙古族自治县",
  220722: "长岭县",
  220723: "乾安县",
  220781: "扶余市",
  220800: "白城市",
  220801: "市辖区",
  220802: "洮北区",
  220821: "镇赉县",
  220822: "通榆县",
  220881: "洮南市",
  220882: "大安市",
  222400: "延边朝鲜族自治州",
  222401: "延吉市",
  222402: "图们市",
  222403: "敦化市",
  222404: "珲春市",
  222405: "龙井市",
  222406: "和龙市",
  222424: "汪清县",
  222426: "安图县",
  23e4: "黑龙江省",
  230100: "哈尔滨市",
  230101: "市辖区",
  230102: "道里区",
  230103: "南岗区",
  230104: "道外区",
  230108: "平房区",
  230109: "松北区",
  230110: "香坊区",
  230111: "呼兰区",
  230112: "阿城区",
  230113: "双城区",
  230123: "依兰县",
  230124: "方正县",
  230125: "宾县",
  230126: "巴彦县",
  230127: "木兰县",
  230128: "通河县",
  230129: "延寿县",
  230183: "尚志市",
  230184: "五常市",
  230200: "齐齐哈尔市",
  230201: "市辖区",
  230202: "龙沙区",
  230203: "建华区",
  230204: "铁锋区",
  230205: "昂昂溪区",
  230206: "富拉尔基区",
  230207: "碾子山区",
  230208: "梅里斯达斡尔族区",
  230221: "龙江县",
  230223: "依安县",
  230224: "泰来县",
  230225: "甘南县",
  230227: "富裕县",
  230229: "克山县",
  230230: "克东县",
  230231: "拜泉县",
  230281: "讷河市",
  230300: "鸡西市",
  230301: "市辖区",
  230302: "鸡冠区",
  230303: "恒山区",
  230304: "滴道区",
  230305: "梨树区",
  230306: "城子河区",
  230307: "麻山区",
  230321: "鸡东县",
  230381: "虎林市",
  230382: "密山市",
  230400: "鹤岗市",
  230401: "市辖区",
  230402: "向阳区",
  230403: "工农区",
  230404: "南山区",
  230405: "兴安区",
  230406: "东山区",
  230407: "兴山区",
  230421: "萝北县",
  230422: "绥滨县",
  230500: "双鸭山市",
  230501: "市辖区",
  230502: "尖山区",
  230503: "岭东区",
  230505: "四方台区",
  230506: "宝山区",
  230521: "集贤县",
  230522: "友谊县",
  230523: "宝清县",
  230524: "饶河县",
  230600: "大庆市",
  230601: "市辖区",
  230602: "萨尔图区",
  230603: "龙凤区",
  230604: "让胡路区",
  230605: "红岗区",
  230606: "大同区",
  230621: "肇州县",
  230622: "肇源县",
  230623: "林甸县",
  230624: "杜尔伯特蒙古族自治县",
  230700: "伊春市",
  230701: "市辖区",
  230702: "伊春区",
  230703: "南岔区",
  230704: "友好区",
  230705: "西林区",
  230706: "翠峦区",
  230707: "新青区",
  230708: "美溪区",
  230709: "金山屯区",
  230710: "五营区",
  230711: "乌马河区",
  230712: "汤旺河区",
  230713: "带岭区",
  230714: "乌伊岭区",
  230715: "红星区",
  230716: "上甘岭区",
  230722: "嘉荫县",
  230781: "铁力市",
  230800: "佳木斯市",
  230801: "市辖区",
  230803: "向阳区",
  230804: "前进区",
  230805: "东风区",
  230811: "郊区",
  230822: "桦南县",
  230826: "桦川县",
  230828: "汤原县",
  230881: "同江市",
  230882: "富锦市",
  230883: "抚远市",
  230900: "七台河市",
  230901: "市辖区",
  230902: "新兴区",
  230903: "桃山区",
  230904: "茄子河区",
  230921: "勃利县",
  231e3: "牡丹江市",
  231001: "市辖区",
  231002: "东安区",
  231003: "阳明区",
  231004: "爱民区",
  231005: "西安区",
  231025: "林口县",
  231081: "绥芬河市",
  231083: "海林市",
  231084: "宁安市",
  231085: "穆棱市",
  231086: "东宁市",
  231100: "黑河市",
  231101: "市辖区",
  231102: "爱辉区",
  231121: "嫩江县",
  231123: "逊克县",
  231124: "孙吴县",
  231181: "北安市",
  231182: "五大连池市",
  231200: "绥化市",
  231201: "市辖区",
  231202: "北林区",
  231221: "望奎县",
  231222: "兰西县",
  231223: "青冈县",
  231224: "庆安县",
  231225: "明水县",
  231226: "绥棱县",
  231281: "安达市",
  231282: "肇东市",
  231283: "海伦市",
  232700: "大兴安岭地区",
  232721: "呼玛县",
  232722: "塔河县",
  232723: "漠河县",
  31e4: "上海市",
  310100: "市辖区",
  310101: "黄浦区",
  310104: "徐汇区",
  310105: "长宁区",
  310106: "静安区",
  310107: "普陀区",
  310109: "虹口区",
  310110: "杨浦区",
  310112: "闵行区",
  310113: "宝山区",
  310114: "嘉定区",
  310115: "浦东新区",
  310116: "金山区",
  310117: "松江区",
  310118: "青浦区",
  310120: "奉贤区",
  310151: "崇明区",
  32e4: "江苏省",
  320100: "南京市",
  320101: "市辖区",
  320102: "玄武区",
  320104: "秦淮区",
  320105: "建邺区",
  320106: "鼓楼区",
  320111: "浦口区",
  320113: "栖霞区",
  320114: "雨花台区",
  320115: "江宁区",
  320116: "六合区",
  320117: "溧水区",
  320118: "高淳区",
  320200: "无锡市",
  320201: "市辖区",
  320205: "锡山区",
  320206: "惠山区",
  320211: "滨湖区",
  320213: "梁溪区",
  320214: "新吴区",
  320281: "江阴市",
  320282: "宜兴市",
  320300: "徐州市",
  320301: "市辖区",
  320302: "鼓楼区",
  320303: "云龙区",
  320305: "贾汪区",
  320311: "泉山区",
  320312: "铜山区",
  320321: "丰县",
  320322: "沛县",
  320324: "睢宁县",
  320381: "新沂市",
  320382: "邳州市",
  320400: "常州市",
  320401: "市辖区",
  320402: "天宁区",
  320404: "钟楼区",
  320411: "新北区",
  320412: "武进区",
  320413: "金坛区",
  320481: "溧阳市",
  320500: "苏州市",
  320501: "市辖区",
  320505: "虎丘区",
  320506: "吴中区",
  320507: "相城区",
  320508: "姑苏区",
  320509: "吴江区",
  320581: "常熟市",
  320582: "张家港市",
  320583: "昆山市",
  320585: "太仓市",
  320594: "苏州工业园区",
  320600: "南通市",
  320601: "市辖区",
  320602: "崇川区",
  320611: "港闸区",
  320612: "通州区",
  320621: "海安县",
  320623: "如东县",
  320681: "启东市",
  320682: "如皋市",
  320684: "海门市",
  320700: "连云港市",
  320701: "市辖区",
  320703: "连云区",
  320706: "海州区",
  320707: "赣榆区",
  320722: "东海县",
  320723: "灌云县",
  320724: "灌南县",
  320800: "淮安市",
  320801: "市辖区",
  320803: "淮安区",
  320804: "淮阴区",
  320812: "清江浦区",
  320813: "洪泽区",
  320826: "涟水县",
  320830: "盱眙县",
  320831: "金湖县",
  320900: "盐城市",
  320901: "市辖区",
  320902: "亭湖区",
  320903: "盐都区",
  320904: "大丰区",
  320921: "响水县",
  320922: "滨海县",
  320923: "阜宁县",
  320924: "射阳县",
  320925: "建湖县",
  320981: "东台市",
  321e3: "扬州市",
  321001: "市辖区",
  321002: "广陵区",
  321003: "邗江区",
  321012: "江都区",
  321023: "宝应县",
  321081: "仪征市",
  321084: "高邮市",
  321100: "镇江市",
  321101: "市辖区",
  321102: "京口区",
  321111: "润州区",
  321112: "丹徒区",
  321181: "丹阳市",
  321182: "扬中市",
  321183: "句容市",
  321200: "泰州市",
  321201: "市辖区",
  321202: "海陵区",
  321203: "高港区",
  321204: "姜堰区",
  321281: "兴化市",
  321282: "靖江市",
  321283: "泰兴市",
  321300: "宿迁市",
  321301: "市辖区",
  321302: "宿城区",
  321311: "宿豫区",
  321322: "沭阳县",
  321323: "泗阳县",
  321324: "泗洪县",
  33e4: "浙江省",
  330100: "杭州市",
  330101: "市辖区",
  330102: "上城区",
  330103: "下城区",
  330104: "江干区",
  330105: "拱墅区",
  330106: "西湖区",
  330108: "滨江区",
  330109: "萧山区",
  330110: "余杭区",
  330111: "富阳区",
  330122: "桐庐县",
  330127: "淳安县",
  330182: "建德市",
  330185: "临安市",
  330200: "宁波市",
  330201: "市辖区",
  330203: "海曙区",
  330204: "江东区",
  330205: "江北区",
  330206: "北仑区",
  330211: "镇海区",
  330212: "鄞州区",
  330225: "象山县",
  330226: "宁海县",
  330281: "余姚市",
  330282: "慈溪市",
  330283: "奉化市",
  330300: "温州市",
  330301: "市辖区",
  330302: "鹿城区",
  330303: "龙湾区",
  330304: "瓯海区",
  330305: "洞头区",
  330324: "永嘉县",
  330326: "平阳县",
  330327: "苍南县",
  330328: "文成县",
  330329: "泰顺县",
  330381: "瑞安市",
  330382: "乐清市",
  330400: "嘉兴市",
  330401: "市辖区",
  330402: "南湖区",
  330411: "秀洲区",
  330421: "嘉善县",
  330424: "海盐县",
  330481: "海宁市",
  330482: "平湖市",
  330483: "桐乡市",
  330500: "湖州市",
  330501: "市辖区",
  330502: "吴兴区",
  330503: "南浔区",
  330521: "德清县",
  330522: "长兴县",
  330523: "安吉县",
  330600: "绍兴市",
  330601: "市辖区",
  330602: "越城区",
  330603: "柯桥区",
  330604: "上虞区",
  330624: "新昌县",
  330681: "诸暨市",
  330683: "嵊州市",
  330700: "金华市",
  330701: "市辖区",
  330702: "婺城区",
  330703: "金东区",
  330723: "武义县",
  330726: "浦江县",
  330727: "磐安县",
  330781: "兰溪市",
  330782: "义乌市",
  330783: "东阳市",
  330784: "永康市",
  330800: "衢州市",
  330801: "市辖区",
  330802: "柯城区",
  330803: "衢江区",
  330822: "常山县",
  330824: "开化县",
  330825: "龙游县",
  330881: "江山市",
  330900: "舟山市",
  330901: "市辖区",
  330902: "定海区",
  330903: "普陀区",
  330921: "岱山县",
  330922: "嵊泗县",
  331e3: "台州市",
  331001: "市辖区",
  331002: "椒江区",
  331003: "黄岩区",
  331004: "路桥区",
  331021: "玉环县",
  331022: "三门县",
  331023: "天台县",
  331024: "仙居县",
  331081: "温岭市",
  331082: "临海市",
  331100: "丽水市",
  331101: "市辖区",
  331102: "莲都区",
  331121: "青田县",
  331122: "缙云县",
  331123: "遂昌县",
  331124: "松阳县",
  331125: "云和县",
  331126: "庆元县",
  331127: "景宁畲族自治县",
  331181: "龙泉市",
  34e4: "安徽省",
  340100: "合肥市",
  340101: "市辖区",
  340102: "瑶海区",
  340103: "庐阳区",
  340104: "蜀山区",
  340111: "包河区",
  340121: "长丰县",
  340122: "肥东县",
  340123: "肥西县",
  340124: "庐江县",
  340181: "巢湖市",
  340200: "芜湖市",
  340201: "市辖区",
  340202: "镜湖区",
  340203: "弋江区",
  340207: "鸠江区",
  340208: "三山区",
  340221: "芜湖县",
  340222: "繁昌县",
  340223: "南陵县",
  340225: "无为县",
  340300: "蚌埠市",
  340301: "市辖区",
  340302: "龙子湖区",
  340303: "蚌山区",
  340304: "禹会区",
  340311: "淮上区",
  340321: "怀远县",
  340322: "五河县",
  340323: "固镇县",
  340400: "淮南市",
  340401: "市辖区",
  340402: "大通区",
  340403: "田家庵区",
  340404: "谢家集区",
  340405: "八公山区",
  340406: "潘集区",
  340421: "凤台县",
  340422: "寿县",
  340500: "马鞍山市",
  340501: "市辖区",
  340503: "花山区",
  340504: "雨山区",
  340506: "博望区",
  340521: "当涂县",
  340522: "含山县",
  340523: "和县",
  340600: "淮北市",
  340601: "市辖区",
  340602: "杜集区",
  340603: "相山区",
  340604: "烈山区",
  340621: "濉溪县",
  340700: "铜陵市",
  340701: "市辖区",
  340705: "铜官区",
  340706: "义安区",
  340711: "郊区",
  340722: "枞阳县",
  340800: "安庆市",
  340801: "市辖区",
  340802: "迎江区",
  340803: "大观区",
  340811: "宜秀区",
  340822: "怀宁县",
  340824: "潜山县",
  340825: "太湖县",
  340826: "宿松县",
  340827: "望江县",
  340828: "岳西县",
  340881: "桐城市",
  341e3: "黄山市",
  341001: "市辖区",
  341002: "屯溪区",
  341003: "黄山区",
  341004: "徽州区",
  341021: "歙县",
  341022: "休宁县",
  341023: "黟县",
  341024: "祁门县",
  341100: "滁州市",
  341101: "市辖区",
  341102: "琅琊区",
  341103: "南谯区",
  341122: "来安县",
  341124: "全椒县",
  341125: "定远县",
  341126: "凤阳县",
  341181: "天长市",
  341182: "明光市",
  341200: "阜阳市",
  341201: "市辖区",
  341202: "颍州区",
  341203: "颍东区",
  341204: "颍泉区",
  341221: "临泉县",
  341222: "太和县",
  341225: "阜南县",
  341226: "颍上县",
  341282: "界首市",
  341300: "宿州市",
  341301: "市辖区",
  341302: "埇桥区",
  341321: "砀山县",
  341322: "萧县",
  341323: "灵璧县",
  341324: "泗县",
  341500: "六安市",
  341501: "市辖区",
  341502: "金安区",
  341503: "裕安区",
  341504: "叶集区",
  341522: "霍邱县",
  341523: "舒城县",
  341524: "金寨县",
  341525: "霍山县",
  341600: "亳州市",
  341601: "市辖区",
  341602: "谯城区",
  341621: "涡阳县",
  341622: "蒙城县",
  341623: "利辛县",
  341700: "池州市",
  341701: "市辖区",
  341702: "贵池区",
  341721: "东至县",
  341722: "石台县",
  341723: "青阳县",
  341800: "宣城市",
  341801: "市辖区",
  341802: "宣州区",
  341821: "郎溪县",
  341822: "广德县",
  341823: "泾县",
  341824: "绩溪县",
  341825: "旌德县",
  341881: "宁国市",
  35e4: "福建省",
  350100: "福州市",
  350101: "市辖区",
  350102: "鼓楼区",
  350103: "台江区",
  350104: "仓山区",
  350105: "马尾区",
  350111: "晋安区",
  350121: "闽侯县",
  350122: "连江县",
  350123: "罗源县",
  350124: "闽清县",
  350125: "永泰县",
  350128: "平潭县",
  350181: "福清市",
  350182: "长乐市",
  350200: "厦门市",
  350201: "市辖区",
  350203: "思明区",
  350205: "海沧区",
  350206: "湖里区",
  350211: "集美区",
  350212: "同安区",
  350213: "翔安区",
  350300: "莆田市",
  350301: "市辖区",
  350302: "城厢区",
  350303: "涵江区",
  350304: "荔城区",
  350305: "秀屿区",
  350322: "仙游县",
  350400: "三明市",
  350401: "市辖区",
  350402: "梅列区",
  350403: "三元区",
  350421: "明溪县",
  350423: "清流县",
  350424: "宁化县",
  350425: "大田县",
  350426: "尤溪县",
  350427: "沙县",
  350428: "将乐县",
  350429: "泰宁县",
  350430: "建宁县",
  350481: "永安市",
  350500: "泉州市",
  350501: "市辖区",
  350502: "鲤城区",
  350503: "丰泽区",
  350504: "洛江区",
  350505: "泉港区",
  350521: "惠安县",
  350524: "安溪县",
  350525: "永春县",
  350526: "德化县",
  350527: "金门县",
  350581: "石狮市",
  350582: "晋江市",
  350583: "南安市",
  350600: "漳州市",
  350601: "市辖区",
  350602: "芗城区",
  350603: "龙文区",
  350622: "云霄县",
  350623: "漳浦县",
  350624: "诏安县",
  350625: "长泰县",
  350626: "东山县",
  350627: "南靖县",
  350628: "平和县",
  350629: "华安县",
  350681: "龙海市",
  350700: "南平市",
  350701: "市辖区",
  350702: "延平区",
  350703: "建阳区",
  350721: "顺昌县",
  350722: "浦城县",
  350723: "光泽县",
  350724: "松溪县",
  350725: "政和县",
  350781: "邵武市",
  350782: "武夷山市",
  350783: "建瓯市",
  350800: "龙岩市",
  350801: "市辖区",
  350802: "新罗区",
  350803: "永定区",
  350821: "长汀县",
  350823: "上杭县",
  350824: "武平县",
  350825: "连城县",
  350881: "漳平市",
  350900: "宁德市",
  350901: "市辖区",
  350902: "蕉城区",
  350921: "霞浦县",
  350922: "古田县",
  350923: "屏南县",
  350924: "寿宁县",
  350925: "周宁县",
  350926: "柘荣县",
  350981: "福安市",
  350982: "福鼎市",
  36e4: "江西省",
  360100: "南昌市",
  360101: "市辖区",
  360102: "东湖区",
  360103: "西湖区",
  360104: "青云谱区",
  360105: "湾里区",
  360111: "青山湖区",
  360112: "新建区",
  360121: "南昌县",
  360123: "安义县",
  360124: "进贤县",
  360200: "景德镇市",
  360201: "市辖区",
  360202: "昌江区",
  360203: "珠山区",
  360222: "浮梁县",
  360281: "乐平市",
  360300: "萍乡市",
  360301: "市辖区",
  360302: "安源区",
  360313: "湘东区",
  360321: "莲花县",
  360322: "上栗县",
  360323: "芦溪县",
  360400: "九江市",
  360401: "市辖区",
  360402: "濂溪区",
  360403: "浔阳区",
  360421: "九江县",
  360423: "武宁县",
  360424: "修水县",
  360425: "永修县",
  360426: "德安县",
  360428: "都昌县",
  360429: "湖口县",
  360430: "彭泽县",
  360481: "瑞昌市",
  360482: "共青城市",
  360483: "庐山市",
  360500: "新余市",
  360501: "市辖区",
  360502: "渝水区",
  360521: "分宜县",
  360600: "鹰潭市",
  360601: "市辖区",
  360602: "月湖区",
  360622: "余江县",
  360681: "贵溪市",
  360700: "赣州市",
  360701: "市辖区",
  360702: "章贡区",
  360703: "南康区",
  360721: "赣县",
  360722: "信丰县",
  360723: "大余县",
  360724: "上犹县",
  360725: "崇义县",
  360726: "安远县",
  360727: "龙南县",
  360728: "定南县",
  360729: "全南县",
  360730: "宁都县",
  360731: "于都县",
  360732: "兴国县",
  360733: "会昌县",
  360734: "寻乌县",
  360735: "石城县",
  360781: "瑞金市",
  360800: "吉安市",
  360801: "市辖区",
  360802: "吉州区",
  360803: "青原区",
  360821: "吉安县",
  360822: "吉水县",
  360823: "峡江县",
  360824: "新干县",
  360825: "永丰县",
  360826: "泰和县",
  360827: "遂川县",
  360828: "万安县",
  360829: "安福县",
  360830: "永新县",
  360881: "井冈山市",
  360900: "宜春市",
  360901: "市辖区",
  360902: "袁州区",
  360921: "奉新县",
  360922: "万载县",
  360923: "上高县",
  360924: "宜丰县",
  360925: "靖安县",
  360926: "铜鼓县",
  360981: "丰城市",
  360982: "樟树市",
  360983: "高安市",
  361e3: "抚州市",
  361001: "市辖区",
  361002: "临川区",
  361021: "南城县",
  361022: "黎川县",
  361023: "南丰县",
  361024: "崇仁县",
  361025: "乐安县",
  361026: "宜黄县",
  361027: "金溪县",
  361028: "资溪县",
  361029: "东乡县",
  361030: "广昌县",
  361100: "上饶市",
  361101: "市辖区",
  361102: "信州区",
  361103: "广丰区",
  361121: "上饶县",
  361123: "玉山县",
  361124: "铅山县",
  361125: "横峰县",
  361126: "弋阳县",
  361127: "余干县",
  361128: "鄱阳县",
  361129: "万年县",
  361130: "婺源县",
  361181: "德兴市",
  37e4: "山东省",
  370100: "济南市",
  370101: "市辖区",
  370102: "历下区",
  370103: "市中区",
  370104: "槐荫区",
  370105: "天桥区",
  370112: "历城区",
  370113: "长清区",
  370124: "平阴县",
  370125: "济阳县",
  370126: "商河县",
  370181: "章丘市",
  370200: "青岛市",
  370201: "市辖区",
  370202: "市南区",
  370203: "市北区",
  370211: "黄岛区",
  370212: "崂山区",
  370213: "李沧区",
  370214: "城阳区",
  370281: "胶州市",
  370282: "即墨市",
  370283: "平度市",
  370285: "莱西市",
  370300: "淄博市",
  370301: "市辖区",
  370302: "淄川区",
  370303: "张店区",
  370304: "博山区",
  370305: "临淄区",
  370306: "周村区",
  370321: "桓台县",
  370322: "高青县",
  370323: "沂源县",
  370400: "枣庄市",
  370401: "市辖区",
  370402: "市中区",
  370403: "薛城区",
  370404: "峄城区",
  370405: "台儿庄区",
  370406: "山亭区",
  370481: "滕州市",
  370500: "东营市",
  370501: "市辖区",
  370502: "东营区",
  370503: "河口区",
  370505: "垦利区",
  370522: "利津县",
  370523: "广饶县",
  370600: "烟台市",
  370601: "市辖区",
  370602: "芝罘区",
  370611: "福山区",
  370612: "牟平区",
  370613: "莱山区",
  370634: "长岛县",
  370681: "龙口市",
  370682: "莱阳市",
  370683: "莱州市",
  370684: "蓬莱市",
  370685: "招远市",
  370686: "栖霞市",
  370687: "海阳市",
  370700: "潍坊市",
  370701: "市辖区",
  370702: "潍城区",
  370703: "寒亭区",
  370704: "坊子区",
  370705: "奎文区",
  370724: "临朐县",
  370725: "昌乐县",
  370781: "青州市",
  370782: "诸城市",
  370783: "寿光市",
  370784: "安丘市",
  370785: "高密市",
  370786: "昌邑市",
  370800: "济宁市",
  370801: "市辖区",
  370811: "任城区",
  370812: "兖州区",
  370826: "微山县",
  370827: "鱼台县",
  370828: "金乡县",
  370829: "嘉祥县",
  370830: "汶上县",
  370831: "泗水县",
  370832: "梁山县",
  370881: "曲阜市",
  370883: "邹城市",
  370900: "泰安市",
  370901: "市辖区",
  370902: "泰山区",
  370911: "岱岳区",
  370921: "宁阳县",
  370923: "东平县",
  370982: "新泰市",
  370983: "肥城市",
  371e3: "威海市",
  371001: "市辖区",
  371002: "环翠区",
  371003: "文登区",
  371082: "荣成市",
  371083: "乳山市",
  371100: "日照市",
  371101: "市辖区",
  371102: "东港区",
  371103: "岚山区",
  371121: "五莲县",
  371122: "莒县",
  371200: "莱芜市",
  371201: "市辖区",
  371202: "莱城区",
  371203: "钢城区",
  371300: "临沂市",
  371301: "市辖区",
  371302: "兰山区",
  371311: "罗庄区",
  371312: "河东区",
  371321: "沂南县",
  371322: "郯城县",
  371323: "沂水县",
  371324: "兰陵县",
  371325: "费县",
  371326: "平邑县",
  371327: "莒南县",
  371328: "蒙阴县",
  371329: "临沭县",
  371400: "德州市",
  371401: "市辖区",
  371402: "德城区",
  371403: "陵城区",
  371422: "宁津县",
  371423: "庆云县",
  371424: "临邑县",
  371425: "齐河县",
  371426: "平原县",
  371427: "夏津县",
  371428: "武城县",
  371481: "乐陵市",
  371482: "禹城市",
  371500: "聊城市",
  371501: "市辖区",
  371502: "东昌府区",
  371521: "阳谷县",
  371522: "莘县",
  371523: "茌平县",
  371524: "东阿县",
  371525: "冠县",
  371526: "高唐县",
  371581: "临清市",
  371600: "滨州市",
  371601: "市辖区",
  371602: "滨城区",
  371603: "沾化区",
  371621: "惠民县",
  371622: "阳信县",
  371623: "无棣县",
  371625: "博兴县",
  371626: "邹平县",
  371700: "菏泽市",
  371701: "市辖区",
  371702: "牡丹区",
  371703: "定陶区",
  371721: "曹县",
  371722: "单县",
  371723: "成武县",
  371724: "巨野县",
  371725: "郓城县",
  371726: "鄄城县",
  371728: "东明县",
  41e4: "河南省",
  410100: "郑州市",
  410101: "市辖区",
  410102: "中原区",
  410103: "二七区",
  410104: "管城回族区",
  410105: "金水区",
  410106: "上街区",
  410108: "惠济区",
  410122: "中牟县",
  410181: "巩义市",
  410182: "荥阳市",
  410183: "新密市",
  410184: "新郑市",
  410185: "登封市",
  410200: "开封市",
  410201: "市辖区",
  410202: "龙亭区",
  410203: "顺河回族区",
  410204: "鼓楼区",
  410205: "禹王台区",
  410211: "金明区",
  410212: "祥符区",
  410221: "杞县",
  410222: "通许县",
  410223: "尉氏县",
  410225: "兰考县",
  410300: "洛阳市",
  410301: "市辖区",
  410302: "老城区",
  410303: "西工区",
  410304: "瀍河回族区",
  410305: "涧西区",
  410306: "吉利区",
  410311: "洛龙区",
  410322: "孟津县",
  410323: "新安县",
  410324: "栾川县",
  410325: "嵩县",
  410326: "汝阳县",
  410327: "宜阳县",
  410328: "洛宁县",
  410329: "伊川县",
  410381: "偃师市",
  410400: "平顶山市",
  410401: "市辖区",
  410402: "新华区",
  410403: "卫东区",
  410404: "石龙区",
  410411: "湛河区",
  410421: "宝丰县",
  410422: "叶县",
  410423: "鲁山县",
  410425: "郏县",
  410481: "舞钢市",
  410482: "汝州市",
  410500: "安阳市",
  410501: "市辖区",
  410502: "文峰区",
  410503: "北关区",
  410505: "殷都区",
  410506: "龙安区",
  410522: "安阳县",
  410523: "汤阴县",
  410526: "滑县",
  410527: "内黄县",
  410581: "林州市",
  410600: "鹤壁市",
  410601: "市辖区",
  410602: "鹤山区",
  410603: "山城区",
  410611: "淇滨区",
  410621: "浚县",
  410622: "淇县",
  410700: "新乡市",
  410701: "市辖区",
  410702: "红旗区",
  410703: "卫滨区",
  410704: "凤泉区",
  410711: "牧野区",
  410721: "新乡县",
  410724: "获嘉县",
  410725: "原阳县",
  410726: "延津县",
  410727: "封丘县",
  410728: "长垣县",
  410781: "卫辉市",
  410782: "辉县市",
  410800: "焦作市",
  410801: "市辖区",
  410802: "解放区",
  410803: "中站区",
  410804: "马村区",
  410811: "山阳区",
  410821: "修武县",
  410822: "博爱县",
  410823: "武陟县",
  410825: "温县",
  410882: "沁阳市",
  410883: "孟州市",
  410900: "濮阳市",
  410901: "市辖区",
  410902: "华龙区",
  410922: "清丰县",
  410923: "南乐县",
  410926: "范县",
  410927: "台前县",
  410928: "濮阳县",
  411e3: "许昌市",
  411001: "市辖区",
  411002: "魏都区",
  411023: "许昌县",
  411024: "鄢陵县",
  411025: "襄城县",
  411081: "禹州市",
  411082: "长葛市",
  411100: "漯河市",
  411101: "市辖区",
  411102: "源汇区",
  411103: "郾城区",
  411104: "召陵区",
  411121: "舞阳县",
  411122: "临颍县",
  411200: "三门峡市",
  411201: "市辖区",
  411202: "湖滨区",
  411203: "陕州区",
  411221: "渑池县",
  411224: "卢氏县",
  411281: "义马市",
  411282: "灵宝市",
  411300: "南阳市",
  411301: "市辖区",
  411302: "宛城区",
  411303: "卧龙区",
  411321: "南召县",
  411322: "方城县",
  411323: "西峡县",
  411324: "镇平县",
  411325: "内乡县",
  411326: "淅川县",
  411327: "社旗县",
  411328: "唐河县",
  411329: "新野县",
  411330: "桐柏县",
  411381: "邓州市",
  411400: "商丘市",
  411401: "市辖区",
  411402: "梁园区",
  411403: "睢阳区",
  411421: "民权县",
  411422: "睢县",
  411423: "宁陵县",
  411424: "柘城县",
  411425: "虞城县",
  411426: "夏邑县",
  411481: "永城市",
  411500: "信阳市",
  411501: "市辖区",
  411502: "浉河区",
  411503: "平桥区",
  411521: "罗山县",
  411522: "光山县",
  411523: "新县",
  411524: "商城县",
  411525: "固始县",
  411526: "潢川县",
  411527: "淮滨县",
  411528: "息县",
  411600: "周口市",
  411601: "市辖区",
  411602: "川汇区",
  411621: "扶沟县",
  411622: "西华县",
  411623: "商水县",
  411624: "沈丘县",
  411625: "郸城县",
  411626: "淮阳县",
  411627: "太康县",
  411628: "鹿邑县",
  411681: "项城市",
  411700: "驻马店市",
  411701: "市辖区",
  411702: "驿城区",
  411721: "西平县",
  411722: "上蔡县",
  411723: "平舆县",
  411724: "正阳县",
  411725: "确山县",
  411726: "泌阳县",
  411727: "汝南县",
  411728: "遂平县",
  411729: "新蔡县",
  419e3: "省直辖县级行政区划",
  419001: "济源市",
  42e4: "湖北省",
  420100: "武汉市",
  420101: "市辖区",
  420102: "江岸区",
  420103: "江汉区",
  420104: "硚口区",
  420105: "汉阳区",
  420106: "武昌区",
  420107: "青山区",
  420111: "洪山区",
  420112: "东西湖区",
  420113: "汉南区",
  420114: "蔡甸区",
  420115: "江夏区",
  420116: "黄陂区",
  420117: "新洲区",
  420200: "黄石市",
  420201: "市辖区",
  420202: "黄石港区",
  420203: "西塞山区",
  420204: "下陆区",
  420205: "铁山区",
  420222: "阳新县",
  420281: "大冶市",
  420300: "十堰市",
  420301: "市辖区",
  420302: "茅箭区",
  420303: "张湾区",
  420304: "郧阳区",
  420322: "郧西县",
  420323: "竹山县",
  420324: "竹溪县",
  420325: "房县",
  420381: "丹江口市",
  420500: "宜昌市",
  420501: "市辖区",
  420502: "西陵区",
  420503: "伍家岗区",
  420504: "点军区",
  420505: "猇亭区",
  420506: "夷陵区",
  420525: "远安县",
  420526: "兴山县",
  420527: "秭归县",
  420528: "长阳土家族自治县",
  420529: "五峰土家族自治县",
  420581: "宜都市",
  420582: "当阳市",
  420583: "枝江市",
  420600: "襄阳市",
  420601: "市辖区",
  420602: "襄城区",
  420606: "樊城区",
  420607: "襄州区",
  420624: "南漳县",
  420625: "谷城县",
  420626: "保康县",
  420682: "老河口市",
  420683: "枣阳市",
  420684: "宜城市",
  420700: "鄂州市",
  420701: "市辖区",
  420702: "梁子湖区",
  420703: "华容区",
  420704: "鄂城区",
  420800: "荆门市",
  420801: "市辖区",
  420802: "东宝区",
  420804: "掇刀区",
  420821: "京山县",
  420822: "沙洋县",
  420881: "钟祥市",
  420900: "孝感市",
  420901: "市辖区",
  420902: "孝南区",
  420921: "孝昌县",
  420922: "大悟县",
  420923: "云梦县",
  420981: "应城市",
  420982: "安陆市",
  420984: "汉川市",
  421e3: "荆州市",
  421001: "市辖区",
  421002: "沙市区",
  421003: "荆州区",
  421022: "公安县",
  421023: "监利县",
  421024: "江陵县",
  421081: "石首市",
  421083: "洪湖市",
  421087: "松滋市",
  421100: "黄冈市",
  421101: "市辖区",
  421102: "黄州区",
  421121: "团风县",
  421122: "红安县",
  421123: "罗田县",
  421124: "英山县",
  421125: "浠水县",
  421126: "蕲春县",
  421127: "黄梅县",
  421181: "麻城市",
  421182: "武穴市",
  421200: "咸宁市",
  421201: "市辖区",
  421202: "咸安区",
  421221: "嘉鱼县",
  421222: "通城县",
  421223: "崇阳县",
  421224: "通山县",
  421281: "赤壁市",
  421300: "随州市",
  421301: "市辖区",
  421303: "曾都区",
  421321: "随县",
  421381: "广水市",
  422800: "恩施土家族苗族自治州",
  422801: "恩施市",
  422802: "利川市",
  422822: "建始县",
  422823: "巴东县",
  422825: "宣恩县",
  422826: "咸丰县",
  422827: "来凤县",
  422828: "鹤峰县",
  429e3: "省直辖县级行政区划",
  429004: "仙桃市",
  429005: "潜江市",
  429006: "天门市",
  429021: "神农架林区",
  43e4: "湖南省",
  430100: "长沙市",
  430101: "市辖区",
  430102: "芙蓉区",
  430103: "天心区",
  430104: "岳麓区",
  430105: "开福区",
  430111: "雨花区",
  430112: "望城区",
  430121: "长沙县",
  430124: "宁乡县",
  430181: "浏阳市",
  430200: "株洲市",
  430201: "市辖区",
  430202: "荷塘区",
  430203: "芦淞区",
  430204: "石峰区",
  430211: "天元区",
  430221: "株洲县",
  430223: "攸县",
  430224: "茶陵县",
  430225: "炎陵县",
  430281: "醴陵市",
  430300: "湘潭市",
  430301: "市辖区",
  430302: "雨湖区",
  430304: "岳塘区",
  430321: "湘潭县",
  430381: "湘乡市",
  430382: "韶山市",
  430400: "衡阳市",
  430401: "市辖区",
  430405: "珠晖区",
  430406: "雁峰区",
  430407: "石鼓区",
  430408: "蒸湘区",
  430412: "南岳区",
  430421: "衡阳县",
  430422: "衡南县",
  430423: "衡山县",
  430424: "衡东县",
  430426: "祁东县",
  430481: "耒阳市",
  430482: "常宁市",
  430500: "邵阳市",
  430501: "市辖区",
  430502: "双清区",
  430503: "大祥区",
  430511: "北塔区",
  430521: "邵东县",
  430522: "新邵县",
  430523: "邵阳县",
  430524: "隆回县",
  430525: "洞口县",
  430527: "绥宁县",
  430528: "新宁县",
  430529: "城步苗族自治县",
  430581: "武冈市",
  430600: "岳阳市",
  430601: "市辖区",
  430602: "岳阳楼区",
  430603: "云溪区",
  430611: "君山区",
  430621: "岳阳县",
  430623: "华容县",
  430624: "湘阴县",
  430626: "平江县",
  430681: "汨罗市",
  430682: "临湘市",
  430700: "常德市",
  430701: "市辖区",
  430702: "武陵区",
  430703: "鼎城区",
  430721: "安乡县",
  430722: "汉寿县",
  430723: "澧县",
  430724: "临澧县",
  430725: "桃源县",
  430726: "石门县",
  430781: "津市市",
  430800: "张家界市",
  430801: "市辖区",
  430802: "永定区",
  430811: "武陵源区",
  430821: "慈利县",
  430822: "桑植县",
  430900: "益阳市",
  430901: "市辖区",
  430902: "资阳区",
  430903: "赫山区",
  430921: "南县",
  430922: "桃江县",
  430923: "安化县",
  430981: "沅江市",
  431e3: "郴州市",
  431001: "市辖区",
  431002: "北湖区",
  431003: "苏仙区",
  431021: "桂阳县",
  431022: "宜章县",
  431023: "永兴县",
  431024: "嘉禾县",
  431025: "临武县",
  431026: "汝城县",
  431027: "桂东县",
  431028: "安仁县",
  431081: "资兴市",
  431100: "永州市",
  431101: "市辖区",
  431102: "零陵区",
  431103: "冷水滩区",
  431121: "祁阳县",
  431122: "东安县",
  431123: "双牌县",
  431124: "道县",
  431125: "江永县",
  431126: "宁远县",
  431127: "蓝山县",
  431128: "新田县",
  431129: "江华瑶族自治县",
  431200: "怀化市",
  431201: "市辖区",
  431202: "鹤城区",
  431221: "中方县",
  431222: "沅陵县",
  431223: "辰溪县",
  431224: "溆浦县",
  431225: "会同县",
  431226: "麻阳苗族自治县",
  431227: "新晃侗族自治县",
  431228: "芷江侗族自治县",
  431229: "靖州苗族侗族自治县",
  431230: "通道侗族自治县",
  431281: "洪江市",
  431300: "娄底市",
  431301: "市辖区",
  431302: "娄星区",
  431321: "双峰县",
  431322: "新化县",
  431381: "冷水江市",
  431382: "涟源市",
  433100: "湘西土家族苗族自治州",
  433101: "吉首市",
  433122: "泸溪县",
  433123: "凤凰县",
  433124: "花垣县",
  433125: "保靖县",
  433126: "古丈县",
  433127: "永顺县",
  433130: "龙山县",
  44e4: "广东省",
  440100: "广州市",
  440101: "市辖区",
  440103: "荔湾区",
  440104: "越秀区",
  440105: "海珠区",
  440106: "天河区",
  440111: "白云区",
  440112: "黄埔区",
  440113: "番禺区",
  440114: "花都区",
  440115: "南沙区",
  440117: "从化区",
  440118: "增城区",
  440200: "韶关市",
  440201: "市辖区",
  440203: "武江区",
  440204: "浈江区",
  440205: "曲江区",
  440222: "始兴县",
  440224: "仁化县",
  440229: "翁源县",
  440232: "乳源瑶族自治县",
  440233: "新丰县",
  440281: "乐昌市",
  440282: "南雄市",
  440300: "深圳市",
  440301: "市辖区",
  440303: "罗湖区",
  440304: "福田区",
  440305: "南山区",
  440306: "宝安区",
  440307: "龙岗区",
  440308: "盐田区",
  440400: "珠海市",
  440401: "市辖区",
  440402: "香洲区",
  440403: "斗门区",
  440404: "金湾区",
  440500: "汕头市",
  440501: "市辖区",
  440507: "龙湖区",
  440511: "金平区",
  440512: "濠江区",
  440513: "潮阳区",
  440514: "潮南区",
  440515: "澄海区",
  440523: "南澳县",
  440600: "佛山市",
  440601: "市辖区",
  440604: "禅城区",
  440605: "南海区",
  440606: "顺德区",
  440607: "三水区",
  440608: "高明区",
  440700: "江门市",
  440701: "市辖区",
  440703: "蓬江区",
  440704: "江海区",
  440705: "新会区",
  440781: "台山市",
  440783: "开平市",
  440784: "鹤山市",
  440785: "恩平市",
  440800: "湛江市",
  440801: "市辖区",
  440802: "赤坎区",
  440803: "霞山区",
  440804: "坡头区",
  440811: "麻章区",
  440823: "遂溪县",
  440825: "徐闻县",
  440881: "廉江市",
  440882: "雷州市",
  440883: "吴川市",
  440900: "茂名市",
  440901: "市辖区",
  440902: "茂南区",
  440904: "电白区",
  440981: "高州市",
  440982: "化州市",
  440983: "信宜市",
  441200: "肇庆市",
  441201: "市辖区",
  441202: "端州区",
  441203: "鼎湖区",
  441204: "高要区",
  441223: "广宁县",
  441224: "怀集县",
  441225: "封开县",
  441226: "德庆县",
  441284: "四会市",
  441300: "惠州市",
  441301: "市辖区",
  441302: "惠城区",
  441303: "惠阳区",
  441322: "博罗县",
  441323: "惠东县",
  441324: "龙门县",
  441400: "梅州市",
  441401: "市辖区",
  441402: "梅江区",
  441403: "梅县区",
  441422: "大埔县",
  441423: "丰顺县",
  441424: "五华县",
  441426: "平远县",
  441427: "蕉岭县",
  441481: "兴宁市",
  441500: "汕尾市",
  441501: "市辖区",
  441502: "城区",
  441521: "海丰县",
  441523: "陆河县",
  441581: "陆丰市",
  441600: "河源市",
  441601: "市辖区",
  441602: "源城区",
  441621: "紫金县",
  441622: "龙川县",
  441623: "连平县",
  441624: "和平县",
  441625: "东源县",
  441700: "阳江市",
  441701: "市辖区",
  441702: "江城区",
  441704: "阳东区",
  441721: "阳西县",
  441781: "阳春市",
  441800: "清远市",
  441801: "市辖区",
  441802: "清城区",
  441803: "清新区",
  441821: "佛冈县",
  441823: "阳山县",
  441825: "连山壮族瑶族自治县",
  441826: "连南瑶族自治县",
  441881: "英德市",
  441882: "连州市",
  441900: "东莞市",
  442e3: "中山市",
  445100: "潮州市",
  445101: "市辖区",
  445102: "湘桥区",
  445103: "潮安区",
  445122: "饶平县",
  445200: "揭阳市",
  445201: "市辖区",
  445202: "榕城区",
  445203: "揭东区",
  445222: "揭西县",
  445224: "惠来县",
  445281: "普宁市",
  445300: "云浮市",
  445301: "市辖区",
  445302: "云城区",
  445303: "云安区",
  445321: "新兴县",
  445322: "郁南县",
  445381: "罗定市",
  45e4: "广西壮族自治区",
  450100: "南宁市",
  450101: "市辖区",
  450102: "兴宁区",
  450103: "青秀区",
  450105: "江南区",
  450107: "西乡塘区",
  450108: "良庆区",
  450109: "邕宁区",
  450110: "武鸣区",
  450123: "隆安县",
  450124: "马山县",
  450125: "上林县",
  450126: "宾阳县",
  450127: "横县",
  450200: "柳州市",
  450201: "市辖区",
  450202: "城中区",
  450203: "鱼峰区",
  450204: "柳南区",
  450205: "柳北区",
  450206: "柳江区",
  450222: "柳城县",
  450223: "鹿寨县",
  450224: "融安县",
  450225: "融水苗族自治县",
  450226: "三江侗族自治县",
  450300: "桂林市",
  450301: "市辖区",
  450302: "秀峰区",
  450303: "叠彩区",
  450304: "象山区",
  450305: "七星区",
  450311: "雁山区",
  450312: "临桂区",
  450321: "阳朔县",
  450323: "灵川县",
  450324: "全州县",
  450325: "兴安县",
  450326: "永福县",
  450327: "灌阳县",
  450328: "龙胜各族自治县",
  450329: "资源县",
  450330: "平乐县",
  450331: "荔浦县",
  450332: "恭城瑶族自治县",
  450400: "梧州市",
  450401: "市辖区",
  450403: "万秀区",
  450405: "长洲区",
  450406: "龙圩区",
  450421: "苍梧县",
  450422: "藤县",
  450423: "蒙山县",
  450481: "岑溪市",
  450500: "北海市",
  450501: "市辖区",
  450502: "海城区",
  450503: "银海区",
  450512: "铁山港区",
  450521: "合浦县",
  450600: "防城港市",
  450601: "市辖区",
  450602: "港口区",
  450603: "防城区",
  450621: "上思县",
  450681: "东兴市",
  450700: "钦州市",
  450701: "市辖区",
  450702: "钦南区",
  450703: "钦北区",
  450721: "灵山县",
  450722: "浦北县",
  450800: "贵港市",
  450801: "市辖区",
  450802: "港北区",
  450803: "港南区",
  450804: "覃塘区",
  450821: "平南县",
  450881: "桂平市",
  450900: "玉林市",
  450901: "市辖区",
  450902: "玉州区",
  450903: "福绵区",
  450921: "容县",
  450922: "陆川县",
  450923: "博白县",
  450924: "兴业县",
  450981: "北流市",
  451e3: "百色市",
  451001: "市辖区",
  451002: "右江区",
  451021: "田阳县",
  451022: "田东县",
  451023: "平果县",
  451024: "德保县",
  451026: "那坡县",
  451027: "凌云县",
  451028: "乐业县",
  451029: "田林县",
  451030: "西林县",
  451031: "隆林各族自治县",
  451081: "靖西市",
  451100: "贺州市",
  451101: "市辖区",
  451102: "八步区",
  451103: "平桂区",
  451121: "昭平县",
  451122: "钟山县",
  451123: "富川瑶族自治县",
  451200: "河池市",
  451201: "市辖区",
  451202: "金城江区",
  451221: "南丹县",
  451222: "天峨县",
  451223: "凤山县",
  451224: "东兰县",
  451225: "罗城仫佬族自治县",
  451226: "环江毛南族自治县",
  451227: "巴马瑶族自治县",
  451228: "都安瑶族自治县",
  451229: "大化瑶族自治县",
  451281: "宜州市",
  451300: "来宾市",
  451301: "市辖区",
  451302: "兴宾区",
  451321: "忻城县",
  451322: "象州县",
  451323: "武宣县",
  451324: "金秀瑶族自治县",
  451381: "合山市",
  451400: "崇左市",
  451401: "市辖区",
  451402: "江州区",
  451421: "扶绥县",
  451422: "宁明县",
  451423: "龙州县",
  451424: "大新县",
  451425: "天等县",
  451481: "凭祥市",
  46e4: "海南省",
  460100: "海口市",
  460101: "市辖区",
  460105: "秀英区",
  460106: "龙华区",
  460107: "琼山区",
  460108: "美兰区",
  460200: "三亚市",
  460201: "市辖区",
  460202: "海棠区",
  460203: "吉阳区",
  460204: "天涯区",
  460205: "崖州区",
  460300: "三沙市",
  460400: "儋州市",
  469e3: "省直辖县级行政区划",
  469001: "五指山市",
  469002: "琼海市",
  469005: "文昌市",
  469006: "万宁市",
  469007: "东方市",
  469021: "定安县",
  469022: "屯昌县",
  469023: "澄迈县",
  469024: "临高县",
  469025: "白沙黎族自治县",
  469026: "昌江黎族自治县",
  469027: "乐东黎族自治县",
  469028: "陵水黎族自治县",
  469029: "保亭黎族苗族自治县",
  469030: "琼中黎族苗族自治县",
  5e5: "重庆市",
  500100: "市辖区",
  500101: "万州区",
  500102: "涪陵区",
  500103: "渝中区",
  500104: "大渡口区",
  500105: "江北区",
  500106: "沙坪坝区",
  500107: "九龙坡区",
  500108: "南岸区",
  500109: "北碚区",
  500110: "綦江区",
  500111: "大足区",
  500112: "渝北区",
  500113: "巴南区",
  500114: "黔江区",
  500115: "长寿区",
  500116: "江津区",
  500117: "合川区",
  500118: "永川区",
  500119: "南川区",
  500120: "璧山区",
  500151: "铜梁区",
  500152: "潼南区",
  500153: "荣昌区",
  500154: "开州区",
  500200: "县",
  500228: "梁平县",
  500229: "城口县",
  500230: "丰都县",
  500231: "垫江县",
  500232: "武隆县",
  500233: "忠县",
  500235: "云阳县",
  500236: "奉节县",
  500237: "巫山县",
  500238: "巫溪县",
  500240: "石柱土家族自治县",
  500241: "秀山土家族苗族自治县",
  500242: "酉阳土家族苗族自治县",
  500243: "彭水苗族土家族自治县",
  51e4: "四川省",
  510100: "成都市",
  510101: "市辖区",
  510104: "锦江区",
  510105: "青羊区",
  510106: "金牛区",
  510107: "武侯区",
  510108: "成华区",
  510112: "龙泉驿区",
  510113: "青白江区",
  510114: "新都区",
  510115: "温江区",
  510116: "双流区",
  510121: "金堂县",
  510124: "郫县",
  510129: "大邑县",
  510131: "蒲江县",
  510132: "新津县",
  510181: "都江堰市",
  510182: "彭州市",
  510183: "邛崃市",
  510184: "崇州市",
  510185: "简阳市",
  510300: "自贡市",
  510301: "市辖区",
  510302: "自流井区",
  510303: "贡井区",
  510304: "大安区",
  510311: "沿滩区",
  510321: "荣县",
  510322: "富顺县",
  510400: "攀枝花市",
  510401: "市辖区",
  510402: "东区",
  510403: "西区",
  510411: "仁和区",
  510421: "米易县",
  510422: "盐边县",
  510500: "泸州市",
  510501: "市辖区",
  510502: "江阳区",
  510503: "纳溪区",
  510504: "龙马潭区",
  510521: "泸县",
  510522: "合江县",
  510524: "叙永县",
  510525: "古蔺县",
  510600: "德阳市",
  510601: "市辖区",
  510603: "旌阳区",
  510623: "中江县",
  510626: "罗江县",
  510681: "广汉市",
  510682: "什邡市",
  510683: "绵竹市",
  510700: "绵阳市",
  510701: "市辖区",
  510703: "涪城区",
  510704: "游仙区",
  510705: "安州区",
  510722: "三台县",
  510723: "盐亭县",
  510725: "梓潼县",
  510726: "北川羌族自治县",
  510727: "平武县",
  510781: "江油市",
  510800: "广元市",
  510801: "市辖区",
  510802: "利州区",
  510811: "昭化区",
  510812: "朝天区",
  510821: "旺苍县",
  510822: "青川县",
  510823: "剑阁县",
  510824: "苍溪县",
  510900: "遂宁市",
  510901: "市辖区",
  510903: "船山区",
  510904: "安居区",
  510921: "蓬溪县",
  510922: "射洪县",
  510923: "大英县",
  511e3: "内江市",
  511001: "市辖区",
  511002: "市中区",
  511011: "东兴区",
  511024: "威远县",
  511025: "资中县",
  511028: "隆昌县",
  511100: "乐山市",
  511101: "市辖区",
  511102: "市中区",
  511111: "沙湾区",
  511112: "五通桥区",
  511113: "金口河区",
  511123: "犍为县",
  511124: "井研县",
  511126: "夹江县",
  511129: "沐川县",
  511132: "峨边彝族自治县",
  511133: "马边彝族自治县",
  511181: "峨眉山市",
  511300: "南充市",
  511301: "市辖区",
  511302: "顺庆区",
  511303: "高坪区",
  511304: "嘉陵区",
  511321: "南部县",
  511322: "营山县",
  511323: "蓬安县",
  511324: "仪陇县",
  511325: "西充县",
  511381: "阆中市",
  511400: "眉山市",
  511401: "市辖区",
  511402: "东坡区",
  511403: "彭山区",
  511421: "仁寿县",
  511423: "洪雅县",
  511424: "丹棱县",
  511425: "青神县",
  511500: "宜宾市",
  511501: "市辖区",
  511502: "翠屏区",
  511503: "南溪区",
  511521: "宜宾县",
  511523: "江安县",
  511524: "长宁县",
  511525: "高县",
  511526: "珙县",
  511527: "筠连县",
  511528: "兴文县",
  511529: "屏山县",
  511600: "广安市",
  511601: "市辖区",
  511602: "广安区",
  511603: "前锋区",
  511621: "岳池县",
  511622: "武胜县",
  511623: "邻水县",
  511681: "华蓥市",
  511700: "达州市",
  511701: "市辖区",
  511702: "通川区",
  511703: "达川区",
  511722: "宣汉县",
  511723: "开江县",
  511724: "大竹县",
  511725: "渠县",
  511781: "万源市",
  511800: "雅安市",
  511801: "市辖区",
  511802: "雨城区",
  511803: "名山区",
  511822: "荥经县",
  511823: "汉源县",
  511824: "石棉县",
  511825: "天全县",
  511826: "芦山县",
  511827: "宝兴县",
  511900: "巴中市",
  511901: "市辖区",
  511902: "巴州区",
  511903: "恩阳区",
  511921: "通江县",
  511922: "南江县",
  511923: "平昌县",
  512e3: "资阳市",
  512001: "市辖区",
  512002: "雁江区",
  512021: "安岳县",
  512022: "乐至县",
  513200: "阿坝藏族羌族自治州",
  513201: "马尔康市",
  513221: "汶川县",
  513222: "理县",
  513223: "茂县",
  513224: "松潘县",
  513225: "九寨沟县",
  513226: "金川县",
  513227: "小金县",
  513228: "黑水县",
  513230: "壤塘县",
  513231: "阿坝县",
  513232: "若尔盖县",
  513233: "红原县",
  513300: "甘孜藏族自治州",
  513301: "康定市",
  513322: "泸定县",
  513323: "丹巴县",
  513324: "九龙县",
  513325: "雅江县",
  513326: "道孚县",
  513327: "炉霍县",
  513328: "甘孜县",
  513329: "新龙县",
  513330: "德格县",
  513331: "白玉县",
  513332: "石渠县",
  513333: "色达县",
  513334: "理塘县",
  513335: "巴塘县",
  513336: "乡城县",
  513337: "稻城县",
  513338: "得荣县",
  513400: "凉山彝族自治州",
  513401: "西昌市",
  513422: "木里藏族自治县",
  513423: "盐源县",
  513424: "德昌县",
  513425: "会理县",
  513426: "会东县",
  513427: "宁南县",
  513428: "普格县",
  513429: "布拖县",
  513430: "金阳县",
  513431: "昭觉县",
  513432: "喜德县",
  513433: "冕宁县",
  513434: "越西县",
  513435: "甘洛县",
  513436: "美姑县",
  513437: "雷波县",
  52e4: "贵州省",
  520100: "贵阳市",
  520101: "市辖区",
  520102: "南明区",
  520103: "云岩区",
  520111: "花溪区",
  520112: "乌当区",
  520113: "白云区",
  520115: "观山湖区",
  520121: "开阳县",
  520122: "息烽县",
  520123: "修文县",
  520181: "清镇市",
  520200: "六盘水市",
  520201: "钟山区",
  520203: "六枝特区",
  520221: "水城县",
  520222: "盘县",
  520300: "遵义市",
  520301: "市辖区",
  520302: "红花岗区",
  520303: "汇川区",
  520304: "播州区",
  520322: "桐梓县",
  520323: "绥阳县",
  520324: "正安县",
  520325: "道真仡佬族苗族自治县",
  520326: "务川仡佬族苗族自治县",
  520327: "凤冈县",
  520328: "湄潭县",
  520329: "余庆县",
  520330: "习水县",
  520381: "赤水市",
  520382: "仁怀市",
  520400: "安顺市",
  520401: "市辖区",
  520402: "西秀区",
  520403: "平坝区",
  520422: "普定县",
  520423: "镇宁布依族苗族自治县",
  520424: "关岭布依族苗族自治县",
  520425: "紫云苗族布依族自治县",
  520500: "毕节市",
  520501: "市辖区",
  520502: "七星关区",
  520521: "大方县",
  520522: "黔西县",
  520523: "金沙县",
  520524: "织金县",
  520525: "纳雍县",
  520526: "威宁彝族回族苗族自治县",
  520527: "赫章县",
  520600: "铜仁市",
  520601: "市辖区",
  520602: "碧江区",
  520603: "万山区",
  520621: "江口县",
  520622: "玉屏侗族自治县",
  520623: "石阡县",
  520624: "思南县",
  520625: "印江土家族苗族自治县",
  520626: "德江县",
  520627: "沿河土家族自治县",
  520628: "松桃苗族自治县",
  522300: "黔西南布依族苗族自治州",
  522301: "兴义市",
  522322: "兴仁县",
  522323: "普安县",
  522324: "晴隆县",
  522325: "贞丰县",
  522326: "望谟县",
  522327: "册亨县",
  522328: "安龙县",
  522600: "黔东南苗族侗族自治州",
  522601: "凯里市",
  522622: "黄平县",
  522623: "施秉县",
  522624: "三穗县",
  522625: "镇远县",
  522626: "岑巩县",
  522627: "天柱县",
  522628: "锦屏县",
  522629: "剑河县",
  522630: "台江县",
  522631: "黎平县",
  522632: "榕江县",
  522633: "从江县",
  522634: "雷山县",
  522635: "麻江县",
  522636: "丹寨县",
  522700: "黔南布依族苗族自治州",
  522701: "都匀市",
  522702: "福泉市",
  522722: "荔波县",
  522723: "贵定县",
  522725: "瓮安县",
  522726: "独山县",
  522727: "平塘县",
  522728: "罗甸县",
  522729: "长顺县",
  522730: "龙里县",
  522731: "惠水县",
  522732: "三都水族自治县",
  53e4: "云南省",
  530100: "昆明市",
  530101: "市辖区",
  530102: "五华区",
  530103: "盘龙区",
  530111: "官渡区",
  530112: "西山区",
  530113: "东川区",
  530114: "呈贡区",
  530122: "晋宁县",
  530124: "富民县",
  530125: "宜良县",
  530126: "石林彝族自治县",
  530127: "嵩明县",
  530128: "禄劝彝族苗族自治县",
  530129: "寻甸回族彝族自治县",
  530181: "安宁市",
  530300: "曲靖市",
  530301: "市辖区",
  530302: "麒麟区",
  530303: "沾益区",
  530321: "马龙县",
  530322: "陆良县",
  530323: "师宗县",
  530324: "罗平县",
  530325: "富源县",
  530326: "会泽县",
  530381: "宣威市",
  530400: "玉溪市",
  530401: "市辖区",
  530402: "红塔区",
  530403: "江川区",
  530422: "澄江县",
  530423: "通海县",
  530424: "华宁县",
  530425: "易门县",
  530426: "峨山彝族自治县",
  530427: "新平彝族傣族自治县",
  530428: "元江哈尼族彝族傣族自治县",
  530500: "保山市",
  530501: "市辖区",
  530502: "隆阳区",
  530521: "施甸县",
  530523: "龙陵县",
  530524: "昌宁县",
  530581: "腾冲市",
  530600: "昭通市",
  530601: "市辖区",
  530602: "昭阳区",
  530621: "鲁甸县",
  530622: "巧家县",
  530623: "盐津县",
  530624: "大关县",
  530625: "永善县",
  530626: "绥江县",
  530627: "镇雄县",
  530628: "彝良县",
  530629: "威信县",
  530630: "水富县",
  530700: "丽江市",
  530701: "市辖区",
  530702: "古城区",
  530721: "玉龙纳西族自治县",
  530722: "永胜县",
  530723: "华坪县",
  530724: "宁蒗彝族自治县",
  530800: "普洱市",
  530801: "市辖区",
  530802: "思茅区",
  530821: "宁洱哈尼族彝族自治县",
  530822: "墨江哈尼族自治县",
  530823: "景东彝族自治县",
  530824: "景谷傣族彝族自治县",
  530825: "镇沅彝族哈尼族拉祜族自治县",
  530826: "江城哈尼族彝族自治县",
  530827: "孟连傣族拉祜族佤族自治县",
  530828: "澜沧拉祜族自治县",
  530829: "西盟佤族自治县",
  530900: "临沧市",
  530901: "市辖区",
  530902: "临翔区",
  530921: "凤庆县",
  530922: "云县",
  530923: "永德县",
  530924: "镇康县",
  530925: "双江拉祜族佤族布朗族傣族自治县",
  530926: "耿马傣族佤族自治县",
  530927: "沧源佤族自治县",
  532300: "楚雄彝族自治州",
  532301: "楚雄市",
  532322: "双柏县",
  532323: "牟定县",
  532324: "南华县",
  532325: "姚安县",
  532326: "大姚县",
  532327: "永仁县",
  532328: "元谋县",
  532329: "武定县",
  532331: "禄丰县",
  532500: "红河哈尼族彝族自治州",
  532501: "个旧市",
  532502: "开远市",
  532503: "蒙自市",
  532504: "弥勒市",
  532523: "屏边苗族自治县",
  532524: "建水县",
  532525: "石屏县",
  532527: "泸西县",
  532528: "元阳县",
  532529: "红河县",
  532530: "金平苗族瑶族傣族自治县",
  532531: "绿春县",
  532532: "河口瑶族自治县",
  532600: "文山壮族苗族自治州",
  532601: "文山市",
  532622: "砚山县",
  532623: "西畴县",
  532624: "麻栗坡县",
  532625: "马关县",
  532626: "丘北县",
  532627: "广南县",
  532628: "富宁县",
  532800: "西双版纳傣族自治州",
  532801: "景洪市",
  532822: "勐海县",
  532823: "勐腊县",
  532900: "大理白族自治州",
  532901: "大理市",
  532922: "漾濞彝族自治县",
  532923: "祥云县",
  532924: "宾川县",
  532925: "弥渡县",
  532926: "南涧彝族自治县",
  532927: "巍山彝族回族自治县",
  532928: "永平县",
  532929: "云龙县",
  532930: "洱源县",
  532931: "剑川县",
  532932: "鹤庆县",
  533100: "德宏傣族景颇族自治州",
  533102: "瑞丽市",
  533103: "芒市",
  533122: "梁河县",
  533123: "盈江县",
  533124: "陇川县",
  533300: "怒江傈僳族自治州",
  533301: "泸水市",
  533323: "福贡县",
  533324: "贡山独龙族怒族自治县",
  533325: "兰坪白族普米族自治县",
  533400: "迪庆藏族自治州",
  533401: "香格里拉市",
  533422: "德钦县",
  533423: "维西傈僳族自治县",
  54e4: "西藏自治区",
  540100: "拉萨市",
  540101: "市辖区",
  540102: "城关区",
  540103: "堆龙德庆区",
  540121: "林周县",
  540122: "当雄县",
  540123: "尼木县",
  540124: "曲水县",
  540126: "达孜县",
  540127: "墨竹工卡县",
  540200: "日喀则市",
  540202: "桑珠孜区",
  540221: "南木林县",
  540222: "江孜县",
  540223: "定日县",
  540224: "萨迦县",
  540225: "拉孜县",
  540226: "昂仁县",
  540227: "谢通门县",
  540228: "白朗县",
  540229: "仁布县",
  540230: "康马县",
  540231: "定结县",
  540232: "仲巴县",
  540233: "亚东县",
  540234: "吉隆县",
  540235: "聂拉木县",
  540236: "萨嘎县",
  540237: "岗巴县",
  540300: "昌都市",
  540302: "卡若区",
  540321: "江达县",
  540322: "贡觉县",
  540323: "类乌齐县",
  540324: "丁青县",
  540325: "察雅县",
  540326: "八宿县",
  540327: "左贡县",
  540328: "芒康县",
  540329: "洛隆县",
  540330: "边坝县",
  540400: "林芝市",
  540402: "巴宜区",
  540421: "工布江达县",
  540422: "米林县",
  540423: "墨脱县",
  540424: "波密县",
  540425: "察隅县",
  540426: "朗县",
  540500: "山南市",
  540501: "市辖区",
  540502: "乃东区",
  540521: "扎囊县",
  540522: "贡嘎县",
  540523: "桑日县",
  540524: "琼结县",
  540525: "曲松县",
  540526: "措美县",
  540527: "洛扎县",
  540528: "加查县",
  540529: "隆子县",
  540530: "错那县",
  540531: "浪卡子县",
  542400: "那曲地区",
  542421: "那曲县",
  542422: "嘉黎县",
  542423: "比如县",
  542424: "聂荣县",
  542425: "安多县",
  542426: "申扎县",
  542427: "索县",
  542428: "班戈县",
  542429: "巴青县",
  542430: "尼玛县",
  542431: "双湖县",
  542500: "阿里地区",
  542521: "普兰县",
  542522: "札达县",
  542523: "噶尔县",
  542524: "日土县",
  542525: "革吉县",
  542526: "改则县",
  542527: "措勤县",
  61e4: "陕西省",
  610100: "西安市",
  610101: "市辖区",
  610102: "新城区",
  610103: "碑林区",
  610104: "莲湖区",
  610111: "灞桥区",
  610112: "未央区",
  610113: "雁塔区",
  610114: "阎良区",
  610115: "临潼区",
  610116: "长安区",
  610117: "高陵区",
  610122: "蓝田县",
  610124: "周至县",
  610125: "户县",
  610200: "铜川市",
  610201: "市辖区",
  610202: "王益区",
  610203: "印台区",
  610204: "耀州区",
  610222: "宜君县",
  610300: "宝鸡市",
  610301: "市辖区",
  610302: "渭滨区",
  610303: "金台区",
  610304: "陈仓区",
  610322: "凤翔县",
  610323: "岐山县",
  610324: "扶风县",
  610326: "眉县",
  610327: "陇县",
  610328: "千阳县",
  610329: "麟游县",
  610330: "凤县",
  610331: "太白县",
  610400: "咸阳市",
  610401: "市辖区",
  610402: "秦都区",
  610403: "杨陵区",
  610404: "渭城区",
  610422: "三原县",
  610423: "泾阳县",
  610424: "乾县",
  610425: "礼泉县",
  610426: "永寿县",
  610427: "彬县",
  610428: "长武县",
  610429: "旬邑县",
  610430: "淳化县",
  610431: "武功县",
  610481: "兴平市",
  610500: "渭南市",
  610501: "市辖区",
  610502: "临渭区",
  610503: "华州区",
  610522: "潼关县",
  610523: "大荔县",
  610524: "合阳县",
  610525: "澄城县",
  610526: "蒲城县",
  610527: "白水县",
  610528: "富平县",
  610581: "韩城市",
  610582: "华阴市",
  610600: "延安市",
  610601: "市辖区",
  610602: "宝塔区",
  610603: "安塞区",
  610621: "延长县",
  610622: "延川县",
  610623: "子长县",
  610625: "志丹县",
  610626: "吴起县",
  610627: "甘泉县",
  610628: "富县",
  610629: "洛川县",
  610630: "宜川县",
  610631: "黄龙县",
  610632: "黄陵县",
  610700: "汉中市",
  610701: "市辖区",
  610702: "汉台区",
  610721: "南郑县",
  610722: "城固县",
  610723: "洋县",
  610724: "西乡县",
  610725: "勉县",
  610726: "宁强县",
  610727: "略阳县",
  610728: "镇巴县",
  610729: "留坝县",
  610730: "佛坪县",
  610800: "榆林市",
  610801: "市辖区",
  610802: "榆阳区",
  610803: "横山区",
  610821: "神木县",
  610822: "府谷县",
  610824: "靖边县",
  610825: "定边县",
  610826: "绥德县",
  610827: "米脂县",
  610828: "佳县",
  610829: "吴堡县",
  610830: "清涧县",
  610831: "子洲县",
  610900: "安康市",
  610901: "市辖区",
  610902: "汉滨区",
  610921: "汉阴县",
  610922: "石泉县",
  610923: "宁陕县",
  610924: "紫阳县",
  610925: "岚皋县",
  610926: "平利县",
  610927: "镇坪县",
  610928: "旬阳县",
  610929: "白河县",
  611e3: "商洛市",
  611001: "市辖区",
  611002: "商州区",
  611021: "洛南县",
  611022: "丹凤县",
  611023: "商南县",
  611024: "山阳县",
  611025: "镇安县",
  611026: "柞水县",
  62e4: "甘肃省",
  620100: "兰州市",
  620101: "市辖区",
  620102: "城关区",
  620103: "七里河区",
  620104: "西固区",
  620105: "安宁区",
  620111: "红古区",
  620121: "永登县",
  620122: "皋兰县",
  620123: "榆中县",
  620200: "嘉峪关市",
  620201: "市辖区",
  620300: "金昌市",
  620301: "市辖区",
  620302: "金川区",
  620321: "永昌县",
  620400: "白银市",
  620401: "市辖区",
  620402: "白银区",
  620403: "平川区",
  620421: "靖远县",
  620422: "会宁县",
  620423: "景泰县",
  620500: "天水市",
  620501: "市辖区",
  620502: "秦州区",
  620503: "麦积区",
  620521: "清水县",
  620522: "秦安县",
  620523: "甘谷县",
  620524: "武山县",
  620525: "张家川回族自治县",
  620600: "武威市",
  620601: "市辖区",
  620602: "凉州区",
  620621: "民勤县",
  620622: "古浪县",
  620623: "天祝藏族自治县",
  620700: "张掖市",
  620701: "市辖区",
  620702: "甘州区",
  620721: "肃南裕固族自治县",
  620722: "民乐县",
  620723: "临泽县",
  620724: "高台县",
  620725: "山丹县",
  620800: "平凉市",
  620801: "市辖区",
  620802: "崆峒区",
  620821: "泾川县",
  620822: "灵台县",
  620823: "崇信县",
  620824: "华亭县",
  620825: "庄浪县",
  620826: "静宁县",
  620900: "酒泉市",
  620901: "市辖区",
  620902: "肃州区",
  620921: "金塔县",
  620922: "瓜州县",
  620923: "肃北蒙古族自治县",
  620924: "阿克塞哈萨克族自治县",
  620981: "玉门市",
  620982: "敦煌市",
  621e3: "庆阳市",
  621001: "市辖区",
  621002: "西峰区",
  621021: "庆城县",
  621022: "环县",
  621023: "华池县",
  621024: "合水县",
  621025: "正宁县",
  621026: "宁县",
  621027: "镇原县",
  621100: "定西市",
  621101: "市辖区",
  621102: "安定区",
  621121: "通渭县",
  621122: "陇西县",
  621123: "渭源县",
  621124: "临洮县",
  621125: "漳县",
  621126: "岷县",
  621200: "陇南市",
  621201: "市辖区",
  621202: "武都区",
  621221: "成县",
  621222: "文县",
  621223: "宕昌县",
  621224: "康县",
  621225: "西和县",
  621226: "礼县",
  621227: "徽县",
  621228: "两当县",
  622900: "临夏回族自治州",
  622901: "临夏市",
  622921: "临夏县",
  622922: "康乐县",
  622923: "永靖县",
  622924: "广河县",
  622925: "和政县",
  622926: "东乡族自治县",
  622927: "积石山保安族东乡族撒拉族自治县",
  623e3: "甘南藏族自治州",
  623001: "合作市",
  623021: "临潭县",
  623022: "卓尼县",
  623023: "舟曲县",
  623024: "迭部县",
  623025: "玛曲县",
  623026: "碌曲县",
  623027: "夏河县",
  63e4: "青海省",
  630100: "西宁市",
  630101: "市辖区",
  630102: "城东区",
  630103: "城中区",
  630104: "城西区",
  630105: "城北区",
  630121: "大通回族土族自治县",
  630122: "湟中县",
  630123: "湟源县",
  630200: "海东市",
  630202: "乐都区",
  630203: "平安区",
  630222: "民和回族土族自治县",
  630223: "互助土族自治县",
  630224: "化隆回族自治县",
  630225: "循化撒拉族自治县",
  632200: "海北藏族自治州",
  632221: "门源回族自治县",
  632222: "祁连县",
  632223: "海晏县",
  632224: "刚察县",
  632300: "黄南藏族自治州",
  632321: "同仁县",
  632322: "尖扎县",
  632323: "泽库县",
  632324: "河南蒙古族自治县",
  632500: "海南藏族自治州",
  632521: "共和县",
  632522: "同德县",
  632523: "贵德县",
  632524: "兴海县",
  632525: "贵南县",
  632600: "果洛藏族自治州",
  632621: "玛沁县",
  632622: "班玛县",
  632623: "甘德县",
  632624: "达日县",
  632625: "久治县",
  632626: "玛多县",
  632700: "玉树藏族自治州",
  632701: "玉树市",
  632722: "杂多县",
  632723: "称多县",
  632724: "治多县",
  632725: "囊谦县",
  632726: "曲麻莱县",
  632800: "海西蒙古族藏族自治州",
  632801: "格尔木市",
  632802: "德令哈市",
  632821: "乌兰县",
  632822: "都兰县",
  632823: "天峻县",
  64e4: "宁夏回族自治区",
  640100: "银川市",
  640101: "市辖区",
  640104: "兴庆区",
  640105: "西夏区",
  640106: "金凤区",
  640121: "永宁县",
  640122: "贺兰县",
  640181: "灵武市",
  640200: "石嘴山市",
  640201: "市辖区",
  640202: "大武口区",
  640205: "惠农区",
  640221: "平罗县",
  640300: "吴忠市",
  640301: "市辖区",
  640302: "利通区",
  640303: "红寺堡区",
  640323: "盐池县",
  640324: "同心县",
  640381: "青铜峡市",
  640400: "固原市",
  640401: "市辖区",
  640402: "原州区",
  640422: "西吉县",
  640423: "隆德县",
  640424: "泾源县",
  640425: "彭阳县",
  640500: "中卫市",
  640501: "市辖区",
  640502: "沙坡头区",
  640521: "中宁县",
  640522: "海原县",
  65e4: "新疆维吾尔自治区",
  650100: "乌鲁木齐市",
  650101: "市辖区",
  650102: "天山区",
  650103: "沙依巴克区",
  650104: "新市区",
  650105: "水磨沟区",
  650106: "头屯河区",
  650107: "达坂城区",
  650109: "米东区",
  650121: "乌鲁木齐县",
  650200: "克拉玛依市",
  650201: "市辖区",
  650202: "独山子区",
  650203: "克拉玛依区",
  650204: "白碱滩区",
  650205: "乌尔禾区",
  650400: "吐鲁番市",
  650402: "高昌区",
  650421: "鄯善县",
  650422: "托克逊县",
  650500: "哈密市",
  650502: "伊州区",
  650521: "巴里坤哈萨克自治县",
  650522: "伊吾县",
  652300: "昌吉回族自治州",
  652301: "昌吉市",
  652302: "阜康市",
  652323: "呼图壁县",
  652324: "玛纳斯县",
  652325: "奇台县",
  652327: "吉木萨尔县",
  652328: "木垒哈萨克自治县",
  652700: "博尔塔拉蒙古自治州",
  652701: "博乐市",
  652702: "阿拉山口市",
  652722: "精河县",
  652723: "温泉县",
  652800: "巴音郭楞蒙古自治州",
  652801: "库尔勒市",
  652822: "轮台县",
  652823: "尉犁县",
  652824: "若羌县",
  652825: "且末县",
  652826: "焉耆回族自治县",
  652827: "和静县",
  652828: "和硕县",
  652829: "博湖县",
  652900: "阿克苏地区",
  652901: "阿克苏市",
  652922: "温宿县",
  652923: "库车县",
  652924: "沙雅县",
  652925: "新和县",
  652926: "拜城县",
  652927: "乌什县",
  652928: "阿瓦提县",
  652929: "柯坪县",
  653e3: "克孜勒苏柯尔克孜自治州",
  653001: "阿图什市",
  653022: "阿克陶县",
  653023: "阿合奇县",
  653024: "乌恰县",
  653100: "喀什地区",
  653101: "喀什市",
  653121: "疏附县",
  653122: "疏勒县",
  653123: "英吉沙县",
  653124: "泽普县",
  653125: "莎车县",
  653126: "叶城县",
  653127: "麦盖提县",
  653128: "岳普湖县",
  653129: "伽师县",
  653130: "巴楚县",
  653131: "塔什库尔干塔吉克自治县",
  653200: "和田地区",
  653201: "和田市",
  653221: "和田县",
  653222: "墨玉县",
  653223: "皮山县",
  653224: "洛浦县",
  653225: "策勒县",
  653226: "于田县",
  653227: "民丰县",
  654e3: "伊犁哈萨克自治州",
  654002: "伊宁市",
  654003: "奎屯市",
  654004: "霍尔果斯市",
  654021: "伊宁县",
  654022: "察布查尔锡伯自治县",
  654023: "霍城县",
  654024: "巩留县",
  654025: "新源县",
  654026: "昭苏县",
  654027: "特克斯县",
  654028: "尼勒克县",
  654200: "塔城地区",
  654201: "塔城市",
  654202: "乌苏市",
  654221: "额敏县",
  654223: "沙湾县",
  654224: "托里县",
  654225: "裕民县",
  654226: "和布克赛尔蒙古自治县",
  654300: "阿勒泰地区",
  654301: "阿勒泰市",
  654321: "布尔津县",
  654322: "富蕴县",
  654323: "福海县",
  654324: "哈巴河县",
  654325: "青河县",
  654326: "吉木乃县",
  659e3: "自治区直辖县级行政区划",
  659001: "石河子市",
  659002: "阿拉尔市",
  659003: "图木舒克市",
  659004: "五家渠市",
  659006: "铁门关市",
  71e4: "台湾省",
  81e4: "香港特别行政区",
  82e4: "澳门特别行政区"
};
function _r(e, t, n) {
  if (!e || e.length !== t || !/^[0-9A-Z]+$/.test(e))
    throw new Error(n);
}
function D(e, t, n) {
  if (t.findIndex((r) => r == e) < 0)
    throw new Error(n);
}
function Co(e, t, n) {
  const r = Object.entries(t).find(([s]) => s == e);
  if (!r)
    throw new Error(n || `{ ${e} } 不在范围内！`);
  return r[1];
}
function Fo(e, t, n) {
  const r = Object.entries(t).find(([s, i]) => i == e);
  if (!r)
    throw new Error(n || `{ ${e} } 不在范围内！`);
  return r[0];
}
function Or(e, t, n, r) {
  let s = 0;
  for (let i = 0, o = n.length; i < o; i++) {
    if (!(e[i] in r))
      throw new Error(
        `计算校验码失败: 参与校验的字符 { ${e[i]} } 不在代码字符集范围内！`
      );
    const a = r[e[i]];
    s += a * n[i];
  }
  return s = (t - s % t) % t, Fo(
    s,
    r,
    `计算校验码失败: 校验码 { ${s} } 不在代码字符集范围内！`
  );
}
const ko = 11, Po = [3, 7, 9, 10, 5, 8, 4, 2], Do = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  G: 16,
  H: 17,
  I: 18,
  J: 19,
  K: 20,
  L: 21,
  M: 22,
  N: 23,
  O: 24,
  P: 25,
  Q: 26,
  R: 27,
  S: 28,
  T: 29,
  U: 30,
  V: 31,
  W: 32,
  X: 33,
  Y: 34,
  Z: 35
};
function Mo(e) {
  if (_r(
    e,
    9,
    "不符合《GB 11714-1997》：组织机构代码只能 9 位 且 大写！"
  ), Or(e, ko, Po, Do) !== e[8])
    throw new Error("不符合《GB 11714-1997》：校验码检验失败");
  return !0;
}
const Lo = 31, Io = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28], $o = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  G: 16,
  H: 17,
  J: 18,
  K: 19,
  L: 20,
  M: 21,
  N: 22,
  P: 23,
  Q: 24,
  R: 25,
  T: 26,
  U: 27,
  W: 28,
  X: 29,
  Y: 30
};
function Wl(e) {
  _r(
    e,
    18,
    "不符合《GB 32100-2015》：税号只能 18 位 且 大写！"
  );
  const t = e[0];
  D(
    t,
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "N", "Y"],
    "不符合《GB 32100-2015》： { 第1位 : 登记管理部门代码 } "
  );
  const n = e[1], r = "不符合《GB 32100-2015》： { 第2位 : 机构类别代码 } ";
  switch (t) {
    case "1":
      D(n, ["1", "2", "3", "9"], r);
      break;
    case "2":
      D(n, ["1", "9"], r);
      break;
    case "3":
      D(
        n,
        ["1", "2", "3", "4", "5", "9"],
        r
      );
      break;
    case "4":
      D(n, ["1", "9"], r);
      break;
    case "5":
      D(n, ["1", "2", "3", "9"], r);
      break;
    case "6":
      D(n, ["1", "2", "9"], r);
      break;
    case "7":
      D(n, ["1", "2", "9"], r);
      break;
    case "8":
      D(n, ["1", "9"], r);
      break;
    case "9":
      D(n, ["1", "2", "3"], r);
      break;
    case "A":
      D(n, ["1", "9"], r);
      break;
    case "N":
      D(n, ["1", "2", "3", "9"], r);
      break;
    case "Y":
      D(n, ["1"], r);
      break;
  }
  const s = e.substring(2, 8);
  Co(
    s,
    Eo,
    "不符合《GB 32100-2015》： { 第3位 ~ 第8位 : 登记管理机关行政区划码 } "
  );
  const i = e.substring(8, 17);
  try {
    Mo(i);
  } catch {
    throw new Error(
      "不符合《GB 32100-2015》： { 第9位 ~ 第17位 : 主体标识码 (组织机构代码) }"
    );
  }
  if (Or(e, Lo, Io, $o) !== e[17])
    throw new Error("不符合《GB 32100-2015》：校验码检验失败");
  return !0;
}
const xn = Symbol("NO_VALUE");
async function* Hl(e) {
  for (const t of e)
    yield t;
}
async function Vl(e) {
  const t = [];
  for await (const n of e)
    t.push(n);
  return t;
}
async function Gl(e) {
  let t = xn;
  for await (const n of e)
    t = n;
  if (t === xn)
    throw new Error("No items in generator");
  return t;
}
async function Xl(e) {
  let t;
  do
    t = await e.next();
  while (!t.done);
  return t.value;
}
async function* Zl(e, t = 1 / 0) {
  const n = (i) => {
    const o = i.next().then(({ done: a, value: c }) => ({
      done: a,
      value: c,
      generator: i,
      promise: o
    }));
    return o;
  }, r = [...e], s = /* @__PURE__ */ new Set();
  for (; s.size < t && r.length > 0; ) {
    const i = r.shift();
    s.add(n(i));
  }
  for (; s.size > 0; ) {
    const { done: i, value: o, generator: a, promise: c } = await Promise.race(s);
    if (s.delete(c), !i)
      s.add(n(a)), o !== void 0 && (yield o);
    else if (r.length > 0) {
      const u = r.shift();
      s.add(n(u));
    }
  }
}
function No() {
  const e = {};
  return e.promise = new Promise((t, n) => {
    e.resolve = t, e.reject = n;
  }), e;
}
async function Jl(e, t) {
  const n = fi(e) ? e : e(), r = async (s) => {
    s.value && s.value.then ? s.value.then(async (i) => {
      await t?.(i), s.done || await r(await n.next(i));
    }).catch(async (i) => {
      if (s.done || !n.throw)
        throw new Error(i);
      await r(await n.throw(i));
    }) : typeof s.value == "function" ? s.value(async (i, o) => {
      if (i) {
        if (s.done || !n.throw)
          throw new Error(i);
        return await r(await n.throw(i));
      }
      await t?.(o), s.done || await r(await n.next(o));
    }) : (await t?.(s.value), s.done || await r(await n.next(s.value)));
  };
  await r(await n.next());
}
function Yl(e) {
  return (...t) => (
    // Thunk函数签名
    (n) => {
      let r;
      try {
        e.apply(this, [
          ...t,
          (s, i) => {
            r || (r = !0, n(s, i));
          }
        ]);
      } catch (s) {
        n(s);
      }
    }
  );
}
function Kl(e) {
  return new Promise((t, n) => {
    e.call(this, (r, s) => r ? n(r) : t(s));
  });
}
function Ql(e) {
  let t = !1;
  return {
    promise: new Promise((n, r) => {
      e.then(
        (s) => t ? r({ isCanceled: !0, value: s }) : n(s),
        (s) => r({ isCanceled: t, error: s })
      );
    }),
    cancel: () => t = !0
  };
}
function th(e, t) {
  let n;
  return Promise.race([
    e,
    new Promise((r, s) => {
      n = setTimeout(() => s(new Error("Timeout")), t);
    })
  ]).then((r) => (clearTimeout(n), r)).catch((r) => (clearTimeout(n), r));
}
function eh(e) {
  let t = null, n = Promise.resolve();
  for (const r of e)
    n = n.then((s) => (t = s, r));
  return n.catch((r) => {
    throw r;
  }).then(() => t);
}
async function nh(e) {
  return new Promise((t) => {
    setTimeout(t, Math.min(ws, e));
  });
}
function rh(e) {
}
async function sh(e, t) {
  return Promise.race([
    e(),
    new Promise(
      (n, r) => setTimeout(() => r(new Error("Timeout exceeded!")), t)
    )
  ]);
}
async function ih(e = []) {
  return await e.reduce(async (t, n) => (await t, await n()), Promise.resolve(void 0));
}
let Uo = 0;
function Tr(e) {
  const t = No();
  let n = !1;
  return {
    name: e.name || String(++Uo),
    deadline: typeof e.deadline == "number" ? Math.max(e.deadline, 0) : -1,
    run: async () => {
      if (!n) {
        n = !0;
        try {
          let r;
          const s = e.args || [];
          e.thisArg ? r = await e.fn.call(e.thisArg, ...s) : r = await e.fn(...s), t.resolve(r);
        } catch (r) {
          t.reject(r);
        }
      }
    },
    result: () => t.promise
  };
}
class zo {
  // 任务队列
  queue;
  // 是否暂停执行任务队列
  suspend = !1;
  // 执行信号
  // Incrementing adds a lock
  // Decrementing releases a lock
  semaphore = 0;
  // 并发执行数量 或 并发等待结果数量
  concurrency = 1;
  // 剩余可执行时间，毫秒
  // -1 不考虑剩余可执行时间
  // =0 自动暂停执行任务队列
  timeRemaining = -1;
  // 超时任务检查id
  timeoutId;
  // queue = createNoneRingQueue() : 不缓存数据
  // queue = createFixedRingQueue(10) : 超出缓存空间时，抛错
  // queue = createDroppingRingQueue(10) : 超出缓存空间时，忽略新数据
  // queue = createSlidingRingQueue(10) : 超出缓存空间时，删除旧数据
  // queue = createExpandingRingQueue(10) : 超出缓存空间时，扩大缓存空间
  constructor(t) {
    this.queue = t?.queue || ys(10), typeof t?.concurrency == "number" && (this.concurrency = Math.max(t?.concurrency, 1)), typeof t?.timeRemaining == "number" && this.setTimeRemaining(t.timeRemaining);
  }
  setTimeRemaining(t) {
    this.timeRemaining = Math.max(0, t);
  }
  increaseTimeRemaining(t, n = !1) {
    this.timeRemaining !== -1 ? this.setTimeRemaining(this.timeRemaining + t) : n && this.setTimeRemaining(t);
  }
  decreaseTimeRemaining(t) {
    this.timeRemaining !== -1 && this.setTimeRemaining(this.timeRemaining - t);
  }
  // 执行任务，不管执行结果
  _exec(t, n = !0) {
    const r = K();
    try {
      this.semaphore++, t.run();
    } finally {
      this.semaphore--, n && (this.decreaseTimeRemaining(K() - r), this._flush());
    }
  }
  // 执行队列
  _flush() {
    for (; !this.suspend && this.semaphore < this.concurrency && (this.timeRemaining == -1 || this.timeRemaining > 0); ) {
      const t = this.queue.dequeue();
      if (!t)
        break;
      this._exec(t);
    }
    this._timeout();
  }
  // 超时任务检查
  _timeout(t = 0, n = 0) {
    clearTimeout(this.timeoutId), this.timeoutId = setTimeout(() => {
      if (!(this.suspend || this.semaphore > 0 || !this.queue.length)) {
        for (let r = 0; r < this.queue.length(); ) {
          const s = this.queue.index(r);
          if (!s)
            break;
          s.deadline != -1 && s.deadline <= K() ? (this._exec(s, !1), this.queue.deleteIndex(r)) : r++;
        }
        this.queue.length() && (this.timeoutId = setTimeout(
          () => {
            this._timeout(t, ++n);
          },
          300 * Math.pow(2, n)
          // wait a bit longer between each retry
        ));
      }
    }, t);
  }
  // 暂停
  pause() {
    this.suspend = !0;
  }
  // 恢复
  resume() {
    this.suspend = !1, this._flush();
  }
  addTask(t) {
    this.queue.delete((n) => n.name == t.name), this.queue.enqueue(t);
  }
  // 立即触发执行
  immediately(t) {
    this._exec(t), this._flush();
  }
  // 立即顺序触发执行队列
  asap(t) {
    this.addTask(t), this._flush();
  }
  // 有空余时间再执行队列
  idleCallback(t) {
    this.setTimeRemaining(t.timeRemaining()), this._flush();
  }
  clear() {
    this.queue.clear();
  }
}
class vr extends zo {
  // 上个任务的执行结果
  lastResult;
  constructor(t) {
    super(t);
  }
  // 执行任务
  _exec(t, n = !0) {
    const r = K();
    try {
      this.semaphore++, t.run();
    } finally {
      t.result().then((s) => {
        this.lastResult = s;
      }).finally(() => {
        this.semaphore--, n && (this.decreaseTimeRemaining(K() - r), this._flush());
      });
    }
  }
}
class oh {
  schedule;
  constructor(t) {
    this.schedule = new vr(t);
  }
  get lastResult() {
    return this.schedule.lastResult;
  }
  // promise 自己绑定this
  asap(t, ...n) {
    const r = Tr({
      fn: t,
      args: n
    });
    return this.schedule.asap(r), r;
  }
  immediately(t, ...n) {
    return this.clear(), this.asap(t, ...n);
  }
  // 丢弃所有未处理的 promise
  clear() {
    this.schedule.clear();
  }
}
class ah {
  schedule;
  closeLastDialog;
  constructor(t) {
    this.schedule = new vr(t);
  }
  // dialog 自己绑定this
  // 将 Dialog 放入队列，依次关闭后显示
  asap(t, n) {
    const r = Tr({
      fn: (s) => new Promise((i) => {
        this.closeLastDialog = t({
          ...s,
          onClose: () => {
            this.closeLastDialog = void 0, s?.onClose?.(), i();
          }
        });
      }),
      args: [n]
    });
    return this.schedule.asap(r), r;
  }
  // 强制显示 Dialog
  immediately(t, n) {
    return this.clear(), this.asap(t, n);
  }
  // 强制关闭上一个 Dialog
  closeLast() {
    this.closeLastDialog && this.closeLastDialog();
  }
  // 丢弃所有未处理的 Dialog
  clear() {
    this.schedule.clear(), this.closeLast();
  }
}
function ch(e) {
  if (typeof setImmediate < "u" && zt(setImmediate))
    setImmediate(e);
  else if (typeof MessageChannel < "u" && (zt(MessageChannel) || MessageChannel.toString() === "[object MessageChannelConstructor]")) {
    const { port1: t, port2: n } = new MessageChannel();
    n.onmessage = e, t.postMessage(null);
  } else
    typeof Promise < "u" && zt(Promise) ? Promise.resolve().then(e) : setTimeout(e, 0);
}
function uh(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch(
    (t) => setTimeout(() => {
      throw t;
    })
  );
}
class lh {
  // postMessage
  port;
  // onmessage
  port2;
  constructor() {
    const { port1: t, port2: n } = new MessageChannel();
    this.port = t, this.port2 = n, this.port.start(), this.port2.start();
  }
  close() {
    this.port.close(), this.port2.close();
  }
  postMessage(t) {
    const n = Vn();
    return this.port.postMessage({ id: n, message: t }), n;
  }
  onmessage(t) {
    this.port2.addEventListener("message", t);
  }
  offmessage(t) {
    this.port2.removeEventListener("message", t);
  }
  onmessageerror(t) {
    this.port2.addEventListener("messageerror", t);
  }
  offmessageerror(t) {
    this.port2.removeEventListener("messageerror", t);
  }
}
function hh(e = "", t) {
  const {
    OPERATION_DELIMITER: n = "/",
    KEY_DELIMITER: r = ",",
    KEY_VALUE_DELIMITER: s = ":"
  } = t || {};
  return e.split(n).filter((i) => i !== "").reduce((i, o) => {
    const [a, ...c] = o.split(r);
    if (c.length === 0) {
      const [u, l] = a.split(s);
      i.push({
        type: u,
        payload: l !== void 0 ? decodeURIComponent(l) : !0
      });
    } else {
      if (a.indexOf(s) !== -1)
        throw new Error(`"${a}" is invalid`);
      i.push(
        c.reduce(
          (u, l) => {
            const [h, p] = l.split(s);
            return u[h] = p !== void 0 ? decodeURIComponent(p) : !0, u;
          },
          {
            type: a
          }
        )
      );
    }
    return i;
  }, []);
}
function jo(e) {
  const t = typeof e.immutable == "boolean" ? e.immutable : !0, n = e.initState || {};
  let r = e.reducer;
  if (e.enhancer)
    return e.enhancer(jo)({ reducer: r, initState: n, immutable: t });
  const s = [], i = (u) => (s.push(u), () => {
    const l = s.indexOf(u);
    l > -1 && s.splice(l, 1);
  });
  let o = n;
  t || (o = _o(o, {
    callback: (u) => {
      s.forEach((l) => l(u));
    }
  }));
  const a = (u) => {
    if (t) {
      const l = o;
      o = r(o, u);
      const h = cr(l, o);
      for (const p of h)
        s.forEach((d) => d(p));
    } else
      r(o, u);
  }, c = (u) => {
    r = u, a({ type: "INIT" });
  };
  return a({ type: "INIT" }), {
    getState: () => o,
    dispatch: a,
    subscribe: i,
    replaceReducer: c
  };
}
function fh(e, t = !0) {
  const n = Object.keys(e);
  return (r, s) => {
    const i = t ? { ...r } : r;
    for (let o = 0, a = n.length; o < a; o++) {
      const c = n[o];
      i[c] = e[c](i[c] || {}, s);
    }
    return i;
  };
}
function dh(...e) {
  return (t) => (n) => {
    const r = t(n);
    let s = r.dispatch;
    const i = { getState: r.getState, dispatch: s }, o = e.map((a) => a(i));
    return s = Xs(...o)(s), r.dispatch = s, r;
  };
}
const ph = (e) => {
  let t = 0;
  return (n) => (r) => {
    gn.start(
      `--- State Change index: ${++t} action: ${String(
        r.type
      )} ---`
    ), E(`action: ${I(r)}`), E(`old-state: ${I(e.getState())}`), n(r), E(`new-state: ${I(e.getState())}`), gn.end();
  };
}, mh = (e) => (t) => (n) => {
  try {
    t(n);
  } catch (r) {
    throw E(`Reducer错误报告: ${r}`), r;
  }
}, gh = (e) => (t) => (n) => {
  const r = `dispatch(${String(n.type)}) execute time`;
  Kt.start(r), t(n), Kt.end(r);
};
class yh {
  _next;
  _error;
  _complete;
  constructor() {
  }
  subscribe(t) {
    return this._next = t.next, this._error = t.error, this._complete = t.complete, {
      unsubscribe: () => {
        this.complete();
      }
    };
  }
  next(t) {
    this._next?.(t);
  }
  error(t) {
    this._error?.(t);
  }
  complete() {
    this._complete?.();
  }
}
function Rr(e = window.location.href) {
  try {
    return new URL(e);
  } catch {
    const n = "(?<protocol>https?:)", r = "(?<host>(?<hostname>[^/#?:]+)(?::(?<port>\\d+))?)", s = "(?<pathname>(?:\\/[^/#?]+)*\\/?)", i = "(?<search>(?:\\?[^#]*)?)", o = "(?<hash>(?:#.*)?)", c = new RegExp(`^${n}//${r}${s}${i}${o}$`).exec(e);
    return {
      href: e,
      protocol: c?.groups?.protocol || "",
      host: c?.groups?.host || "",
      hostname: c?.groups?.hostname || "",
      port: c?.groups?.port || "",
      pathname: c?.groups?.pathname || "",
      search: c?.groups?.search || "",
      hash: c?.groups?.hash || ""
    };
  }
}
function wh(e) {
  const t = Rr(e);
  return t.protocol === "http:" || t.protocol === "https:";
}
function Bo(e) {
  return !e.includes("://") || e.includes(window.location.origin);
}
function bh(e = window.location.href) {
  const t = Rr(e), n = t.href.indexOf(t.hash);
  return t.hash && n >= 0 ? t.href.substring(0, n) : t.href;
}
function qo(e, t) {
  return e.replace(/(?:\?.*)?$/, t.replace(/^[&?]/, "?"));
}
function Sh(e, t) {
  return qo(e, Er(t));
}
function Wo(e, t) {
  return e + t.replace(/^[&?]/, e.indexOf("?") >= 0 ? "&" : "?");
}
function Ah(e, t) {
  return Wo(e, Er(t));
}
function xh(e = window.location.href) {
  const t = {};
  let n = decodeURIComponent(e).split(/[?]/)[1];
  if (n || (n = e), n = n.replace(/^[#?&]/, ""), n = n.replace(/#\/(([^?&=]*))$/, ""), n) {
    const r = /(?:^|&)([^&=]*)=?([^&]*?)(?=&|$)/y;
    let s = r.exec(n);
    for (; s; )
      t[s[1]] = s[2], s = r.exec(n);
  }
  return t;
}
function _h(e = window.location.href) {
  return JSON.parse(
    '{"' + decodeURI(e.split("?")[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
  );
}
function Er(e) {
  return "?" + Object.entries(e).map(([t, n]) => `${encodeURIComponent(t)}=${encodeURIComponent(n)}`).join("&");
}
function Oh(e) {
  return "?" + [...e.entries()].map(
    (t) => encodeURIComponent(t[0]) + "=" + encodeURIComponent(t[1] instanceof File ? t[1].name : t[1])
  ).join("&");
}
async function Ho(e, t) {
  if (Bo(e))
    return e;
  const r = await (await fetch(e)).text(), s = new URL(e).href.split("/");
  s.pop();
  const i = `const _importScripts = importScripts;
const _fixImports = (url) => new URL(url, '${s.join("/") + "/"}').href;
importScripts = (...urls) => _importScripts(...urls.map(_fixImports));
`, o = "application/javascript";
  let a = `data:${o},` + encodeURIComponent(i + r);
  return (typeof t?.useBlob == "boolean" ? t?.useBlob : !0) && (a = URL.createObjectURL(
    new Blob([`importScripts("${a}")`], { type: o })
  )), a;
}
class Th {
  worker;
  constructor() {
    if (!wi)
      throw new Error("Your environment do not support Worker !");
  }
  async createFromURL(t, n = !1) {
    const r = await Ho(t);
    return n ? (this.worker = new SharedWorker(r, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker.port.start()) : this.worker = new Worker(r, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker;
  }
  async createFromCode(t, n = !1) {
    const r = new Blob([t]), s = URL.createObjectURL(r);
    return n ? (this.worker = new SharedWorker(s, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker.port.start()) : this.worker = new Worker(s, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker;
  }
  terminate() {
    this.worker instanceof Worker && this.worker.terminate(), this.worker instanceof SharedWorker && this.worker.port.close();
  }
  // type Transferable = OffscreenCanvas | ImageBitmap | MessagePort | ReadableStream | WritableStream | TransformStream | ArrayBuffer;
  postMessage(t, n = []) {
    const r = Vn();
    return this.worker instanceof Worker && this.worker.postMessage({ id: r, message: t }, n), this.worker instanceof SharedWorker && this.worker.port.postMessage({ id: r, message: t }, n), r;
  }
  postCanvas(t) {
    const n = t.transferControlToOffscreen();
    this.postMessage({ canvas: n }, [n]);
  }
  postPort(t) {
    this.postMessage({ port: t }, [t]);
  }
  onmessage(t) {
    this.worker instanceof Worker && this.worker.addEventListener("message", t), this.worker instanceof SharedWorker && this.worker.port.addEventListener("message", t);
  }
  offmessage(t) {
    this.worker instanceof Worker && this.worker.removeEventListener("message", t), this.worker instanceof SharedWorker && this.worker.port.removeEventListener("message", t);
  }
  onmessageerror(t) {
    this.worker instanceof Worker && this.worker.addEventListener("messageerror", t), this.worker instanceof SharedWorker && this.worker.port.addEventListener("messageerror", t);
  }
  offmessageerror(t) {
    this.worker instanceof Worker && this.worker.removeEventListener("messageerror", t), this.worker instanceof SharedWorker && this.worker.port.removeEventListener("messageerror", t);
  }
}
function Vo(e) {
  return e * Math.PI / 180;
}
function H(e) {
  return e * 180 / Math.PI;
}
function Z(e, t = 0) {
  if (!e)
    return t;
  switch (e.unit) {
    case "turn":
      return e.v * 360;
    case "rad":
      return H(e.v);
    case "deg":
    default:
      return e.v;
  }
}
function vh(e, t) {
  return {
    dx: Math.cos(e) * t,
    dy: Math.sin(e) * t
  };
}
function Go(e) {
  const t = [];
  return e.replace(
    /([a-z0-9]+)\s*\(?\s*((-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)*[a-z%]*\s*,?\s*)+)\)?/gi,
    (n, r, s) => {
      const i = [];
      return s.split(/\s*[,\s]+\s*/).forEach((o) => {
        o.trim() && i.push({
          v: Y(o, 0),
          unit: o.match(/[a-z%]+$/)?.[0] || ""
        });
      }), t.push({
        command: r,
        values: i
      }), "";
    }
  ), t;
}
class v {
  precision = 1e-6;
  x;
  y;
  z;
  w;
  // 齐次坐标 w = 1：表示 3D 点坐标  w = 0：作为一个向量或方向使用
  constructor(t = 0, n = 0, r = 0, s = 1) {
    this.x = t, this.y = n, this.z = r, this.w = s;
  }
  clone() {
    return new v(this.x, this.y, this.z, this.w);
  }
  add(t) {
    return new v(this.x + t.x, this.y + t.y, this.z + t.z, this.w);
  }
  sub(t) {
    return new v(this.x - t.x, this.y - t.y, this.z - t.z, this.w);
  }
  multiply(t) {
    return new v(this.x * t.x, this.y * t.y, this.z * t.z, this.w);
  }
  divide(t) {
    return new v(this.x / t.x, this.y / t.y, this.z / t.z, this.w);
  }
  min(t) {
    return new v(
      Math.min(this.x, t.x),
      Math.min(this.y, t.y),
      Math.min(this.z, t.z),
      this.w
    );
  }
  max(t) {
    return new v(
      Math.max(this.x, t.x),
      Math.max(this.y, t.y),
      Math.max(this.z, t.z),
      this.w
    );
  }
  clamp(t, n) {
    return new v(
      dt(this.x, t.x, n.x),
      dt(this.y, t.y, n.y),
      dt(this.z, t.z, n.z),
      this.w
    );
  }
  floor() {
    return new v(
      Math.floor(this.x),
      Math.floor(this.y),
      Math.floor(this.z),
      this.w
    );
  }
  ceil() {
    return new v(
      Math.ceil(this.x),
      Math.ceil(this.y),
      Math.ceil(this.z),
      this.w
    );
  }
  round() {
    return new v(
      Math.round(this.x),
      Math.round(this.y),
      Math.round(this.z),
      this.w
    );
  }
  roundToZero() {
    return new v(
      Math.trunc(this.x),
      Math.trunc(this.y),
      Math.trunc(this.z),
      this.w
    );
  }
  negate() {
    return new v(
      this.x - this.x,
      this.y - this.y,
      this.z - this.z,
      this.w
    );
  }
  // Returns the scalar product of the vector with the argument
  // Both vectors must have equal dimensionality
  dot(t) {
    const n = t.toArray(), r = this.toArray();
    let s = 0, i = 3;
    do
      s += r[i - 1] * n[i - 1];
    while (--i);
    return s;
  }
  // Returns the vector product of the vector with the argument
  // Both vectors must have dimensionality 3
  cross(t) {
    const n = t.toArray(), r = this.toArray();
    return new v(
      r[1] * n[2] - r[2] * n[1],
      r[2] * n[0] - r[0] * n[2],
      r[0] * n[1] - r[1] * n[0]
    );
  }
  length() {
    return Math.sqrt(this.dot(this));
  }
  distance(t) {
    return this.sub(t).length();
  }
  normalize() {
    const t = this.length();
    return t == 0 ? new v() : new v(this.x / t, this.y / t, this.z / t, this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  // Returns the angle between the vector and the argument (also a vector)
  degreeFrom(t) {
    const n = t.toArray();
    let r = 0, s = 0, i = 0;
    if (this.toArray().forEach((a, c) => {
      r += a * n[c], s += a * a, i += n[c] * n[c];
    }), s = Math.sqrt(s), i = Math.sqrt(i), s * i === 0)
      return;
    let o = r / (s * i);
    return o < -1 && (o = -1), o > 1 && (o = 1), H(Math.acos(o));
  }
  // Returns true iff the vector is parallel to the argument
  isParallelTo(t) {
    const n = this.degreeFrom(t);
    return n === void 0 ? void 0 : n <= this.precision;
  }
  // 2D: 与 x 轴正方向之间的弧度值
  radian() {
    let t = Math.atan2(this.y, this.x);
    return t < 0 && (t += Math.PI * 2), t;
  }
  // 2D: 与 x 轴正方向之间的角度值
  degree() {
    return H(this.radian());
  }
  // 2D: 返回滑动方向
  getDirection(t = 10) {
    if (Math.abs(this.x) < t && Math.abs(this.y) < t)
      return "no";
    const n = this.degree();
    return n >= -135 && n <= -45 ? "up" : n > 45 && n < 135 ? "down" : n >= 135 && n <= 180 || n >= -180 && n < -135 ? "left" : "right";
  }
  toArray() {
    return [this.x, this.y, this.z, this.w];
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class W {
  _elements;
  _margin;
  // protected isCoordinateChanged = false;
  // private _is2D: boolean;
  // 2D矩阵属性
  get a() {
    return this._elements[0];
  }
  set a(t) {
    this._elements[0] = t;
  }
  get b() {
    return this._elements[1];
  }
  set b(t) {
    this._elements[1] = t;
  }
  get c() {
    return this._elements[4];
  }
  set c(t) {
    this._elements[4] = t;
  }
  get d() {
    return this._elements[5];
  }
  set d(t) {
    this._elements[5] = t;
  }
  get e() {
    return this._elements[12];
  }
  set e(t) {
    this._elements[12] = t;
  }
  get f() {
    return this._elements[13];
  }
  set f(t) {
    this._elements[13] = t;
  }
  // 3D矩阵属性
  get m11() {
    return this._elements[0];
  }
  set m11(t) {
    this._elements[0] = t;
  }
  get m12() {
    return this._elements[1];
  }
  set m12(t) {
    this._elements[1] = t;
  }
  get m13() {
    return this._elements[2];
  }
  set m13(t) {
    this._elements[2] = t;
  }
  get m14() {
    return this._elements[3];
  }
  set m14(t) {
    this._elements[3] = t;
  }
  get m21() {
    return this._elements[4];
  }
  set m21(t) {
    this._elements[4] = t;
  }
  get m22() {
    return this._elements[5];
  }
  set m22(t) {
    this._elements[5] = t;
  }
  get m23() {
    return this._elements[6];
  }
  set m23(t) {
    this._elements[6] = t;
  }
  get m24() {
    return this._elements[7];
  }
  set m24(t) {
    this._elements[7] = t;
  }
  get m31() {
    return this._elements[8];
  }
  set m31(t) {
    this._elements[8] = t;
  }
  get m32() {
    return this._elements[9];
  }
  set m32(t) {
    this._elements[9] = t;
  }
  get m33() {
    return this._elements[10];
  }
  set m33(t) {
    this._elements[10] = t;
  }
  get m34() {
    return this._elements[11];
  }
  set m34(t) {
    this._elements[11] = t;
  }
  get m41() {
    return this._elements[12];
  }
  set m41(t) {
    this._elements[12] = t;
  }
  get m42() {
    return this._elements[13];
  }
  set m42(t) {
    this._elements[13] = t;
  }
  get m43() {
    return this._elements[14];
  }
  set m43(t) {
    this._elements[14] = t;
  }
  get m44() {
    return this._elements[15];
  }
  set m44(t) {
    this._elements[15] = t;
  }
  get elements() {
    return Array.from(this._elements);
  }
  constructor(t, n) {
    this._margin = xs(n), this._elements = new Float64Array(16), this.identity(), t && (typeof t == "string" ? this._parseTransformString(t) : Array.isArray(t) ? this._fromArray(t) : t instanceof W && this._elements.set(t._elements));
  }
  identity() {
    this._elements.fill(0), this.m11 = 1, this.m22 = 1, this.m33 = 1, this.m44 = 1;
  }
  get isIdentity() {
    return this._margin(this.m11, 1) && this._margin(this.m12, 0) && this._margin(this.m13, 0) && this._margin(this.m14, 0) && this._margin(this.m21, 0) && this._margin(this.m22, 1) && this._margin(this.m23, 0) && this._margin(this.m24, 0) && this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && this._margin(this.m41, 0) && this._margin(this.m42, 0) && this._margin(this.m43, 0) && this._margin(this.m44, 1);
  }
  get isCoordinateChanged() {
    return !(this._margin(this.m11, 1) && this._margin(this.m12, 0) && this._margin(this.m13, 0) && this._margin(this.m14, 0) && this._margin(this.m21, 0) && this._margin(this.m22, 1) && this._margin(this.m23, 0) && this._margin(this.m24, 0) && this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && // this._margin(this.m41, 0) &&
    // this._margin(this.m42, 0) &&
    // this._margin(this.m43, 0) &&
    this._margin(this.m44, 1));
  }
  get is2D() {
    return this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && this._margin(this.m43, 0) && this._margin(this.m44, 1);
  }
  _fromArray(t) {
    if (t.length === 6)
      this._elements.set([
        t[0],
        t[1],
        0,
        0,
        t[2],
        t[3],
        0,
        0,
        0,
        0,
        1,
        0,
        t[4],
        t[5],
        0,
        1
      ]);
    else if (t.length === 16)
      this._elements.set(t);
    else
      throw new TypeError(
        "Invalid matrix length (must be 6 for 2D or 16 for 3D)"
      );
  }
  // 矩阵不满足交换律，所以顺序很重要
  _parseTransformString(t) {
    return Go(t).forEach(({ command: n, values: r }) => {
      switch (n) {
        case "m":
        case "matrix":
        case "matrix3d":
          this._fromArray(r.map((s) => s.v));
          break;
        case "t":
        case "translate":
        case "translate3d":
          this.translateSelf(
            r[0]?.v || 0,
            r[1]?.v || 0,
            r[2]?.v || 0
          );
          break;
        case "translateX":
          this.translateSelf(r[0]?.v || 0, 0, 0);
          break;
        case "translateY":
          this.translateSelf(0, r[0]?.v || 0, 0);
          break;
        case "translateZ":
          this.translateSelf(0, 0, r[0]?.v || 0);
          break;
        case "r":
        case "rotate":
        case "rotateZ":
          this.rotateSelf(Z(r[0], 0), 0, 0, 1);
          break;
        case "rotateX":
          this.rotateSelf(Z(r[0], 0), 1, 0, 0);
          break;
        case "rotateY":
          this.rotateSelf(Z(r[0], 0), 0, 1, 0);
          break;
        case "rotate3d":
          this.rotateSelf(
            Z(r[3], 0),
            Z(r[0], 0),
            Z(r[1], 0),
            Z(r[2], 0)
          );
          break;
        case "s":
        case "scale":
        case "scale3d":
          this.scaleSelf(
            r[0]?.v || 1,
            r[1]?.v || r[0]?.v || 1,
            r[2]?.v || 1
          );
          break;
        case "scaleX":
          this.scaleSelf(r[0]?.v || 1, 1, 1);
          break;
        case "scaleY":
          this.scaleSelf(1, r[0]?.v || 1, 1);
          break;
        case "scaleZ":
          this.scaleSelf(1, 1, r[0]?.v || 1);
          break;
        case "skewX":
          this.skewXSelf(Z(r[0], 0));
          break;
        case "skewY":
          this.skewYSelf(Z(r[0], 0));
          break;
        case "none":
        default:
          Bs(`Unsupported transform function: ${n}`);
      }
    }), this;
  }
  // other * this  =>  this first, then other
  multiply(t) {
    return this.clone().multiplySelf(t);
  }
  // other * this  =>  this first, then other
  multiplySelf(t) {
    const n = this.elements, r = t.elements, s = new Float64Array(16);
    for (let i = 0; i < 4; i++)
      for (let o = 0; o < 4; o++)
        s[i * 4 + o] = n[i * 4 + 0] * r[0 * 4 + o] + n[i * 4 + 1] * r[1 * 4 + o] + n[i * 4 + 2] * r[2 * 4 + o] + n[i * 4 + 3] * r[3 * 4 + o];
    return this._elements.set(s), this;
  }
  translate(t, n = 0, r = 0) {
    return this.clone().translateSelf(t, n, r);
  }
  translateSelf(t, n = 0, r = 0) {
    const s = new W();
    if (this.isCoordinateChanged) {
      const i = this.transformPoint(new v(t, n, r));
      s.m41 = i.x, s.m42 = i.y, s.m43 = i.z;
    } else
      s.m41 = t, s.m42 = n, s.m43 = r;
    return this.multiplySelf(s);
  }
  rotate(t, n = 0, r = 0, s = 1) {
    return this.clone().rotateSelf(t, n, r, s);
  }
  // x, y, z 代表旋转轴的方向向量
  // 对于多个旋转，通常是先绕 Z 轴旋转，然后绕 Y 轴，再绕 X 轴
  rotateSelf(t, n = 0, r = 0, s = 1) {
    if (this.isCoordinateChanged) {
      const u = this.transformPoint(new v(n, r, s));
      n = u.x, r = u.y, s = u.z;
    }
    const i = t * Math.PI / 180, o = Math.cos(i), a = Math.sin(i), c = new W();
    if (n === 0 && r === 0 && s === 1)
      c.m11 = o, c.m12 = a, c.m21 = -a, c.m22 = o;
    else if (n === 1 && r === 0 && s === 0)
      c.m22 = o, c.m23 = a, c.m32 = -a, c.m33 = o;
    else if (n === 0 && r === 1 && s === 0)
      c.m11 = o, c.m13 = -a, c.m31 = a, c.m33 = o;
    else {
      const u = Math.sqrt(n * n + r * r + s * s) || 1;
      if (u == 0)
        return this;
      const l = n / u, h = r / u, p = s / u, d = 1 - o;
      c.m11 = o + l * l * d, c.m12 = l * h * d + p * a, c.m13 = l * p * d - h * a, c.m21 = h * l * d - p * a, c.m22 = o + h * h * d, c.m23 = h * p * d + l * a, c.m31 = p * l * d + h * a, c.m32 = p * h * d - l * a, c.m33 = o + p * p * d;
    }
    return this.multiplySelf(c);
  }
  scale(t, n = t, r = 1) {
    return this.clone().scaleSelf(t, n, r);
  }
  scaleSelf(t, n = t, r = 1) {
    const s = new W();
    return s.m11 = t, s.m22 = n, s.m33 = r, this.multiplySelf(s);
  }
  skewX(t) {
    return this.clone().skewXSelf(t);
  }
  skewXSelf(t) {
    const n = t * Math.PI / 180, r = new W();
    return r.m21 = Math.tan(n), this.multiplySelf(r);
  }
  skewY(t) {
    return this.clone().skewYSelf(t);
  }
  skewYSelf(t) {
    const n = t * Math.PI / 180, r = new W();
    return r.m12 = Math.tan(n), this.multiplySelf(r);
  }
  // skewZ(degree: number): DomMatrix {
  //   return this.clone().skewZSelf(degree);
  // }
  // skewZSelf(degree: number): this {
  //   const rad = (degree * Math.PI) / 180;
  //   const skew = new DomMatrix();
  //   skew.m13 = Math.tan(rad); // c参数
  //   // if (skew.m13 !== 0) {
  //   //   this.isCoordinateChanged = true;
  //   // }
  //   return this.multiplySelf(skew);
  // }
  to2D() {
    return new W([
      this.a,
      this.b,
      this.c,
      this.d,
      this.e,
      this.f
    ]);
  }
  // 正射投影
  // | 2/(r-l)   0         0      -(r+l)/(r-l) |
  // | 0         2/(t-b)   0      -(t+b)/(t-b) |
  // | 0         0         -2/(f-n)  -(f+n)/(f-n) |
  // | 0         0         0       1            |
  // 透视投影
  // | 2n/(r-l)  0        (r+l)/(r-l)   0       |
  // | 0        2n/(t-b)  (t+b)/(t-b)   0       |
  // | 0        0        -(f+n)/(f-n)   -2fn/(f-n) |
  // | 0        0        -1             0       |
  inverse() {
    return this.clone().invertSelf();
  }
  /**
   * Inverts the matrix
   * -> based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
   * -> based on https://github.com/mrdoob/three.js/blob/master/src/math/Matrix4.js
   */
  invertSelf() {
    if (this.is2D) {
      const t = this.a * this.d - this.b * this.c;
      if (t === 0)
        throw new Error("Matrix is not invertible.");
      const n = 1 / t;
      return this.multiplySelf(
        new W([
          this.d * n,
          -this.b * n,
          -this.c * n,
          this.a * n,
          (this.c * this.f - this.d * this.e) * n,
          (this.b * this.e - this.a * this.f) * n
        ])
      );
    } else {
      const t = Array.from(this.elements), n = t[0], r = t[1], s = t[2], i = t[3], o = t[4], a = t[5], c = t[6], u = t[7], l = t[8], h = t[9], p = t[10], d = t[11], g = t[12], m = t[13], y = t[14], w = t[15], S = h * y * u - m * p * u + m * c * d - a * y * d - h * c * w + a * p * w, x = g * p * u - l * y * u - g * c * d + o * y * d + l * c * w - o * p * w, O = l * m * u - g * h * u + g * a * d - o * m * d - l * a * w + o * h * w, A = g * h * c - l * m * c - g * a * p + o * m * p + l * a * y - o * h * y, C = n * S + r * x + s * O + i * A;
      if (C === 0)
        throw new Error("Matrix is not invertible.");
      const _ = 1 / C;
      return t[0] = S * _, t[1] = (m * p * i - h * y * i - m * s * d + r * y * d + h * s * w - r * p * w) * _, t[2] = (a * y * i - m * c * i + m * s * u - r * y * u - a * s * w + r * c * w) * _, t[3] = (h * c * i - a * p * i - h * s * u + r * p * u + a * s * d - r * c * d) * _, t[4] = x * _, t[5] = (l * y * i - g * p * i + g * s * d - n * y * d - l * s * w + n * p * w) * _, t[6] = (g * c * i - o * y * i - g * s * u + n * y * u + o * s * w - n * c * w) * _, t[7] = (o * p * i - l * c * i + l * s * u - n * p * u - o * s * d + n * c * d) * _, t[8] = O * _, t[9] = (g * h * i - l * m * i - g * r * d + n * m * d + l * r * w - n * h * w) * _, t[10] = (o * m * i - g * a * i + g * r * u - n * m * u - o * r * w + n * a * w) * _, t[11] = (l * a * i - o * h * i - l * r * u + n * h * u + o * r * d - n * a * d) * _, t[12] = A * _, t[13] = (l * m * s - g * h * s + g * r * p - n * m * p - l * r * y + n * h * y) * _, t[14] = (g * a * s - o * m * s - g * r * c + n * m * c + o * r * y - n * a * y) * _, t[15] = (o * h * s - l * a * s + l * r * c - n * h * c - o * r * p + n * a * p) * _, this._elements.set(t), this;
    }
  }
  transformPoint(t) {
    const { x: n = 0, y: r = 0, z: s = 0, w: i = 1 } = t, o = new v(
      this.m11 * n + this.m21 * r + this.m31 * s + this.m41 * i,
      this.m12 * n + this.m22 * r + this.m32 * s + this.m42 * i,
      this.m13 * n + this.m23 * r + this.m33 * s + this.m43 * i,
      this.m14 * n + this.m24 * r + this.m34 * s + this.m44 * i
    );
    return o.w !== 1 && (o.x /= o.w, o.y /= o.w, o.z /= o.w), o;
  }
  toString(t = 6) {
    return this.is2D ? `matrix(${[
      et(this.a, t),
      et(this.b, t),
      et(this.c, t),
      et(this.d, t),
      et(this.e, t),
      et(this.f, t)
    ].join(", ")})` : `matrix3d(${Array.from(this.elements).map((n) => et(n, t)).join(", ")})`;
  }
  toArray() {
    return this.is2D ? [this.a, this.b, this.c, this.d, this.e, this.f] : [
      this.m11,
      this.m12,
      this.m13,
      this.m14,
      this.m21,
      this.m22,
      this.m23,
      this.m24,
      this.m31,
      this.m32,
      this.m33,
      this.m34,
      this.m41,
      this.m42,
      this.m43,
      this.m44
    ];
  }
  clone() {
    return new W(this);
  }
  split() {
    const t = Math.sqrt(
      this.m11 * this.m11 + this.m12 * this.m12 + this.m13 * this.m13
    ), n = Math.sqrt(
      this.m21 * this.m21 + this.m22 * this.m22 + this.m23 * this.m23
    ), r = Math.sqrt(
      this.m31 * this.m31 + this.m32 * this.m32 + this.m33 * this.m33
    ), s = H(dt(Math.asin(-this.m13), -1, 1));
    let i = H(Math.atan2(this.m23, this.m33));
    Math.cos(Vo(s)) === 0 && (i = H(Math.atan2(-this.m31, this.m22)));
    let o = H(Math.atan2(this.m12, this.m11));
    return this.m11 < 0 && this.m22 >= 0 && (o += 180), {
      x: this.m41,
      y: this.m42,
      z: this.m43,
      scalarX: t,
      scalarY: n,
      scalarZ: r,
      degreeX: i,
      degreeY: s,
      degreeZ: o,
      skewX: H(this.m14),
      skewY: H(this.m24),
      skewZ: H(this.m34),
      skewW: this.m44,
      perspective: this.m34 ? -(1 / this.m34) : 0
    };
  }
  // 行列式
  determinant() {
    if (this.is2D)
      return this.a * this.d - this.b * this.c;
    const t = this.elements, n = t[0], r = t[4], s = t[8], i = t[12], o = t[1], a = t[5], c = t[9], u = t[13], l = t[2], h = t[6], p = t[10], d = t[14], g = t[3], m = t[7], y = t[11], w = t[15];
    return g * (+i * c * h - s * u * h - i * a * p + r * u * p + s * a * d - r * c * d) + m * (+n * c * d - n * u * p + i * o * p - s * o * d + s * u * l - i * c * l) + y * (+n * u * h - n * a * d - i * o * h + r * o * d + i * a * l - r * u * l) + w * (-s * a * l - n * c * h + n * a * p + s * o * h - r * o * p + r * c * l);
  }
}
function Cr(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Xo } = Object.prototype, { getPrototypeOf: sn } = Object, pe = ((e) => (t) => {
  const n = Xo.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), B = (e) => (e = e.toLowerCase(), (t) => pe(t) === e), me = (e) => (t) => typeof t === e, { isArray: wt } = Array, vt = me("undefined");
function Zo(e) {
  return e !== null && !vt(e) && e.constructor !== null && !vt(e.constructor) && L(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Fr = B("ArrayBuffer");
function Jo(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Fr(e.buffer), t;
}
const Yo = me("string"), L = me("function"), kr = me("number"), ge = (e) => e !== null && typeof e == "object", Ko = (e) => e === !0 || e === !1, Wt = (e) => {
  if (pe(e) !== "object")
    return !1;
  const t = sn(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Qo = B("Date"), t0 = B("File"), e0 = B("Blob"), n0 = B("FileList"), r0 = (e) => ge(e) && L(e.pipe), s0 = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || L(e.append) && ((t = pe(e)) === "formdata" || // detect form-data instance
  t === "object" && L(e.toString) && e.toString() === "[object FormData]"));
}, i0 = B("URLSearchParams"), [o0, a0, c0, u0] = ["ReadableStream", "Request", "Response", "Headers"].map(B), l0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Pt(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), wt(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (r = 0; r < o; r++)
      a = i[r], t.call(null, e[a], a, e);
  }
}
function Pr(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const ot = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Dr = (e) => !vt(e) && e !== ot;
function Pe() {
  const { caseless: e } = Dr(this) && this || {}, t = {}, n = (r, s) => {
    const i = e && Pr(t, s) || s;
    Wt(t[i]) && Wt(r) ? t[i] = Pe(t[i], r) : Wt(r) ? t[i] = Pe({}, r) : wt(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && Pt(arguments[r], n);
  return t;
}
const h0 = (e, t, n, { allOwnKeys: r } = {}) => (Pt(t, (s, i) => {
  n && L(s) ? e[i] = Cr(s, n) : e[i] = s;
}, { allOwnKeys: r }), e), f0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), d0 = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, p0 = (e, t, n, r) => {
  let s, i, o;
  const a = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      o = s[i], (!r || r(o, e, t)) && !a[o] && (t[o] = e[o], a[o] = !0);
    e = n !== !1 && sn(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, m0 = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, g0 = (e) => {
  if (!e)
    return null;
  if (wt(e))
    return e;
  let t = e.length;
  if (!kr(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, y0 = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && sn(Uint8Array)), w0 = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, b0 = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, S0 = B("HTMLFormElement"), A0 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), _n = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), x0 = B("RegExp"), Mr = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Pt(n, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(e, r);
}, _0 = (e) => {
  Mr(e, (t, n) => {
    if (L(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (L(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, O0 = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return wt(e) ? r(e) : r(String(e).split(t)), n;
}, T0 = () => {
}, v0 = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function R0(e) {
  return !!(e && L(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const E0 = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (ge(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[s] = r;
        const i = wt(r) ? [] : {};
        return Pt(r, (o, a) => {
          const c = n(o, s + 1);
          !vt(c) && (i[a] = c);
        }), t[s] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, C0 = B("AsyncFunction"), F0 = (e) => e && (ge(e) || L(e)) && L(e.then) && L(e.catch), Lr = ((e, t) => e ? setImmediate : t ? ((n, r) => (ot.addEventListener("message", ({ source: s, data: i }) => {
  s === ot && i === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), ot.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  L(ot.postMessage)
), k0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(ot) : typeof process < "u" && process.nextTick || Lr, f = {
  isArray: wt,
  isArrayBuffer: Fr,
  isBuffer: Zo,
  isFormData: s0,
  isArrayBufferView: Jo,
  isString: Yo,
  isNumber: kr,
  isBoolean: Ko,
  isObject: ge,
  isPlainObject: Wt,
  isReadableStream: o0,
  isRequest: a0,
  isResponse: c0,
  isHeaders: u0,
  isUndefined: vt,
  isDate: Qo,
  isFile: t0,
  isBlob: e0,
  isRegExp: x0,
  isFunction: L,
  isStream: r0,
  isURLSearchParams: i0,
  isTypedArray: y0,
  isFileList: n0,
  forEach: Pt,
  merge: Pe,
  extend: h0,
  trim: l0,
  stripBOM: f0,
  inherits: d0,
  toFlatObject: p0,
  kindOf: pe,
  kindOfTest: B,
  endsWith: m0,
  toArray: g0,
  forEachEntry: w0,
  matchAll: b0,
  isHTMLForm: S0,
  hasOwnProperty: _n,
  hasOwnProp: _n,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Mr,
  freezeMethods: _0,
  toObjectSet: O0,
  toCamelCase: A0,
  noop: T0,
  toFiniteNumber: v0,
  findKey: Pr,
  global: ot,
  isContextDefined: Dr,
  isSpecCompliantForm: R0,
  toJSONObject: E0,
  isAsyncFn: C0,
  isThenable: F0,
  setImmediate: Lr,
  asap: k0
};
function b(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
f.inherits(b, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: f.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ir = b.prototype, $r = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  $r[e] = { value: e };
});
Object.defineProperties(b, $r);
Object.defineProperty(Ir, "isAxiosError", { value: !0 });
b.from = (e, t, n, r, s, i) => {
  const o = Object.create(Ir);
  return f.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (a) => a !== "isAxiosError"), b.call(o, e.message, t, n, r, s), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const P0 = null;
function De(e) {
  return f.isPlainObject(e) || f.isArray(e);
}
function Nr(e) {
  return f.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function On(e, t, n) {
  return e ? e.concat(t).map(function(s, i) {
    return s = Nr(s), !n && i ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function D0(e) {
  return f.isArray(e) && !e.some(De);
}
const M0 = f.toFlatObject(f, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ye(e, t, n) {
  if (!f.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = f.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, y) {
    return !f.isUndefined(y[m]);
  });
  const r = n.metaTokens, s = n.visitor || l, i = n.dots, o = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && f.isSpecCompliantForm(t);
  if (!f.isFunction(s))
    throw new TypeError("visitor must be a function");
  function u(g) {
    if (g === null)
      return "";
    if (f.isDate(g))
      return g.toISOString();
    if (!c && f.isBlob(g))
      throw new b("Blob is not supported. Use a Buffer instead.");
    return f.isArrayBuffer(g) || f.isTypedArray(g) ? c && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function l(g, m, y) {
    let w = g;
    if (g && !y && typeof g == "object") {
      if (f.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), g = JSON.stringify(g);
      else if (f.isArray(g) && D0(g) || (f.isFileList(g) || f.endsWith(m, "[]")) && (w = f.toArray(g)))
        return m = Nr(m), w.forEach(function(x, O) {
          !(f.isUndefined(x) || x === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? On([m], O, i) : o === null ? m : m + "[]",
            u(x)
          );
        }), !1;
    }
    return De(g) ? !0 : (t.append(On(y, m, i), u(g)), !1);
  }
  const h = [], p = Object.assign(M0, {
    defaultVisitor: l,
    convertValue: u,
    isVisitable: De
  });
  function d(g, m) {
    if (!f.isUndefined(g)) {
      if (h.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      h.push(g), f.forEach(g, function(w, S) {
        (!(f.isUndefined(w) || w === null) && s.call(
          t,
          w,
          f.isString(S) ? S.trim() : S,
          m,
          p
        )) === !0 && d(w, m ? m.concat(S) : [S]);
      }), h.pop();
    }
  }
  if (!f.isObject(e))
    throw new TypeError("data must be an object");
  return d(e), t;
}
function Tn(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function on(e, t) {
  this._pairs = [], e && ye(e, this, t);
}
const Ur = on.prototype;
Ur.append = function(t, n) {
  this._pairs.push([t, n]);
};
Ur.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Tn);
  } : Tn;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function L0(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function zr(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || L0;
  f.isFunction(n) && (n = {
    serialize: n
  });
  const s = n && n.serialize;
  let i;
  if (s ? i = s(t, n) : i = f.isURLSearchParams(t) ? t.toString() : new on(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class I0 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    f.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const vn = I0, jr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, $0 = typeof URLSearchParams < "u" ? URLSearchParams : on, N0 = typeof FormData < "u" ? FormData : null, U0 = typeof Blob < "u" ? Blob : null, z0 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: $0,
    FormData: N0,
    Blob: U0
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, an = typeof window < "u" && typeof document < "u", Me = typeof navigator == "object" && navigator || void 0, j0 = an && (!Me || ["ReactNative", "NativeScript", "NS"].indexOf(Me.product) < 0), B0 = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), q0 = an && window.location.href || "http://localhost", W0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: an,
  hasStandardBrowserEnv: j0,
  hasStandardBrowserWebWorkerEnv: B0,
  navigator: Me,
  origin: q0
}, Symbol.toStringTag, { value: "Module" })), k = {
  ...W0,
  ...z0
};
function H0(e, t) {
  return ye(e, new k.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, i) {
      return k.isNode && f.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function V0(e) {
  return f.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function G0(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let i;
  for (r = 0; r < s; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function Br(e) {
  function t(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__")
      return !0;
    const a = Number.isFinite(+o), c = i >= n.length;
    return o = !o && f.isArray(s) ? s.length : o, c ? (f.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : ((!s[o] || !f.isObject(s[o])) && (s[o] = []), t(n, r, s[o], i) && f.isArray(s[o]) && (s[o] = G0(s[o])), !a);
  }
  if (f.isFormData(e) && f.isFunction(e.entries)) {
    const n = {};
    return f.forEachEntry(e, (r, s) => {
      t(V0(r), s, n, 0);
    }), n;
  }
  return null;
}
function X0(e, t, n) {
  if (f.isString(e))
    try {
      return (t || JSON.parse)(e), f.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const cn = {
  transitional: jr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = f.isObject(t);
    if (i && f.isHTMLForm(t) && (t = new FormData(t)), f.isFormData(t))
      return s ? JSON.stringify(Br(t)) : t;
    if (f.isArrayBuffer(t) || f.isBuffer(t) || f.isStream(t) || f.isFile(t) || f.isBlob(t) || f.isReadableStream(t))
      return t;
    if (f.isArrayBufferView(t))
      return t.buffer;
    if (f.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return H0(t, this.formSerializer).toString();
      if ((a = f.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return ye(
          a ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || s ? (n.setContentType("application/json", !1), X0(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || cn.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (f.isResponse(t) || f.isReadableStream(t))
      return t;
    if (t && f.isString(t) && (r && !this.responseType || s)) {
      const o = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? b.from(a, b.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: k.classes.FormData,
    Blob: k.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
f.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  cn.headers[e] = {};
});
const un = cn, Z0 = f.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), J0 = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || t[n] && Z0[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Rn = Symbol("internals");
function At(e) {
  return e && String(e).trim().toLowerCase();
}
function Ht(e) {
  return e === !1 || e == null ? e : f.isArray(e) ? e.map(Ht) : String(e);
}
function Y0(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const K0 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function _e(e, t, n, r, s) {
  if (f.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!f.isString(t)) {
    if (f.isString(r))
      return t.indexOf(r) !== -1;
    if (f.isRegExp(r))
      return r.test(t);
  }
}
function Q0(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function ta(e, t) {
  const n = f.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, i, o) {
        return this[r].call(this, t, s, i, o);
      },
      configurable: !0
    });
  });
}
class we {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function i(a, c, u) {
      const l = At(c);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const h = f.findKey(s, l);
      (!h || s[h] === void 0 || u === !0 || u === void 0 && s[h] !== !1) && (s[h || c] = Ht(a));
    }
    const o = (a, c) => f.forEach(a, (u, l) => i(u, l, c));
    if (f.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (f.isString(t) && (t = t.trim()) && !K0(t))
      o(J0(t), n);
    else if (f.isHeaders(t))
      for (const [a, c] of t.entries())
        i(c, a, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = At(t), t) {
      const r = f.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return Y0(s);
        if (f.isFunction(n))
          return n.call(this, s, r);
        if (f.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = At(t), t) {
      const r = f.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || _e(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = At(o), o) {
        const a = f.findKey(r, o);
        a && (!n || _e(r, r[a], a, n)) && (delete r[a], s = !0);
      }
    }
    return f.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || _e(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return f.forEach(this, (s, i) => {
      const o = f.findKey(r, i);
      if (o) {
        n[o] = Ht(s), delete n[i];
        return;
      }
      const a = t ? Q0(i) : String(i).trim();
      a !== i && delete n[i], n[a] = Ht(s), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return f.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && f.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[Rn] = this[Rn] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const a = At(o);
      r[a] || (ta(s, o), r[a] = !0);
    }
    return f.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
we.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
f.reduceDescriptors(we.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
f.freezeMethods(we);
const z = we;
function Oe(e, t) {
  const n = this || un, r = t || n, s = z.from(r.headers);
  let i = r.data;
  return f.forEach(e, function(a) {
    i = a.call(n, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function qr(e) {
  return !!(e && e.__CANCEL__);
}
function bt(e, t, n) {
  b.call(this, e ?? "canceled", b.ERR_CANCELED, t, n), this.name = "CanceledError";
}
f.inherits(bt, b, {
  __CANCEL__: !0
});
function Wr(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new b(
    "Request failed with status code " + n.status,
    [b.ERR_BAD_REQUEST, b.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function ea(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function na(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const u = Date.now(), l = r[i];
    o || (o = u), n[s] = c, r[s] = u;
    let h = i, p = 0;
    for (; h !== s; )
      p += n[h++], h = h % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), u - o < t)
      return;
    const d = l && u - l;
    return d ? Math.round(p * 1e3 / d) : void 0;
  };
}
function ra(e, t) {
  let n = 0, r = 1e3 / t, s, i;
  const o = (u, l = Date.now()) => {
    n = l, s = null, i && (clearTimeout(i), i = null), e.apply(null, u);
  };
  return [(...u) => {
    const l = Date.now(), h = l - n;
    h >= r ? o(u, l) : (s = u, i || (i = setTimeout(() => {
      i = null, o(s);
    }, r - h)));
  }, () => s && o(s)];
}
const oe = (e, t, n = 3) => {
  let r = 0;
  const s = na(50, 250);
  return ra((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, c = o - r, u = s(c), l = o <= a;
    r = o;
    const h = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && a && l ? (a - o) / u : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(h);
  }, n);
}, En = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Cn = (e) => (...t) => f.asap(() => e(...t)), sa = k.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, k.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(k.origin),
  k.navigator && /(msie|trident)/i.test(k.navigator.userAgent)
) : () => !0, ia = k.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      f.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), f.isString(r) && o.push("path=" + r), f.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function oa(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function aa(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Hr(e, t, n) {
  let r = !oa(t);
  return e && (r || n == !1) ? aa(e, t) : t;
}
const Fn = (e) => e instanceof z ? { ...e } : e;
function at(e, t) {
  t = t || {};
  const n = {};
  function r(u, l, h, p) {
    return f.isPlainObject(u) && f.isPlainObject(l) ? f.merge.call({ caseless: p }, u, l) : f.isPlainObject(l) ? f.merge({}, l) : f.isArray(l) ? l.slice() : l;
  }
  function s(u, l, h, p) {
    if (f.isUndefined(l)) {
      if (!f.isUndefined(u))
        return r(void 0, u, h, p);
    } else
      return r(u, l, h, p);
  }
  function i(u, l) {
    if (!f.isUndefined(l))
      return r(void 0, l);
  }
  function o(u, l) {
    if (f.isUndefined(l)) {
      if (!f.isUndefined(u))
        return r(void 0, u);
    } else
      return r(void 0, l);
  }
  function a(u, l, h) {
    if (h in t)
      return r(u, l);
    if (h in e)
      return r(void 0, u);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (u, l, h) => s(Fn(u), Fn(l), h, !0)
  };
  return f.forEach(Object.keys(Object.assign({}, e, t)), function(l) {
    const h = c[l] || s, p = h(e[l], t[l], l);
    f.isUndefined(p) && h !== a || (n[l] = p);
  }), n;
}
const Vr = (e) => {
  const t = at({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = t;
  t.headers = o = z.from(o), t.url = zr(Hr(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let c;
  if (f.isFormData(n)) {
    if (k.hasStandardBrowserEnv || k.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((c = o.getContentType()) !== !1) {
      const [u, ...l] = c ? c.split(";").map((h) => h.trim()).filter(Boolean) : [];
      o.setContentType([u || "multipart/form-data", ...l].join("; "));
    }
  }
  if (k.hasStandardBrowserEnv && (r && f.isFunction(r) && (r = r(t)), r || r !== !1 && sa(t.url))) {
    const u = s && i && ia.read(i);
    u && o.set(s, u);
  }
  return t;
}, ca = typeof XMLHttpRequest < "u", ua = ca && function(e) {
  return new Promise(function(n, r) {
    const s = Vr(e);
    let i = s.data;
    const o = z.from(s.headers).normalize();
    let { responseType: a, onUploadProgress: c, onDownloadProgress: u } = s, l, h, p, d, g;
    function m() {
      d && d(), g && g(), s.cancelToken && s.cancelToken.unsubscribe(l), s.signal && s.signal.removeEventListener("abort", l);
    }
    let y = new XMLHttpRequest();
    y.open(s.method.toUpperCase(), s.url, !0), y.timeout = s.timeout;
    function w() {
      if (!y)
        return;
      const x = z.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), A = {
        data: !a || a === "text" || a === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: x,
        config: e,
        request: y
      };
      Wr(function(_) {
        n(_), m();
      }, function(_) {
        r(_), m();
      }, A), y = null;
    }
    "onloadend" in y ? y.onloadend = w : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, y.onabort = function() {
      y && (r(new b("Request aborted", b.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function() {
      r(new b("Network Error", b.ERR_NETWORK, e, y)), y = null;
    }, y.ontimeout = function() {
      let O = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const A = s.transitional || jr;
      s.timeoutErrorMessage && (O = s.timeoutErrorMessage), r(new b(
        O,
        A.clarifyTimeoutError ? b.ETIMEDOUT : b.ECONNABORTED,
        e,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && f.forEach(o.toJSON(), function(O, A) {
      y.setRequestHeader(A, O);
    }), f.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials), a && a !== "json" && (y.responseType = s.responseType), u && ([p, g] = oe(u, !0), y.addEventListener("progress", p)), c && y.upload && ([h, d] = oe(c), y.upload.addEventListener("progress", h), y.upload.addEventListener("loadend", d)), (s.cancelToken || s.signal) && (l = (x) => {
      y && (r(!x || x.type ? new bt(null, e, y) : x), y.abort(), y = null);
    }, s.cancelToken && s.cancelToken.subscribe(l), s.signal && (s.signal.aborted ? l() : s.signal.addEventListener("abort", l)));
    const S = ea(s.url);
    if (S && k.protocols.indexOf(S) === -1) {
      r(new b("Unsupported protocol " + S + ":", b.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(i || null);
  });
}, la = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), s;
    const i = function(u) {
      if (!s) {
        s = !0, a();
        const l = u instanceof Error ? u : this.reason;
        r.abort(l instanceof b ? l : new bt(l instanceof Error ? l.message : l));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new b(`timeout ${t} of ms exceeded`, b.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", i));
    const { signal: c } = r;
    return c.unsubscribe = () => f.asap(a), c;
  }
}, ha = la, fa = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + t, yield e.slice(r, s), r = s;
}, da = async function* (e, t) {
  for await (const n of pa(e))
    yield* fa(n, t);
}, pa = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, kn = (e, t, n, r) => {
  const s = da(e, t);
  let i = 0, o, a = (c) => {
    o || (o = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: l } = await s.next();
        if (u) {
          a(), c.close();
          return;
        }
        let h = l.byteLength;
        if (n) {
          let p = i += h;
          n(p);
        }
        c.enqueue(new Uint8Array(l));
      } catch (u) {
        throw a(u), u;
      }
    },
    cancel(c) {
      return a(c), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, be = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Gr = be && typeof ReadableStream == "function", ma = be && (typeof TextEncoder == "function" ? ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Xr = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, ga = Gr && Xr(() => {
  let e = !1;
  const t = new Request(k.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Pn = 64 * 1024, Le = Gr && Xr(() => f.isReadableStream(new Response("").body)), ae = {
  stream: Le && ((e) => e.body)
};
be && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !ae[t] && (ae[t] = f.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new b(`Response type '${t}' is not supported`, b.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const ya = async (e) => {
  if (e == null)
    return 0;
  if (f.isBlob(e))
    return e.size;
  if (f.isSpecCompliantForm(e))
    return (await new Request(k.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (f.isArrayBufferView(e) || f.isArrayBuffer(e))
    return e.byteLength;
  if (f.isURLSearchParams(e) && (e = e + ""), f.isString(e))
    return (await ma(e)).byteLength;
}, wa = async (e, t) => {
  const n = f.toFiniteNumber(e.getContentLength());
  return n ?? ya(t);
}, ba = be && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: s,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: c,
    responseType: u,
    headers: l,
    withCredentials: h = "same-origin",
    fetchOptions: p
  } = Vr(e);
  u = u ? (u + "").toLowerCase() : "text";
  let d = ha([s, i && i.toAbortSignal()], o), g;
  const m = d && d.unsubscribe && (() => {
    d.unsubscribe();
  });
  let y;
  try {
    if (c && ga && n !== "get" && n !== "head" && (y = await wa(l, r)) !== 0) {
      let A = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), C;
      if (f.isFormData(r) && (C = A.headers.get("content-type")) && l.setContentType(C), A.body) {
        const [_, G] = En(
          y,
          oe(Cn(c))
        );
        r = kn(A.body, Pn, _, G);
      }
    }
    f.isString(h) || (h = h ? "include" : "omit");
    const w = "credentials" in Request.prototype;
    g = new Request(t, {
      ...p,
      signal: d,
      method: n.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: w ? h : void 0
    });
    let S = await fetch(g);
    const x = Le && (u === "stream" || u === "response");
    if (Le && (a || x && m)) {
      const A = {};
      ["status", "statusText", "headers"].forEach((X) => {
        A[X] = S[X];
      });
      const C = f.toFiniteNumber(S.headers.get("content-length")), [_, G] = a && En(
        C,
        oe(Cn(a), !0)
      ) || [];
      S = new Response(
        kn(S.body, Pn, _, () => {
          G && G(), m && m();
        }),
        A
      );
    }
    u = u || "text";
    let O = await ae[f.findKey(ae, u) || "text"](S, e);
    return !x && m && m(), await new Promise((A, C) => {
      Wr(A, C, {
        data: O,
        headers: z.from(S.headers),
        status: S.status,
        statusText: S.statusText,
        config: e,
        request: g
      });
    });
  } catch (w) {
    throw m && m(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new b("Network Error", b.ERR_NETWORK, e, g),
      {
        cause: w.cause || w
      }
    ) : b.from(w, w && w.code, e, g);
  }
}), Ie = {
  http: P0,
  xhr: ua,
  fetch: ba
};
f.forEach(Ie, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Dn = (e) => `- ${e}`, Sa = (e) => f.isFunction(e) || e === null || e === !1, Zr = {
  getAdapter: (e) => {
    e = f.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const s = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let o;
      if (r = n, !Sa(n) && (r = Ie[(o = String(n)).toLowerCase()], r === void 0))
        throw new b(`Unknown adapter '${o}'`);
      if (r)
        break;
      s[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(s).map(
        ([a, c]) => `adapter ${a} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(Dn).join(`
`) : " " + Dn(i[0]) : "as no adapter specified";
      throw new b(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Ie
};
function Te(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new bt(null, e);
}
function Mn(e) {
  return Te(e), e.headers = z.from(e.headers), e.data = Oe.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Zr.getAdapter(e.adapter || un.adapter)(e).then(function(r) {
    return Te(e), r.data = Oe.call(
      e,
      e.transformResponse,
      r
    ), r.headers = z.from(r.headers), r;
  }, function(r) {
    return qr(r) || (Te(e), r && r.response && (r.response.data = Oe.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = z.from(r.response.headers))), Promise.reject(r);
  });
}
const Jr = "1.8.4", Se = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Se[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ln = {};
Se.transitional = function(t, n, r) {
  function s(i, o) {
    return "[Axios v" + Jr + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, a) => {
    if (t === !1)
      throw new b(
        s(o, " has been removed" + (n ? " in " + n : "")),
        b.ERR_DEPRECATED
      );
    return n && !Ln[o] && (Ln[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, a) : !0;
  };
};
Se.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function Aa(e, t, n) {
  if (typeof e != "object")
    throw new b("options must be an object", b.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = t[i];
    if (o) {
      const a = e[i], c = a === void 0 || o(a, i, e);
      if (c !== !0)
        throw new b("option " + i + " must be " + c, b.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new b("Unknown option " + i, b.ERR_BAD_OPTION);
  }
}
const Vt = {
  assertOptions: Aa,
  validators: Se
}, q = Vt.validators;
class ce {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new vn(),
      response: new vn()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = at(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && Vt.assertOptions(r, {
      silentJSONParsing: q.transitional(q.boolean),
      forcedJSONParsing: q.transitional(q.boolean),
      clarifyTimeoutError: q.transitional(q.boolean)
    }, !1), s != null && (f.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : Vt.assertOptions(s, {
      encode: q.function,
      serialize: q.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Vt.assertOptions(n, {
      baseUrl: q.spelling("baseURL"),
      withXsrfToken: q.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && f.merge(
      i.common,
      i[n.method]
    );
    i && f.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete i[g];
      }
    ), n.headers = z.concat(o, i);
    const a = [];
    let c = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (c = c && m.synchronous, a.unshift(m.fulfilled, m.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(m) {
      u.push(m.fulfilled, m.rejected);
    });
    let l, h = 0, p;
    if (!c) {
      const g = [Mn.bind(this), void 0];
      for (g.unshift.apply(g, a), g.push.apply(g, u), p = g.length, l = Promise.resolve(n); h < p; )
        l = l.then(g[h++], g[h++]);
      return l;
    }
    p = a.length;
    let d = n;
    for (h = 0; h < p; ) {
      const g = a[h++], m = a[h++];
      try {
        d = g(d);
      } catch (y) {
        m.call(this, y);
        break;
      }
    }
    try {
      l = Mn.call(this, d);
    } catch (g) {
      return Promise.reject(g);
    }
    for (h = 0, p = u.length; h < p; )
      l = l.then(u[h++], u[h++]);
    return l;
  }
  getUri(t) {
    t = at(this.defaults, t);
    const n = Hr(t.baseURL, t.url, t.allowAbsoluteUrls);
    return zr(n, t.params, t.paramsSerializer);
  }
}
f.forEach(["delete", "get", "head", "options"], function(t) {
  ce.prototype[t] = function(n, r) {
    return this.request(at(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
f.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, o, a) {
      return this.request(at(a || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  ce.prototype[t] = n(), ce.prototype[t + "Form"] = n(!0);
});
const Gt = ce;
class ln {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(i, o, a) {
      r.reason || (r.reason = new bt(i, o, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new ln(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
}
const xa = ln;
function _a(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Oa(e) {
  return f.isObject(e) && e.isAxiosError === !0;
}
const $e = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries($e).forEach(([e, t]) => {
  $e[t] = e;
});
const Ta = $e;
function Yr(e) {
  const t = new Gt(e), n = Cr(Gt.prototype.request, t);
  return f.extend(n, Gt.prototype, t, { allOwnKeys: !0 }), f.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return Yr(at(e, s));
  }, n;
}
const R = Yr(un);
R.Axios = Gt;
R.CanceledError = bt;
R.CancelToken = xa;
R.isCancel = qr;
R.VERSION = Jr;
R.toFormData = ye;
R.AxiosError = b;
R.Cancel = R.CanceledError;
R.all = function(t) {
  return Promise.all(t);
};
R.spread = _a;
R.isAxiosError = Oa;
R.mergeConfig = at;
R.AxiosHeaders = z;
R.formToJSON = (e) => Br(f.isHTMLForm(e) ? new FormData(e) : e);
R.getAdapter = Zr.getAdapter;
R.HttpStatusCode = Ta;
R.default = R;
const va = R;
class Rh {
  instance;
  canceler;
  retryCount = 0;
  cacheTime = 0;
  caches = new Ve();
  constructor(t) {
    this.instance = va.create(t), this.canceler = new Ra(), this.retryCount = t?.retry || 0, this.cacheTime = t?.cache || 0, this.instance.interceptors.request.use(
      (n) => (t?.interceptor?.start?.(), this.canceler.pendingRequest(n), t?.interceptor?.request?.(n), n),
      (n) => (t?.interceptor?.end?.(), this.canceler.cancelRequest(n.config), t?.interceptor?.requestError?.(n), Promise.reject(n))
    ), this.instance.interceptors.response.use(
      (n) => (t?.interceptor?.end?.(), this.canceler.confirmRequest(n.config), t?.interceptor?.response?.(n), n.status == 200 ? Promise.resolve(n) : Promise.reject(n)),
      (n) => (t?.interceptor?.end?.(), this.canceler.cancelRequest(n.config), t?.interceptor?.responseError?.(n), Promise.reject(n.response))
    );
  }
  // @CacheDecorator(60)
  // @RetryDecorator(3)
  request(t) {
    let n = this.instance.request;
    const r = t.retry || this.retryCount;
    r && (n = Qn(n, r));
    const s = t.cache || this.cacheTime;
    return s && (n = tr(n, s, this.caches)), n(t);
  }
  // this.request() 请求后未返回前，可取消请求
  cancel(t) {
    this.canceler.cancelRequest(t);
  }
  get(t, n) {
    return this.request({ ...n, method: "get", url: t });
  }
  delete(t, n) {
    return this.request({ ...n, method: "delete", url: t });
  }
  head(t, n) {
    return this.request({ ...n, method: "head", url: t });
  }
  options(t, n) {
    return this.request({ ...n, method: "options", url: t });
  }
  post(t, n, r) {
    return this.request({ ...r, method: "post", url: t, data: n });
  }
  postBlob(t, n, r) {
    return r = {
      ...r,
      headers: {
        ...r?.headers,
        "Content-Type": "multipart/form-data"
      }
    }, this.request({ ...r, method: "post", url: t, data: n });
  }
  // UNDO : application/octet-stream
  postForm(t, n, r) {
    return this.instance.postForm(t, n, { ...r });
  }
  put(t, n, r) {
    return this.request({ ...r, method: "put", url: t, data: n });
  }
  patch(t, n, r) {
    return this.request({ ...r, method: "patch", url: t, data: n });
  }
  getUri(t) {
    return this.instance.getUri(t);
  }
}
class Ra {
  pendingRequestMap;
  constructor() {
    this.pendingRequestMap = /* @__PURE__ */ new Map();
  }
  getRequestId(t) {
    const { method: n, url: r, params: s, data: i } = t;
    return je({ method: n, url: r, params: s, data: i });
  }
  pendingRequest(t) {
    const n = this.getRequestId(t);
    if (this.pendingRequestMap.has(n))
      t.signal = this.pendingRequestMap.get(n)?.signal;
    else {
      const r = new AbortController();
      t.signal = r.signal, this.pendingRequestMap.set(n, r);
    }
  }
  confirmRequest(t) {
    if (this.pendingRequestMap.size === 0)
      return;
    const n = this.getRequestId(t);
    this.pendingRequestMap.has(n) && this.pendingRequestMap.delete(n);
  }
  cancelRequest(t) {
    if (this.pendingRequestMap.size === 0)
      return;
    const n = this.getRequestId(t);
    this.pendingRequestMap.has(n) && (this.pendingRequestMap.get(n)?.abort(), this.pendingRequestMap.delete(n));
  }
  cancelAllRequest() {
    const t = this.pendingRequestMap.values();
    for (const n of t)
      n.abort();
    this.pendingRequestMap.clear();
  }
}
function Eh(e, t = (n, r) => n <= r) {
  for (let n = 1, r = e.length; n < r; n++) {
    let s = !1;
    for (let i = 0; i < r - n; i++)
      t(e[i], e[i + 1]) || ([e[i], e[i + 1]] = [e[i + 1], e[i]], s = !0);
    if (!s)
      return;
  }
}
function Ch(e, t = (n, r) => n <= r) {
  let n;
  for (let r = 0, s = e.length; r < s - 1; r++) {
    n = r;
    for (let i = r + 1; i < s; i++)
      t(e[n], e[i]) || (n = i);
    n != r && ([e[n], e[r]] = [e[r], e[n]]);
  }
}
function Fh(e, t = (n, r) => n <= r) {
  for (let n = 1, r = e.length; n < r; n++) {
    const s = e[n];
    let i = n - 1;
    for (; i >= 0 && !t(e[i], s); )
      e[i + 1] = e[i], i--;
    e[i + 1] = s;
  }
}
function In(e, t = (n, r) => n <= r) {
  const n = e.length;
  if (n < 2)
    return e;
  const r = Math.floor(n / 2), s = In(e.slice(0, r), t), i = In(e.slice(r), t), o = [];
  for (; s.length && i.length; )
    t(s[0], i[0]) ? o.push(s.shift()) : o.push(i.shift());
  for (; s.length; )
    o.push(s.shift());
  for (; i.length; )
    o.push(i.shift());
  return o;
}
function $n(e, t = 0, n = e.length - 1, r = (s, i) => s <= i) {
  if (t >= n)
    return;
  const s = t + n >> 1;
  $n(e, t, s, r), $n(e, s + 1, n, r);
  let i = t, o = s + 1;
  const a = [];
  for (; i <= s && o <= n; )
    r(e[i], e[o]) ? a.push(e[i++]) : a.push(e[o++]);
  for (; i <= s; )
    a.push(e[i++]);
  for (; o <= n; )
    a.push(e[o++]);
  for (i = t, o = 0; i <= n; ++i, ++o)
    e[i] = a[o];
}
function Ea(e, t = 0, n = e.length - 1, r = (s, i) => s <= i) {
  if (t >= n)
    return t;
  const s = n, i = e[s];
  let o = t;
  for (let a = t; a <= n; a++)
    a != s && r(e[a], i) && ([e[o], e[a]] = [e[a], e[o]], o++);
  return [e[o], e[s]] = [
    e[s],
    e[o]
  ], o;
}
function Nn(e, t = 0, n = e.length - 1, r = (s, i) => s <= i) {
  if (t >= n)
    return;
  const s = Ea(e, t, n, r);
  Nn(e, t, s - 1, r), Nn(e, s + 1, n, r);
}
function Un(e, t = 0, n = e.length - 1, r = (s, i) => s <= i) {
  if (t >= n)
    return;
  const s = t, i = e[s];
  let o = t, a = n;
  for (; o < a; ) {
    for (; o < n && r(e[o], i); )
      o++;
    for (; a > t && r(i, e[a]); )
      a--;
    o < a && ([e[o], e[a]] = [e[a], e[o]]);
  }
  [e[s], e[a]] = [e[a], e[s]], Un(e, t, a - 1, r), Un(e, a + 1, n, r);
}
function zn(e, t = 0, n = e.length - 1, r = (s, i) => s <= i) {
  if (t >= n)
    return;
  const s = t, i = e[s];
  let o = t, a = n, c = t;
  for (; c <= a; )
    r(e[c], i) ? ([e[o], e[c]] = [e[c], e[o]], o++, c++) : r(i, e[c]) ? ([e[c], e[a]] = [e[a], e[c]], a--) : c++;
  [e[s], e[a]] = [e[a], e[s]], zn(e, t, a - 1, r), zn(e, a + 1, n, r);
}
function kh(e, t = (n, r) => n <= r) {
  const n = e.length;
  let r = Math.floor(n / 2);
  for (; r > 0; ) {
    for (let s = r; s < n; s++) {
      const i = e[s];
      let o = s;
      for (; o >= r && !t(e[o - r], i); )
        e[o] = e[o - r], o -= r;
      e[o] = i;
    }
    r = Math.floor(r / 2);
  }
}
function Ph(e, t = (n, r) => n <= r) {
  const n = new fe(t, e), r = [];
  let s;
  for (; (s = n.pop()) !== null; )
    r.push(s);
  return r;
}
function Dh(e, t) {
  let n = 0, r = e.length - 1;
  for (; n < r; ) {
    const s = Math.floor((n + r) / 2), i = e[s];
    if (i === t)
      return s;
    i < t ? n = s + 1 : r = s - 1;
  }
  return -1;
}
function Mh(e, t) {
  function n(s, i, o) {
    const a = s[o];
    let c = i - 1;
    for (let u = i; u < o; u++)
      s[u] >= a && (c++, [s[c], s[u]] = [s[u], s[c]]);
    return [s[c + 1], s[o]] = [s[o], s[c + 1]], c + 1;
  }
  function r(s, i, o) {
    if (s === i)
      return e[s];
    const a = n(e, s, i);
    return a === o ? e[a] : a < o ? r(a + 1, i, o) : r(s, a - 1, o);
  }
  return r(0, e.length - 1, t - 1);
}
class Lh {
  prefixSumArray;
  constructor(t) {
    const n = t.length + 1;
    this.prefixSumArray = Array.from({ length: n }).fill(0);
    for (let r = 1; r < n; r++)
      this.prefixSumArray[r] = this.prefixSumArray[r - 1] + t[r - 1];
  }
  // 查询闭区间 [i, j] 的累加和
  sum(t, n) {
    return this.prefixSumArray[n + 1] - this.prefixSumArray[t];
  }
}
class Ih {
  diffArray;
  constructor(t) {
    const n = t.length;
    this.diffArray = Array.from({ length: n }).fill(0), this.diffArray[0] = t[0];
    for (let r = 1; r < n; r++)
      this.diffArray[r] = t[r] - t[r - 1];
  }
  // 根据差分数组构造结果数组
  result() {
    const t = this.diffArray.length, n = Array.from({ length: t }).fill(0);
    n[0] = this.diffArray[0];
    for (let r = 1; r < t; r++)
      n[r] = n[r - 1] + this.diffArray[r];
    return n;
  }
  // 对闭区间 [i, j]进行增减的操作 ，num 可以为负数
  // 原理很简单，根据 diffArray 数组反推 nums 数组的过程，diff[i] += 3 意味着给 nums[i..] 所有的元素都加了 3，然后 diffArray[j+1] -= 3 又意味着对于 nums[j+1..] 所有元素再减 3，那综合起来，是不是就是对 nums[i..j] 中的所有元素都加 3 了
  // 只要花费 O(1) 的时间修改 diffArray 数组，就相当于给 原数组 的整个区间做了修改
  operate(t, n, r) {
    t >= 0 && t < this.diffArray.length && (this.diffArray[t] += r), n + 1 >= 0 && n + 1 < this.diffArray.length && (this.diffArray[n + 1] -= r);
  }
}
class $h {
  max;
  cache = /* @__PURE__ */ new Map();
  constructor(t) {
    this.max = t;
  }
  add(t, n) {
    const { cache: r } = this;
    if (r.size >= this.max) {
      const s = r.keys().next();
      s.value && r.delete(s.value);
    }
    r.set(t, n);
  }
  get(t) {
    const { cache: n } = this, r = n.get(t);
    if (r)
      return n.delete(t), n.set(t, r), r;
  }
}
class Nh {
  max;
  cache = new gs();
  constructor(t) {
    this.max = t;
  }
  add(t) {
    const { cache: n } = this;
    n.size() >= this.max && n.pop(), n.unshift(t);
  }
  get(t) {
    const { cache: n } = this, r = n.getIndex(t);
    return r == -1 ? this.add(t) : (n.delete(r), n.unshift(t)), t;
  }
}
const Ca = typeof performance == "object" && performance && typeof performance.now == "function" ? performance : Date, Kr = /* @__PURE__ */ new Set(), Ne = typeof process == "object" && process ? process : {}, Qr = (e, t, n, r) => {
  typeof Ne.emitWarning == "function" ? Ne.emitWarning(e, t, n, r) : console.error(`[${n}] ${t}: ${e}`);
};
let ue = T.AbortController, jn = T.AbortSignal;
if (typeof ue > "u") {
  jn = class {
    onabort;
    _onabort = [];
    reason;
    aborted = !1;
    addEventListener(r, s) {
      this._onabort.push(s);
    }
  }, ue = class {
    constructor() {
      t();
    }
    signal = new jn();
    abort(r) {
      if (!this.signal.aborted) {
        this.signal.reason = r, this.signal.aborted = !0;
        for (const s of this.signal._onabort)
          s(r);
        this.signal.onabort?.(r);
      }
    }
  };
  let e = Ne.env?.LRU_CACHE_IGNORE_AC_WARNING !== "1";
  const t = () => {
    e && (e = !1, Qr(
      "AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.",
      "NO_ABORT_CONTROLLER",
      "ENOTSUP",
      t
    ));
  };
}
const Fa = (e) => !Kr.has(e), nt = (e) => e && e === Math.floor(e) && e > 0 && isFinite(e), ts = (e) => nt(e) ? e <= Math.pow(2, 8) ? Uint8Array : e <= Math.pow(2, 16) ? Uint16Array : e <= Math.pow(2, 32) ? Uint32Array : e <= Number.MAX_SAFE_INTEGER ? Xt : null : null;
class Xt extends Array {
  constructor(t) {
    super(t), this.fill(0);
  }
}
class ft {
  heap;
  length;
  // private constructor
  static #a = !1;
  static create(t) {
    const n = ts(t);
    if (!n)
      return [];
    ft.#a = !0;
    const r = new ft(t, n);
    return ft.#a = !1, r;
  }
  constructor(t, n) {
    if (!ft.#a)
      throw new TypeError("instantiate Stack using Stack.create(n)");
    this.heap = new n(t), this.length = 0;
  }
  push(t) {
    this.heap[this.length++] = t;
  }
  pop() {
    return this.heap[--this.length];
  }
}
class es {
  // options that cannot be changed without disaster
  #a;
  #h;
  #g;
  #C;
  #y;
  #D;
  #M;
  #w;
  /**
   * {@link LRUCache.OptionsBase.perf}
   */
  get perf() {
    return this.#w;
  }
  /**
   * {@link LRUCache.OptionsBase.ttl}
   */
  ttl;
  /**
   * {@link LRUCache.OptionsBase.ttlResolution}
   */
  ttlResolution;
  /**
   * {@link LRUCache.OptionsBase.ttlAutopurge}
   */
  ttlAutopurge;
  /**
   * {@link LRUCache.OptionsBase.updateAgeOnGet}
   */
  updateAgeOnGet;
  /**
   * {@link LRUCache.OptionsBase.updateAgeOnHas}
   */
  updateAgeOnHas;
  /**
   * {@link LRUCache.OptionsBase.allowStale}
   */
  allowStale;
  /**
   * {@link LRUCache.OptionsBase.noDisposeOnSet}
   */
  noDisposeOnSet;
  /**
   * {@link LRUCache.OptionsBase.noUpdateTTL}
   */
  noUpdateTTL;
  /**
   * {@link LRUCache.OptionsBase.maxEntrySize}
   */
  maxEntrySize;
  /**
   * {@link LRUCache.OptionsBase.sizeCalculation}
   */
  sizeCalculation;
  /**
   * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
   */
  noDeleteOnFetchRejection;
  /**
   * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
   */
  noDeleteOnStaleGet;
  /**
   * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
   */
  allowStaleOnFetchAbort;
  /**
   * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
   */
  allowStaleOnFetchRejection;
  /**
   * {@link LRUCache.OptionsBase.ignoreFetchAbort}
   */
  ignoreFetchAbort;
  // computed properties
  #s;
  #b;
  #r;
  #n;
  #t;
  #u;
  #f;
  #c;
  #i;
  #S;
  #o;
  #A;
  #x;
  #d;
  #p;
  #_;
  #E;
  #l;
  #L;
  /**
   * Do not call this method unless you need to inspect the
   * inner workings of the cache.  If anything returned by this
   * object is modified in any way, strange breakage may occur.
   *
   * These fields are private for a reason!
   *
   * @internal
   */
  static unsafeExposeInternals(t) {
    return {
      // properties
      starts: t.#x,
      ttls: t.#d,
      autopurgeTimers: t.#p,
      sizes: t.#A,
      keyMap: t.#r,
      keyList: t.#n,
      valList: t.#t,
      next: t.#u,
      prev: t.#f,
      get head() {
        return t.#c;
      },
      get tail() {
        return t.#i;
      },
      free: t.#S,
      // methods
      isBackgroundFetch: (n) => t.#e(n),
      backgroundFetch: (n, r, s, i) => t.#N(n, r, s, i),
      moveToTail: (n) => t.#P(n),
      indexes: (n) => t.#O(n),
      rindexes: (n) => t.#T(n),
      isStale: (n) => t.#m(n)
    };
  }
  // Protected read-only members
  /**
   * {@link LRUCache.OptionsBase.max} (read-only)
   */
  get max() {
    return this.#a;
  }
  /**
   * {@link LRUCache.OptionsBase.maxSize} (read-only)
   */
  get maxSize() {
    return this.#h;
  }
  /**
   * The total computed size of items in the cache (read-only)
   */
  get calculatedSize() {
    return this.#b;
  }
  /**
   * The number of items stored in the cache (read-only)
   */
  get size() {
    return this.#s;
  }
  /**
   * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
   */
  get fetchMethod() {
    return this.#D;
  }
  get memoMethod() {
    return this.#M;
  }
  /**
   * {@link LRUCache.OptionsBase.dispose} (read-only)
   */
  get dispose() {
    return this.#g;
  }
  /**
   * {@link LRUCache.OptionsBase.onInsert} (read-only)
   */
  get onInsert() {
    return this.#C;
  }
  /**
   * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
   */
  get disposeAfter() {
    return this.#y;
  }
  constructor(t) {
    const {
      max: n = 0,
      ttl: r,
      ttlResolution: s = 1,
      ttlAutopurge: i,
      updateAgeOnGet: o,
      updateAgeOnHas: a,
      allowStale: c,
      dispose: u,
      onInsert: l,
      disposeAfter: h,
      noDisposeOnSet: p,
      noUpdateTTL: d,
      maxSize: g = 0,
      maxEntrySize: m = 0,
      sizeCalculation: y,
      fetchMethod: w,
      memoMethod: S,
      noDeleteOnFetchRejection: x,
      noDeleteOnStaleGet: O,
      allowStaleOnFetchRejection: A,
      allowStaleOnFetchAbort: C,
      ignoreFetchAbort: _,
      perf: G
    } = t;
    if (G !== void 0 && typeof G?.now != "function")
      throw new TypeError(
        "perf option must have a now() method if specified"
      );
    if (this.#w = G ?? Ca, n !== 0 && !nt(n))
      throw new TypeError("max option must be a nonnegative integer");
    const X = n ? ts(n) : Array;
    if (!X)
      throw new Error("invalid max value: " + n);
    if (this.#a = n, this.#h = g, this.maxEntrySize = m || this.#h, this.sizeCalculation = y, this.sizeCalculation) {
      if (!this.#h && !this.maxEntrySize)
        throw new TypeError(
          "cannot set sizeCalculation without setting maxSize or maxEntrySize"
        );
      if (typeof this.sizeCalculation != "function")
        throw new TypeError("sizeCalculation set to non-function");
    }
    if (S !== void 0 && typeof S != "function")
      throw new TypeError("memoMethod must be a function if defined");
    if (this.#M = S, w !== void 0 && typeof w != "function")
      throw new TypeError("fetchMethod must be a function if specified");
    if (this.#D = w, this.#E = !!w, this.#r = /* @__PURE__ */ new Map(), this.#n = new Array(n).fill(void 0), this.#t = new Array(n).fill(void 0), this.#u = new X(n), this.#f = new X(n), this.#c = 0, this.#i = 0, this.#S = ft.create(n), this.#s = 0, this.#b = 0, typeof u == "function" && (this.#g = u), typeof l == "function" && (this.#C = l), typeof h == "function" ? (this.#y = h, this.#o = []) : (this.#y = void 0, this.#o = void 0), this.#_ = !!this.#g, this.#L = !!this.#C, this.#l = !!this.#y, this.noDisposeOnSet = !!p, this.noUpdateTTL = !!d, this.noDeleteOnFetchRejection = !!x, this.allowStaleOnFetchRejection = !!A, this.allowStaleOnFetchAbort = !!C, this.ignoreFetchAbort = !!_, this.maxEntrySize !== 0) {
      if (this.#h !== 0 && !nt(this.#h))
        throw new TypeError(
          "maxSize must be a positive integer if specified"
        );
      if (!nt(this.maxEntrySize))
        throw new TypeError(
          "maxEntrySize must be a positive integer if specified"
        );
      this.#H();
    }
    if (this.allowStale = !!c, this.noDeleteOnStaleGet = !!O, this.updateAgeOnGet = !!o, this.updateAgeOnHas = !!a, this.ttlResolution = nt(s) || s === 0 ? s : 1, this.ttlAutopurge = !!i, this.ttl = r || 0, this.ttl) {
      if (!nt(this.ttl))
        throw new TypeError("ttl must be a positive integer if specified");
      this.#U();
    }
    if (this.#a === 0 && this.ttl === 0 && this.#h === 0)
      throw new TypeError("At least one of max, maxSize, or ttl is required");
    if (!this.ttlAutopurge && !this.#a && !this.#h) {
      const lt = "LRU_CACHE_UNBOUNDED";
      Fa(lt) && (Kr.add(lt), Qr("TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.", "UnboundedCacheWarning", lt, es));
    }
  }
  /**
   * Return the number of ms left in the item's TTL. If item is not in cache,
   * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
   */
  getRemainingTTL(t) {
    return this.#r.has(t) ? 1 / 0 : 0;
  }
  #U() {
    const t = new Xt(this.#a), n = new Xt(this.#a);
    this.#d = t, this.#x = n;
    const r = this.ttlAutopurge ? new Array(this.#a) : void 0;
    this.#p = r, this.#z = (a, c, u = this.#w.now()) => {
      n[a] = c !== 0 ? u : 0, t[a] = c, s(a, c);
    }, this.#F = (a) => {
      n[a] = t[a] !== 0 ? this.#w.now() : 0, s(a, t[a]);
    };
    const s = this.ttlAutopurge ? (a, c) => {
      if (r?.[a] && (clearTimeout(r[a]), r[a] = void 0), c && c !== 0 && r) {
        const u = setTimeout(() => {
          this.#m(a) && this.#v(this.#n[a], "expire");
        }, c + 1);
        u.unref && u.unref(), r[a] = u;
      }
    } : () => {
    };
    this.#R = (a, c) => {
      if (t[c]) {
        const u = t[c], l = n[c];
        if (!u || !l)
          return;
        a.ttl = u, a.start = l, a.now = i || o();
        const h = a.now - l;
        a.remainingTTL = u - h;
      }
    };
    let i = 0;
    const o = () => {
      const a = this.#w.now();
      if (this.ttlResolution > 0) {
        i = a;
        const c = setTimeout(() => i = 0, this.ttlResolution);
        c.unref && c.unref();
      }
      return a;
    };
    this.getRemainingTTL = (a) => {
      const c = this.#r.get(a);
      if (c === void 0)
        return 0;
      const u = t[c], l = n[c];
      if (!u || !l)
        return 1 / 0;
      const h = (i || o()) - l;
      return u - h;
    }, this.#m = (a) => {
      const c = n[a], u = t[a];
      return !!u && !!c && (i || o()) - c > u;
    };
  }
  // conditionally set private methods related to TTL
  #F = () => {
  };
  #R = () => {
  };
  #z = () => {
  };
  #m = () => !1;
  #H() {
    const t = new Xt(this.#a);
    this.#b = 0, this.#A = t, this.#k = (n) => {
      this.#b -= t[n], t[n] = 0;
    }, this.#j = (n, r, s, i) => {
      if (this.#e(r))
        return 0;
      if (!nt(s))
        if (i) {
          if (typeof i != "function")
            throw new TypeError("sizeCalculation must be a function");
          if (s = i(r, n), !nt(s))
            throw new TypeError(
              "sizeCalculation return invalid (expect positive integer)"
            );
        } else
          throw new TypeError(
            "invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set."
          );
      return s;
    }, this.#I = (n, r, s) => {
      if (t[n] = r, this.#h) {
        const i = this.#h - t[n];
        for (; this.#b > i; )
          this.#$(!0);
      }
      this.#b += t[n], s && (s.entrySize = r, s.totalCalculatedSize = this.#b);
    };
  }
  #k = (t) => {
  };
  #I = (t, n, r) => {
  };
  #j = (t, n, r, s) => {
    if (r || s)
      throw new TypeError(
        "cannot set size without setting maxSize or maxEntrySize on cache"
      );
    return 0;
  };
  *#O({ allowStale: t = this.allowStale } = {}) {
    if (this.#s)
      for (let n = this.#i; !(!this.#B(n) || ((t || !this.#m(n)) && (yield n), n === this.#c)); )
        n = this.#f[n];
  }
  *#T({ allowStale: t = this.allowStale } = {}) {
    if (this.#s)
      for (let n = this.#c; !(!this.#B(n) || ((t || !this.#m(n)) && (yield n), n === this.#i)); )
        n = this.#u[n];
  }
  #B(t) {
    return t !== void 0 && this.#r.get(this.#n[t]) === t;
  }
  /**
   * Return a generator yielding `[key, value]` pairs,
   * in order from most recently used to least recently used.
   */
  *entries() {
    for (const t of this.#O())
      this.#t[t] !== void 0 && this.#n[t] !== void 0 && !this.#e(this.#t[t]) && (yield [this.#n[t], this.#t[t]]);
  }
  /**
   * Inverse order version of {@link LRUCache.entries}
   *
   * Return a generator yielding `[key, value]` pairs,
   * in order from least recently used to most recently used.
   */
  *rentries() {
    for (const t of this.#T())
      this.#t[t] !== void 0 && this.#n[t] !== void 0 && !this.#e(this.#t[t]) && (yield [this.#n[t], this.#t[t]]);
  }
  /**
   * Return a generator yielding the keys in the cache,
   * in order from most recently used to least recently used.
   */
  *keys() {
    for (const t of this.#O()) {
      const n = this.#n[t];
      n !== void 0 && !this.#e(this.#t[t]) && (yield n);
    }
  }
  /**
   * Inverse order version of {@link LRUCache.keys}
   *
   * Return a generator yielding the keys in the cache,
   * in order from least recently used to most recently used.
   */
  *rkeys() {
    for (const t of this.#T()) {
      const n = this.#n[t];
      n !== void 0 && !this.#e(this.#t[t]) && (yield n);
    }
  }
  /**
   * Return a generator yielding the values in the cache,
   * in order from most recently used to least recently used.
   */
  *values() {
    for (const t of this.#O())
      this.#t[t] !== void 0 && !this.#e(this.#t[t]) && (yield this.#t[t]);
  }
  /**
   * Inverse order version of {@link LRUCache.values}
   *
   * Return a generator yielding the values in the cache,
   * in order from least recently used to most recently used.
   */
  *rvalues() {
    for (const t of this.#T())
      this.#t[t] !== void 0 && !this.#e(this.#t[t]) && (yield this.#t[t]);
  }
  /**
   * Iterating over the cache itself yields the same results as
   * {@link LRUCache.entries}
   */
  [Symbol.iterator]() {
    return this.entries();
  }
  /**
   * A String value that is used in the creation of the default string
   * description of an object. Called by the built-in method
   * `Object.prototype.toString`.
   */
  [Symbol.toStringTag] = "LRUCache";
  /**
   * Find a value for which the supplied fn method returns a truthy value,
   * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
   */
  find(t, n = {}) {
    for (const r of this.#O()) {
      const s = this.#t[r], i = this.#e(s) ? s.__staleWhileFetching : s;
      if (i !== void 0 && t(i, this.#n[r], this))
        return this.get(this.#n[r], n);
    }
  }
  /**
   * Call the supplied function on each item in the cache, in order from most
   * recently used to least recently used.
   *
   * `fn` is called as `fn(value, key, cache)`.
   *
   * If `thisp` is provided, function will be called in the `this`-context of
   * the provided object, or the cache if no `thisp` object is provided.
   *
   * Does not update age or recenty of use, or iterate over stale values.
   */
  forEach(t, n = this) {
    for (const r of this.#O()) {
      const s = this.#t[r], i = this.#e(s) ? s.__staleWhileFetching : s;
      i !== void 0 && t.call(n, i, this.#n[r], this);
    }
  }
  /**
   * The same as {@link LRUCache.forEach} but items are iterated over in
   * reverse order.  (ie, less recently used items are iterated over first.)
   */
  rforEach(t, n = this) {
    for (const r of this.#T()) {
      const s = this.#t[r], i = this.#e(s) ? s.__staleWhileFetching : s;
      i !== void 0 && t.call(n, i, this.#n[r], this);
    }
  }
  /**
   * Delete any stale entries. Returns true if anything was removed,
   * false otherwise.
   */
  purgeStale() {
    let t = !1;
    for (const n of this.#T({ allowStale: !0 }))
      this.#m(n) && (this.#v(this.#n[n], "expire"), t = !0);
    return t;
  }
  /**
   * Get the extended info about a given entry, to get its value, size, and
   * TTL info simultaneously. Returns `undefined` if the key is not present.
   *
   * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
   * serialization, the `start` value is always the current timestamp, and the
   * `ttl` is a calculated remaining time to live (negative if expired).
   *
   * Always returns stale values, if their info is found in the cache, so be
   * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
   * if relevant.
   */
  info(t) {
    const n = this.#r.get(t);
    if (n === void 0)
      return;
    const r = this.#t[n], s = this.#e(r) ? r.__staleWhileFetching : r;
    if (s === void 0)
      return;
    const i = { value: s };
    if (this.#d && this.#x) {
      const o = this.#d[n], a = this.#x[n];
      if (o && a) {
        const c = o - (this.#w.now() - a);
        i.ttl = c, i.start = Date.now();
      }
    }
    return this.#A && (i.size = this.#A[n]), i;
  }
  /**
   * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
   * passed to {@link LRUCache#load}.
   *
   * The `start` fields are calculated relative to a portable `Date.now()`
   * timestamp, even if `performance.now()` is available.
   *
   * Stale entries are always included in the `dump`, even if
   * {@link LRUCache.OptionsBase.allowStale} is false.
   *
   * Note: this returns an actual array, not a generator, so it can be more
   * easily passed around.
   */
  dump() {
    const t = [];
    for (const n of this.#O({ allowStale: !0 })) {
      const r = this.#n[n], s = this.#t[n], i = this.#e(s) ? s.__staleWhileFetching : s;
      if (i === void 0 || r === void 0)
        continue;
      const o = { value: i };
      if (this.#d && this.#x) {
        o.ttl = this.#d[n];
        const a = this.#w.now() - this.#x[n];
        o.start = Math.floor(Date.now() - a);
      }
      this.#A && (o.size = this.#A[n]), t.unshift([r, o]);
    }
    return t;
  }
  /**
   * Reset the cache and load in the items in entries in the order listed.
   *
   * The shape of the resulting cache may be different if the same options are
   * not used in both caches.
   *
   * The `start` fields are assumed to be calculated relative to a portable
   * `Date.now()` timestamp, even if `performance.now()` is available.
   */
  load(t) {
    this.clear();
    for (const [n, r] of t) {
      if (r.start) {
        const s = Date.now() - r.start;
        r.start = this.#w.now() - s;
      }
      this.set(n, r.value, r);
    }
  }
  /**
   * Add a value to the cache.
   *
   * Note: if `undefined` is specified as a value, this is an alias for
   * {@link LRUCache#delete}
   *
   * Fields on the {@link LRUCache.SetOptions} options param will override
   * their corresponding values in the constructor options for the scope
   * of this single `set()` operation.
   *
   * If `start` is provided, then that will set the effective start
   * time for the TTL calculation. Note that this must be a previous
   * value of `performance.now()` if supported, or a previous value of
   * `Date.now()` if not.
   *
   * Options object may also include `size`, which will prevent
   * calling the `sizeCalculation` function and just use the specified
   * number if it is a positive integer, and `noDisposeOnSet` which
   * will prevent calling a `dispose` function in the case of
   * overwrites.
   *
   * If the `size` (or return value of `sizeCalculation`) for a given
   * entry is greater than `maxEntrySize`, then the item will not be
   * added to the cache.
   *
   * Will update the recency of the entry.
   *
   * If the value is `undefined`, then this is an alias for
   * `cache.delete(key)`. `undefined` is never stored in the cache.
   */
  set(t, n, r = {}) {
    if (n === void 0)
      return this.delete(t), this;
    const {
      ttl: s = this.ttl,
      start: i,
      noDisposeOnSet: o = this.noDisposeOnSet,
      sizeCalculation: a = this.sizeCalculation,
      status: c
    } = r;
    let { noUpdateTTL: u = this.noUpdateTTL } = r;
    const l = this.#j(t, n, r.size || 0, a);
    if (this.maxEntrySize && l > this.maxEntrySize)
      return c && (c.set = "miss", c.maxEntrySizeExceeded = !0), this.#v(t, "set"), this;
    let h = this.#s === 0 ? void 0 : this.#r.get(t);
    if (h === void 0)
      h = this.#s === 0 ? this.#i : this.#S.length !== 0 ? this.#S.pop() : this.#s === this.#a ? this.#$(!1) : this.#s, this.#n[h] = t, this.#t[h] = n, this.#r.set(t, h), this.#u[this.#i] = h, this.#f[h] = this.#i, this.#i = h, this.#s++, this.#I(h, l, c), c && (c.set = "add"), u = !1, this.#L && this.#C?.(n, t, "add");
    else {
      this.#P(h);
      const p = this.#t[h];
      if (n !== p) {
        if (this.#E && this.#e(p)) {
          p.__abortController.abort(new Error("replaced"));
          const { __staleWhileFetching: d } = p;
          d !== void 0 && !o && (this.#_ && this.#g?.(d, t, "set"), this.#l && this.#o?.push([d, t, "set"]));
        } else
          o || (this.#_ && this.#g?.(p, t, "set"), this.#l && this.#o?.push([p, t, "set"]));
        if (this.#k(h), this.#I(h, l, c), this.#t[h] = n, c) {
          c.set = "replace";
          const d = p && this.#e(p) ? p.__staleWhileFetching : p;
          d !== void 0 && (c.oldValue = d);
        }
      } else
        c && (c.set = "update");
      this.#L && this.onInsert?.(n, t, n === p ? "update" : "replace");
    }
    if (s !== 0 && !this.#d && this.#U(), this.#d && (u || this.#z(h, s, i), c && this.#R(c, h)), !o && this.#l && this.#o) {
      const p = this.#o;
      let d;
      for (; d = p?.shift(); )
        this.#y?.(...d);
    }
    return this;
  }
  /**
   * Evict the least recently used item, returning its value or
   * `undefined` if cache is empty.
   */
  pop() {
    try {
      for (; this.#s; ) {
        const t = this.#t[this.#c];
        if (this.#$(!0), this.#e(t)) {
          if (t.__staleWhileFetching)
            return t.__staleWhileFetching;
        } else if (t !== void 0)
          return t;
      }
    } finally {
      if (this.#l && this.#o) {
        const t = this.#o;
        let n;
        for (; n = t?.shift(); )
          this.#y?.(...n);
      }
    }
  }
  #$(t) {
    const n = this.#c, r = this.#n[n], s = this.#t[n];
    return this.#E && this.#e(s) ? s.__abortController.abort(new Error("evicted")) : (this.#_ || this.#l) && (this.#_ && this.#g?.(s, r, "evict"), this.#l && this.#o?.push([s, r, "evict"])), this.#k(n), this.#p?.[n] && (clearTimeout(this.#p[n]), this.#p[n] = void 0), t && (this.#n[n] = void 0, this.#t[n] = void 0, this.#S.push(n)), this.#s === 1 ? (this.#c = this.#i = 0, this.#S.length = 0) : this.#c = this.#u[n], this.#r.delete(r), this.#s--, n;
  }
  /**
   * Check if a key is in the cache, without updating the recency of use.
   * Will return false if the item is stale, even though it is technically
   * in the cache.
   *
   * Check if a key is in the cache, without updating the recency of
   * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
   * to `true` in either the options or the constructor.
   *
   * Will return `false` if the item is stale, even though it is technically in
   * the cache. The difference can be determined (if it matters) by using a
   * `status` argument, and inspecting the `has` field.
   *
   * Will not update item age unless
   * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
   */
  has(t, n = {}) {
    const { updateAgeOnHas: r = this.updateAgeOnHas, status: s } = n, i = this.#r.get(t);
    if (i !== void 0) {
      const o = this.#t[i];
      if (this.#e(o) && o.__staleWhileFetching === void 0)
        return !1;
      if (this.#m(i))
        s && (s.has = "stale", this.#R(s, i));
      else
        return r && this.#F(i), s && (s.has = "hit", this.#R(s, i)), !0;
    } else
      s && (s.has = "miss");
    return !1;
  }
  /**
   * Like {@link LRUCache#get} but doesn't update recency or delete stale
   * items.
   *
   * Returns `undefined` if the item is stale, unless
   * {@link LRUCache.OptionsBase.allowStale} is set.
   */
  peek(t, n = {}) {
    const { allowStale: r = this.allowStale } = n, s = this.#r.get(t);
    if (s === void 0 || !r && this.#m(s))
      return;
    const i = this.#t[s];
    return this.#e(i) ? i.__staleWhileFetching : i;
  }
  #N(t, n, r, s) {
    const i = n === void 0 ? void 0 : this.#t[n];
    if (this.#e(i))
      return i;
    const o = new ue(), { signal: a } = r;
    a?.addEventListener("abort", () => o.abort(a.reason), {
      signal: o.signal
    });
    const c = {
      signal: o.signal,
      options: r,
      context: s
    }, u = (m, y = !1) => {
      const { aborted: w } = o.signal, S = r.ignoreFetchAbort && m !== void 0, x = r.ignoreFetchAbort || !!(r.allowStaleOnFetchAbort && m !== void 0);
      if (r.status && (w && !y ? (r.status.fetchAborted = !0, r.status.fetchError = o.signal.reason, S && (r.status.fetchAbortIgnored = !0)) : r.status.fetchResolved = !0), w && !S && !y)
        return h(o.signal.reason, x);
      const O = d, A = this.#t[n];
      return (A === d || S && y && A === void 0) && (m === void 0 ? O.__staleWhileFetching !== void 0 ? this.#t[n] = O.__staleWhileFetching : this.#v(t, "fetch") : (r.status && (r.status.fetchUpdated = !0), this.set(t, m, c.options))), m;
    }, l = (m) => (r.status && (r.status.fetchRejected = !0, r.status.fetchError = m), h(m, !1)), h = (m, y) => {
      const { aborted: w } = o.signal, S = w && r.allowStaleOnFetchAbort, x = S || r.allowStaleOnFetchRejection, O = x || r.noDeleteOnFetchRejection, A = d;
      if (this.#t[n] === d && (!O || !y && A.__staleWhileFetching === void 0 ? this.#v(t, "fetch") : S || (this.#t[n] = A.__staleWhileFetching)), x)
        return r.status && A.__staleWhileFetching !== void 0 && (r.status.returnedStale = !0), A.__staleWhileFetching;
      if (A.__returned === A)
        throw m;
    }, p = (m, y) => {
      const w = this.#D?.(t, i, c);
      w && w instanceof Promise && w.then((S) => m(S === void 0 ? void 0 : S), y), o.signal.addEventListener("abort", () => {
        (!r.ignoreFetchAbort || r.allowStaleOnFetchAbort) && (m(void 0), r.allowStaleOnFetchAbort && (m = (S) => u(S, !0)));
      });
    };
    r.status && (r.status.fetchDispatched = !0);
    const d = new Promise(p).then(u, l), g = Object.assign(d, {
      __abortController: o,
      __staleWhileFetching: i,
      __returned: void 0
    });
    return n === void 0 ? (this.set(t, g, { ...c.options, status: void 0 }), n = this.#r.get(t)) : this.#t[n] = g, g;
  }
  #e(t) {
    if (!this.#E)
      return !1;
    const n = t;
    return !!n && n instanceof Promise && Object.prototype.hasOwnProperty.call(n, "__staleWhileFetching") && n.__abortController instanceof ue;
  }
  async fetch(t, n = {}) {
    const {
      // get options
      allowStale: r = this.allowStale,
      updateAgeOnGet: s = this.updateAgeOnGet,
      noDeleteOnStaleGet: i = this.noDeleteOnStaleGet,
      // set options
      ttl: o = this.ttl,
      noDisposeOnSet: a = this.noDisposeOnSet,
      size: c = 0,
      sizeCalculation: u = this.sizeCalculation,
      noUpdateTTL: l = this.noUpdateTTL,
      // fetch exclusive options
      noDeleteOnFetchRejection: h = this.noDeleteOnFetchRejection,
      allowStaleOnFetchRejection: p = this.allowStaleOnFetchRejection,
      ignoreFetchAbort: d = this.ignoreFetchAbort,
      allowStaleOnFetchAbort: g = this.allowStaleOnFetchAbort,
      context: m,
      forceRefresh: y = !1,
      status: w,
      signal: S
    } = n;
    if (!this.#E)
      return w && (w.fetch = "get"), this.get(t, {
        allowStale: r,
        updateAgeOnGet: s,
        noDeleteOnStaleGet: i,
        status: w
      });
    const x = {
      allowStale: r,
      updateAgeOnGet: s,
      noDeleteOnStaleGet: i,
      ttl: o,
      noDisposeOnSet: a,
      size: c,
      sizeCalculation: u,
      noUpdateTTL: l,
      noDeleteOnFetchRejection: h,
      allowStaleOnFetchRejection: p,
      allowStaleOnFetchAbort: g,
      ignoreFetchAbort: d,
      status: w,
      signal: S
    };
    let O = this.#r.get(t);
    if (O === void 0) {
      w && (w.fetch = "miss");
      const A = this.#N(t, O, x, m);
      return A.__returned = A;
    } else {
      const A = this.#t[O];
      if (this.#e(A)) {
        const lt = r && A.__staleWhileFetching !== void 0;
        return w && (w.fetch = "inflight", lt && (w.returnedStale = !0)), lt ? A.__staleWhileFetching : A.__returned = A;
      }
      const C = this.#m(O);
      if (!y && !C)
        return w && (w.fetch = "hit"), this.#P(O), s && this.#F(O), w && this.#R(w, O), A;
      const _ = this.#N(t, O, x, m), X = _.__staleWhileFetching !== void 0 && r;
      return w && (w.fetch = C ? "stale" : "refresh", X && C && (w.returnedStale = !0)), X ? _.__staleWhileFetching : _.__returned = _;
    }
  }
  async forceFetch(t, n = {}) {
    const r = await this.fetch(t, n);
    if (r === void 0)
      throw new Error("fetch() returned undefined");
    return r;
  }
  memo(t, n = {}) {
    const r = this.#M;
    if (!r)
      throw new Error("no memoMethod provided to constructor");
    const { context: s, forceRefresh: i, ...o } = n, a = this.get(t, o);
    if (!i && a !== void 0)
      return a;
    const c = r(t, a, {
      options: o,
      context: s
    });
    return this.set(t, c, o), c;
  }
  /**
   * Return a value from the cache. Will update the recency of the cache
   * entry found.
   *
   * If the key is not found, get() will return `undefined`.
   */
  get(t, n = {}) {
    const {
      allowStale: r = this.allowStale,
      updateAgeOnGet: s = this.updateAgeOnGet,
      noDeleteOnStaleGet: i = this.noDeleteOnStaleGet,
      status: o
    } = n, a = this.#r.get(t);
    if (a !== void 0) {
      const c = this.#t[a], u = this.#e(c);
      return o && this.#R(o, a), this.#m(a) ? (o && (o.get = "stale"), u ? (o && r && c.__staleWhileFetching !== void 0 && (o.returnedStale = !0), r ? c.__staleWhileFetching : void 0) : (i || this.#v(t, "expire"), o && r && (o.returnedStale = !0), r ? c : void 0)) : (o && (o.get = "hit"), u ? c.__staleWhileFetching : (this.#P(a), s && this.#F(a), c));
    } else
      o && (o.get = "miss");
  }
  #q(t, n) {
    this.#f[n] = t, this.#u[t] = n;
  }
  #P(t) {
    t !== this.#i && (t === this.#c ? this.#c = this.#u[t] : this.#q(this.#f[t], this.#u[t]), this.#q(this.#i, t), this.#i = t);
  }
  /**
   * Deletes a key out of the cache.
   *
   * Returns true if the key was deleted, false otherwise.
   */
  delete(t) {
    return this.#v(t, "delete");
  }
  #v(t, n) {
    let r = !1;
    if (this.#s !== 0) {
      const s = this.#r.get(t);
      if (s !== void 0)
        if (this.#p?.[s] && (clearTimeout(this.#p?.[s]), this.#p[s] = void 0), r = !0, this.#s === 1)
          this.#W(n);
        else {
          this.#k(s);
          const i = this.#t[s];
          if (this.#e(i) ? i.__abortController.abort(new Error("deleted")) : (this.#_ || this.#l) && (this.#_ && this.#g?.(i, t, n), this.#l && this.#o?.push([i, t, n])), this.#r.delete(t), this.#n[s] = void 0, this.#t[s] = void 0, s === this.#i)
            this.#i = this.#f[s];
          else if (s === this.#c)
            this.#c = this.#u[s];
          else {
            const o = this.#f[s];
            this.#u[o] = this.#u[s];
            const a = this.#u[s];
            this.#f[a] = this.#f[s];
          }
          this.#s--, this.#S.push(s);
        }
    }
    if (this.#l && this.#o?.length) {
      const s = this.#o;
      let i;
      for (; i = s?.shift(); )
        this.#y?.(...i);
    }
    return r;
  }
  /**
   * Clear the cache entirely, throwing away all values.
   */
  clear() {
    return this.#W("delete");
  }
  #W(t) {
    for (const n of this.#T({ allowStale: !0 })) {
      const r = this.#t[n];
      if (this.#e(r))
        r.__abortController.abort(new Error("deleted"));
      else {
        const s = this.#n[n];
        this.#_ && this.#g?.(r, s, t), this.#l && this.#o?.push([r, s, t]);
      }
    }
    if (this.#r.clear(), this.#t.fill(void 0), this.#n.fill(void 0), this.#d && this.#x) {
      this.#d.fill(0), this.#x.fill(0);
      for (const n of this.#p ?? [])
        n !== void 0 && clearTimeout(n);
      this.#p?.fill(void 0);
    }
    if (this.#A && this.#A.fill(0), this.#c = 0, this.#i = 0, this.#S.length = 0, this.#b = 0, this.#s = 0, this.#l && this.#o) {
      const n = this.#o;
      let r;
      for (; r = n?.shift(); )
        this.#y?.(...r);
    }
  }
}
class ka {
  commands = [];
  pushCommand(t) {
    this.commands.push(t);
  }
  popCommand() {
    this.commands.pop();
  }
  executeCommands(...t) {
    this.commands.forEach((n) => this.executeCommand(n, ...t)), this.commands = [];
  }
  // 子类只需修改此方法
  executeCommand(t, ...n) {
    t.execute(...n);
  }
}
class Pa {
  data;
  constructor(t) {
    this.data = t;
  }
  get() {
    return this.data;
  }
}
class jh {
  state;
  saveState() {
    if (this.state)
      return new Pa(this.state);
  }
  restoreState(t) {
    this.state = t.get();
  }
}
class Bh extends ka {
  originator;
  mementos = [];
  constructor(t) {
    super(), this.originator = t;
  }
  pushMemento(t) {
    this.mementos.push(t);
  }
  popMemento() {
    return this.mementos.pop();
  }
  executeCommand(t) {
    t.execute(this);
  }
}
class qh {
  execute(t) {
    const n = t.originator.saveState();
    n && t.pushMemento(n);
  }
}
class Wh {
  execute(t) {
    const n = t.popMemento();
    n && t.originator.restoreState(n);
  }
}
export {
  cs as AlgorithmEnum,
  Cl as AuthenticatableDecorator,
  Fl as AuthorizeDecorator,
  fe as BasicHeap,
  P2 as BigIntSupported,
  Dh as BinarySearch,
  Sc as BinarySearchTree,
  xt as BinaryTreeNode,
  Eh as BubbleSort,
  Ia as CSSAnimationNames,
  Ve as Cache,
  Ul as CacheDecorator,
  us as CipherEnum,
  ka as CommandInvoker,
  Bl as ConfigurableDecorator,
  rl as CreateValidator,
  $l as DebounceDecorator,
  Ao as Dep,
  Th as DeriveWorker,
  ah as DialogSchedule,
  Ih as DiffArray,
  W as DomMatrix,
  v as DomPoint,
  kc as EPSILON,
  Zt as EncodeEnum,
  $1 as Enum,
  ql as EnumerableDecorator,
  Ol as EventBus,
  Rh as FetchWithAxios,
  Ac as Graph,
  Jt as GraphEdge,
  We as GraphNode,
  vs as HASH_UNDEFINED,
  Dt as Hash,
  Kc as HashObject,
  Yc as HashTable,
  fn as HashTableOverflow,
  Ph as HeapSort,
  Sl as HttpError,
  Fh as InsertSort,
  Ns as LARGE_ARRAY_SIZE,
  es as LRUCache,
  Nh as LRUCacheUseLinkedList,
  $h as LRUCacheUseMap,
  gs as LinkedList,
  _t as ListCache,
  He as ListNode,
  Dl as LogExecuteResultDecorator,
  Ml as LogExecuteTimeDecorator,
  Cc as MAX_SAFE_INTEGER,
  ws as MAX_SIGNED_INT,
  J as MIMEEnum,
  Fc as MIN_SAFE_INTEGER,
  jt as Map,
  Ct as MapCache,
  _c as MaxHeap,
  Pl as MaxLengthDecorator,
  Bh as MementoCaretaker,
  jh as MementoOriginator,
  zl as MemorizeDecorator,
  $n as MergeSort,
  In as MergeSort2,
  Oc as MinHeap,
  kl as MinLengthDecorator,
  Ge as ONE_DAY_TIMESTAMP,
  Lh as PrefixSumArray,
  xc as PriorityQueue,
  Ll as ProfileDecorator,
  oh as PromiseSchedule,
  Et as Queue,
  V as QueueOverflow,
  Mh as QuickSearch,
  Nn as QuickSort,
  Un as QuickSort2,
  Ea as QuickSort_partition,
  as as ReadInBrowserEnum,
  jl as ReadonlyDecorator,
  Nl as RetryDecorator,
  ht as SYMBOL_META,
  qh as SaveCommand,
  zo as Schedule,
  vr as ScheduleDependOnResult,
  Ch as SelectSort,
  z1 as SetCache,
  kh as ShellSort,
  El as SingletonDecorator,
  N1 as Stack,
  lh as StreamUsedMessageChannel,
  yh as Subject,
  D2 as SymbolSupported,
  zn as ThreeWayQuickSort,
  Il as ThrottleDecorator,
  Wh as UndoCommand,
  or as WeakMap,
  Ls as ZeroArray,
  $u as _instanceof,
  Ic as add,
  m1 as addArrayItem,
  Is as addMapEntry,
  $s as addSetEntry,
  Zl as all,
  Wo as appendURL,
  Ah as appendURLRecord,
  O1 as appendUniqueArray,
  Ws as apply,
  dh as applyMiddleware,
  mc as arrayBufferToDataView,
  gc as arrayBufferToTypedArray,
  c1 as arrayCount,
  o1 as arrayEach,
  a1 as arrayEvery,
  h1 as arrayMiddleValue,
  P1 as arrayNeedsUint32,
  Au as assoc,
  Mt as assocIndexOf,
  hr as atob,
  Mc as average,
  Ri as base64URLDecode,
  vi as base64URLEncode,
  Ro as bd09_to_gcj02,
  Rl as bd09_to_wgs84,
  S2 as bind,
  A2 as bindObjectThis,
  Ci as btoa,
  tr as cache,
  N2 as canUseBitmap,
  wi as canUseWorker,
  Ql as cancelablePromise,
  Qa as capitalize,
  eh as chainPromise,
  j1 as changeTimeZone,
  Ha as charAt,
  dt as clamp,
  d2 as classMixin,
  p1 as clearArray,
  T2 as clearObject,
  qe as cloneArrayBuffer,
  y2 as cloneAsPrototype,
  wc as cloneDataView,
  s1 as cloneFill2DArray,
  L1 as cloneMap,
  hs as cloneRegExp,
  I1 as cloneSet,
  Wu as cloneSymbol,
  bc as cloneTypedArray,
  pu as closeLog,
  fh as combineReducers,
  $2 as compareVersion,
  Xs as compose,
  yc as concateTypedArray,
  Fu as conditional,
  K1 as copyTime,
  ol as createCommonDateValidator,
  cl as createCommonDatetimeValidator,
  sl as createCommonEmailValidator,
  hl as createCommonEnumValidator,
  ll as createCommonLengthValidator,
  ul as createCommonNumberValidator,
  il as createCommonPhoneValidator,
  al as createCommonTimeValidator,
  Rc as createDroppingRingQueue,
  Qc as createEmptyArray,
  ys as createExpandingRingQueue,
  vc as createFixedRingQueue,
  Xc as createNextInt,
  Tc as createNoneRingQueue,
  Tl as createSignal,
  Ec as createSlidingRingQueue,
  jo as createStore,
  Hn as createSymbol,
  Tr as createTask,
  Gs as curry,
  gl as customDelay,
  Li as dateValidate,
  $i as datetimeValidate,
  au as dayOfYear,
  Vs as debounce,
  qc as decimalNumber,
  Y1 as decreaseTime,
  it as deepClone,
  cr as deepDiff,
  gi as deepEqual,
  No as deferred,
  nh as delayAsync,
  rh as delaySync,
  g1 as deleteArrayItem,
  Jc as denormalize,
  mn as diffDays,
  ml as discardOddDoubleEven,
  Di as emailValidate,
  Ni as enumValidate,
  mi as eq,
  gu as errorLog,
  Nc as euclideanModulo,
  mh as exceptionLoggerMiddleware,
  gh as executeTimeLoggerMiddleware,
  Os as extractAllNumbers,
  Hc as extractNumber,
  Rs as fill2DArray,
  r1 as fillArray,
  n1 as fillArrayIterate,
  _2 as filterObject,
  f1 as first,
  Ga as fixChineseCompanyName,
  Va as fixChineseTaxNo,
  Xa as fixEmail,
  Xn as fixedDotNumberString,
  Bc as fixedNumberString,
  b1 as flattenArray,
  Ds as flattenArray2,
  Ms as flattenArray3,
  S1 as flattenArray4,
  A1 as flattenArray5,
  Ps as flushArray,
  Sh as flushURLRecord,
  qo as flushURLSearch,
  Oh as formDataToSearch,
  Ft as format,
  nu as formatDate,
  iu as formatDateTime,
  fl as formatDistance,
  dl as formatMoney,
  Wc as formatNumber,
  eu as formatPreset,
  ru as formatTime,
  su as formatTime2,
  W1 as formatTimeOverflow,
  H1 as formatTimeOverflowChinese,
  pi as freeze,
  f2 as functionMixin,
  Wl as gb32100_2015,
  Mo as gbt11714,
  vo as gcj02_to_bd09,
  To as gcj02_to_wgs84,
  Za as generateUUID,
  Hl as generatorfromArray,
  Vl as generatortoArray,
  Cs as get2DArrayColumn,
  Es as get2DArrayRow,
  i1 as get2DArrayRowColumn,
  j2 as getArrayBufferFromByteArray,
  q2 as getArrayBufferFromHexString,
  B2 as getArrayBufferFromNumber,
  Ti as getArrayBufferFromString,
  Ai as getByteArrayFromArrayBuffer,
  _i as getByteArrayFromHexString,
  xi as getByteArrayFromNumber,
  Oi as getByteArrayFromString,
  fu as getCalendarPageItems,
  z2 as getCodePointArrayFromString,
  Ho as getCrossOriginWorkerURL,
  St as getDateDetail,
  ct as getDefinedRegExpPattern,
  Z as getDegree,
  F1 as getDifferenceArray,
  k1 as getDifferenceSet,
  K2 as getFileTypeFromArrayBuffer,
  js as getFirstTimestampOfMonth,
  cu as getFirstTimestampOfNextMonth,
  rs as getGlobal,
  V2 as getHexNumber,
  G2 as getHexString,
  R1 as getIntersectArray,
  C1 as getIntersectArrayUseMap,
  E1 as getIntersectSet,
  Us as getLastDayOfMonth,
  zs as getLastTimestampOfMonth,
  uu as getLastTimestampOfPrevMonth,
  Ye as getNative,
  R2 as getNestedValue,
  As as getNextPrime,
  It as getNthDay,
  hu as getNthMonth,
  lu as getNthMonthNotGood,
  u2 as getOwnPropertyDescriptors,
  Yu as getPrototype,
  ls as getRegExpFlags,
  Zs as getRetryDelay,
  Ut as getSecondsFromTimeOverlow,
  v2 as getSortedObjectString,
  Ei as getString,
  X2 as getStringFromArrayBuffer,
  Z2 as getStringFromArrayBuffer2,
  J2 as getStringFromBase64,
  $ as getTag,
  Nu as getType,
  pc as getTypedArrayType,
  Rr as getURL,
  Q2 as getUint64,
  tl as getUint64BigInt,
  U2 as getUint8ArrayFromString,
  M1 as getUintArray,
  qa as getUnicodeLengthES5,
  T1 as getUnionArray,
  v1 as getUnionSet,
  gn as groupLog,
  M2 as hasDocument,
  I2 as hasHistory,
  l2 as hasProperty,
  Ma as hasSymbol,
  L2 as hasWindow,
  yu as identity,
  ks as includes,
  J1 as increaseTime,
  w2 as inheritPrototype,
  e1 as initCloneArray,
  u1 as intersperse,
  lc as is32BitString,
  j as isArray,
  ps as isArrayBufferView,
  w1 as isArrayEqual,
  Xu as isArrayLike,
  y1 as isArrayNotEmpty,
  ju as isBoolean,
  yi as isBrowser,
  p2 as isCloneable,
  i2 as isDate,
  N as isDateValid,
  Ku as isDescriptor,
  Qu as isEmptyObject,
  bl as isErrorType,
  Dc as isEven,
  Q as isFunction,
  e2 as isGenerator,
  tu as isInDays,
  Q1 as isInTime,
  n2 as isIterable,
  fi as isIterator,
  M as isJustObject,
  hi as isKeyable,
  Ke as isLittleEndian,
  r2 as isMap,
  Gn as isNaN,
  zt as isNative,
  Vu as isNativeFunction,
  k2 as isNode,
  t1 as isNotEmptyArray,
  zu as isNull,
  Bu as isNumber,
  qu as isNumeric,
  ai as isOK,
  yt as isObject,
  U as isObjectLike,
  Zu as isPlainObject,
  bs as isPosInt,
  Ss as isPrime,
  Je as isPrimitive,
  t2 as isPromise,
  Ju as isPrototype,
  Pc as isReallyNaN,
  Bo as isSameOriginURL,
  F2 as isServer,
  s2 as isSet,
  o2 as isStrictComparable,
  ci as isString,
  Hu as isStringableFunction,
  ui as isSymbol,
  Ue as isSymbolString,
  Jn as isTimestampInMilliSeconds,
  q1 as isTimestampInSeconds,
  ms as isTypedArray,
  wh as isURL,
  Uu as isUndefined,
  ou as isWeekend,
  Su as kDone,
  bu as kFalse,
  wu as kTrue,
  Yn as konst,
  d1 as last,
  Gl as lastX,
  Pi as lengthValidate,
  _s as lerp,
  zc as lerpMap,
  Uc as lerps,
  E as log,
  fs as lowercaseFirst,
  Mu as map,
  dn as mapToArray,
  et as maxDotNumber,
  nl as maxLengthValidate,
  ki as maxValidate,
  Ze as memoize,
  Eu as memoizeCapped,
  Js as memorize,
  Bt as mergeObject,
  di as mergeObjectDeep,
  le as meta,
  uh as microTask,
  K as milliseconds,
  el as minLengthValidate,
  Fi as minValidate,
  Gu as nativeCreate,
  g2 as newConstructor,
  ch as nextTick,
  qs as noop,
  Zc as normalize,
  ut as notEmptyValidate,
  Yt as now,
  bi as numberToRadixString,
  c2 as objectEntries,
  kt as objectKeys,
  je as objectSignature,
  a2 as objectValues,
  Ru as once,
  du as openLog,
  hh as operationParser,
  Sr as out_of_china,
  Ks as overArg,
  Iu as overRest,
  W2 as pack,
  ic as padString,
  is as parse,
  de as parseDate,
  Y as parseNumber,
  La as parseObjectSignature,
  Lc as parseRelativeNumber,
  V1 as parseTime,
  X1 as parseTimeFromArray,
  G1 as parseTimeFromDate,
  Z1 as parseTimeFromDateDiff,
  yl as pausable$,
  Mi as phoneValidate,
  O2 as pick,
  xu as pipe,
  _u as pipeCallback,
  vh as polar,
  l1 as popToTopInArray,
  yn as profileLog,
  wl as prop$,
  Si as radixStringToNumber,
  Vc as randomDirection,
  Ts as randomFloat,
  Gc as randomInt,
  Ja as randomLetter,
  Vn as randomString,
  Ka as raw,
  _o as reactive,
  ne as reactiveVue2,
  br as reactiveVue3,
  pl as readStream,
  B1 as readableTimestamp,
  Er as recordToSearch,
  Lu as reduce,
  _l as ref,
  za as regExec,
  Be as regMatch,
  Ua as regMatchAll,
  $a as regSearchIndex,
  Na as regSplit,
  Rt as regTest,
  oc as repeatString,
  ve as replaceSymbol,
  Re as restoreSymbol,
  Qn as retry,
  Xl as returnValue,
  vu as reverseArgs,
  uc as reverseString,
  T as root,
  $c as round,
  ih as runAsyncChain,
  sh as runAsyncWithTimeout,
  Jl as runGenerator,
  tt as runValidates,
  xh as searchToRecord,
  _h as searchToRecord2,
  mu as setLogUploadFn,
  E2 as setNestedValue,
  b2 as setProtoOf,
  pn as setToArray,
  m2 as shallowClone,
  x1 as shuffleArray,
  h2 as shuffleObject,
  Wa as sliceByCodePoints,
  Go as splitTransformString,
  ph as stateLoggerMiddleware,
  jc as stepMap,
  dc as stringByteSize,
  rt as stringLength,
  ja as stringLength2,
  Ba as stringLength3,
  Ya as stringReplace,
  ss as stringify,
  x2 as subtractObject,
  Fs as swapArrayValue,
  Tu as tco,
  Hs as throttle,
  Kl as thunkToPromise,
  Yl as thunkify,
  Kt as timeLog,
  Ii as timeValidate,
  th as timeoutLimitPromise,
  he as toArrayBuffer,
  Y2 as toBlob,
  ec as toCamel,
  H as toDegree,
  ar as toFunctionString,
  tc as toKebab,
  I as toObjectString,
  ds as toPascal,
  Vo as toRadian,
  xl as toValue,
  Pu as trace,
  Ou as trampoline,
  Du as transformUnaryArg,
  nc as trim,
  bh as trimHash,
  sc as trimScopedCSS,
  rc as trimSpecial,
  ac as truncateString,
  cc as truncateStringInMiddle,
  ku as tryCatch,
  Cu as tryEach,
  hn as tryToSymbol,
  _1 as uniqueArray,
  H2 as unpack,
  C2 as useTimestampValue,
  hc as utf16to8,
  fc as utf8to16,
  Bs as warnLog,
  Al as watchEffect,
  vl as wgs84_to_bd09,
  Oo as wgs84_to_gcj02,
  xs as withinErrorMarginNumber
};
//# sourceMappingURL=zyzgroup_core_common.js.map
